// EN/PT translations for AgenteLead Pro
export const TRANSLATIONS = {
  en: {
    // Sidebar / global
    "lang.toggle": "PT",
    "sidebar.subtitle": "FIND. ENGAGE. GROW.",
    "sidebar.footer": "v1.0 — Prospecting Module",

    // ── Iter313 · Vehicle Security Map (VS Map) ─────────────────────
    "vsm.tier": "Tier",
    "vsm.flock_alpr": "Flock/ALPR",
    "vsm.flock": "Flock",
    "vsm.tier.all": "All",
    "vsm.tier.critical": "Critical",
    "vsm.tier.very_high": "V. High",
    "vsm.tier.high": "High",
    "vsm.tier.medium": "Medium",
    "vsm.tier.low": "Low",
    "vsm.flock.all": "All",
    "vsm.flock.only": "Flock only",
    "vsm.flock.exclude": "Exclude Flock",
    "vsm.leads_count": "{count}/{total} leads",
    "vsm.address_placeholder": "Address, city or neighborhood (e.g. Dr. Phillips, Orlando)",
    "vsm.radius": "Radius",
    "vsm.radius.off": "Off",
    "vsm.radius.clear": "Clear radius",
    "vsm.route.optimizer": "Route builder",
    "vsm.route.optimize": "Build {n} stops",
    "vsm.route.navigate": "Open in Google Maps",
    "vsm.route.hint": "Order optimised by proximity (nearest-neighbor)",
    "vsm.osm_loading": "Loading real neighborhood boundaries (OpenStreetMap)…",
    "vsm.geocoding": "Geocoding…",
    "vsm.privacy.city": "City Mode",
    "vsm.privacy.exact": "Exact Address",
    "vsm.privacy.city_title": "City mode (privacy-preserving)",
    "vsm.privacy.exact_title": "Exact address mode (internal use)",
    "vsm.privacy.master_required": "Exact address requires MASTER role",
    "vsm.legend": "Legend",
    "vsm.footer.city_mode": "City Mode: pins aggregated by neighborhood (address not exposed)",
    "vsm.info.est_contract": "Est. contract:",
    "vsm.info.details": "View details",
    "vsm.info.street_view": "Street View",
    "vsm.info.street_view_open": "Open Street View",
    "vsm.empty": "No leads match the active filters.",
    "vsm.missing_key": "Google Maps API key missing. Set REACT_APP_GOOGLE_MAPS_API_KEY.",

    // ── Iter314 · Vehicle Security page body ────────────────────────
    "vs.disclaimer_loading": "Loading regulatory notice…",
    "vs.google_ads": "Google Ads",
    "vs.google_ads_sub": "Keywords + Negatives",
    "vs.google_ads_title": "Google Ads keyword + negative packs per segment",
    "vs.reg_watch": "Regulatory Watch",
    "vs.reg_items_tracked": "{n} items tracked",
    "vs.reg_open": "Open",
    "vs.kpi.total_leads": "Total Leads",
    "vs.kpi.critical": "Critical (90+)",
    "vs.kpi.high_opportunity": "High Opportunity (80+)",
    "vs.kpi.existing_cctv": "Existing CCTV",
    "vs.kpi.existing_alpr": "Existing ALPR",
    "vs.kpi.guard_house": "Guard House",
    "vs.kpi.security_officers": "Security Officers",
    "vs.kpi.multi_entrance": "Multi-Entrance",
    "vs.kpi.large_parking": "Large Parking Lot",
    "vs.kpi.theft_risk": "Theft Risk",
    "vs.kpi.replacement_alpr": "Replacement ALPR",
    "vs.kpi.cross_sell": "Cross-Sell",
    "vs.kpi.active": "Active",
    "vs.kpi.clear_filter": "Clear filter",
    "vs.kpi.filter_by": "Filter leads by: {label}",
    "vs.kpi.no_matches": "No matching leads",
    "vs.pipeline_label": "Estimated Technology Pipeline",
    "vs.pipeline_footer": "+ recurring monitoring / patrol / officer services",
    "vs.header.title": "Smith SecureVehicle™",
    "vs.header.subtitle": "Private Vehicle Intelligence & Property Security · Know what's entering your property.",

    // ── Iter314 · Smith Outreach main surface ───────────────────────
    "so.header.title": "Smith · Outreach AI",
    "so.header.subtitle": "{n} contacts · Claire drafts · Resend delivers",
    "so.btn.replies": "Replies",
    "so.btn.sender": "Sender",
    "so.btn.sender_title": "Configure sender identity (Marcelo Borges @ smithprotective.com)",
    "so.btn.nudge": "Nudge SMS",
    "so.btn.nudge_title": "Auto-Nudge SMS 48h — send an SMS automatically when the email isn't opened in 48h",
    "so.btn.dedupe": "Dedupe",
    "so.btn.dedupe_title": "Clean up duplicate emails/prospects",
    "so.btn.refresh": "Refresh",
    "so.btn.imports": "Imports",
    "so.btn.imports_title": "Import Hub — templates and media",
    "so.tab.compose": "Compose",
    "so.tab.drafts": "Drafts",
    "so.tab.contacts": "Contacts",
    "so.tab.templates": "Templates",
    "so.tab.sent": "Sent",
    "so.tab.retry": "Retry Queue",
    "so.tab.analytics": "Analytics",
    "so.bucket.available": "With email",
    "so.bucket.missing": "No email",
    "so.bucket.unresolvable": "Repository",
    "so.search_placeholder": "Search name, email or company",
    "so.filter.advanced_title": "Advanced filters",
    "so.filter.source_any": "Any source",
    "so.filter.tier_any": "All tiers",
    "so.filter.tier_hot": "🔥 Hot",
    "so.filter.tier_high": "🟢 High",
    "so.filter.tier_qualified": "🟡 Qualified",
    "so.filter.tier_nurture": "🔵 Nurture",
    "so.filter.hide_no_email": "Hide leads without email",
    "so.filter.hide_no_email_hint": "(leads without email are never triggered)",
    "so.filter.only_failed": "Only failed / blocked",
    "so.contacts.empty": "No contacts match those filters.",
    "so.contacts.loading_discovery": "Claire is searching emails via the Apollo → Hunter → Apify → Heuristic cascade…",
    "so.bulk.select_visible": "Select visible",
    "so.bulk.clear": "Clear",
    "so.bulk.action": "Bulk",
    "so.footer.count": "{shown} of {total} contacts",
    "so.empty.title": "Pick a contact to get started",
    "so.empty.body": "Click any contact on the left — Claire will write a personalised cold letter for Smith Protective based on the lead's title, company and segment.",
    "so.recipient.to": "To",
    "so.recipient.no_name": "(no name)",
    "so.recipient.find_email": "Find email with AI",
    "so.recipient.finding": "Searching…",
    "so.recipient.find_email_title": "Run Apollo → Hunter → Apify → Website scrape to discover this decision-maker's email",
    "so.tone.prefix": "Tone",
    "so.tone.consultative": "Consultative",
    "so.tone.urgent": "Urgent",
    "so.tone.empathetic": "Empathetic",
    "so.tone.roi": "ROI (numbers)",
    "so.lang.current": "Current language",
    "so.lang.translate_to": "Translate to {label}",
    "so.regenerate": "Regenerate",
    "so.regenerating": "Generating…",
    "so.templates.title": "Templates",
    "so.templates.empty": "No templates yet. After you compose a letter you like, click Save as template.",
    "so.templates.delete": "Delete",
    "so.save_template": "Save as template",
    "so.save_template_title": "Save the current draft as a reusable template",
    "so.subject.label": "Subject",
    "so.subject.placeholder": "Email subject",
    "so.subject.counter": "{n}/78 chars",
    "so.tool.bold": "Bold (Ctrl+B)",
    "so.tool.italic": "Italic",
    "so.tool.underline": "Underline",
    "so.tool.list": "Bulleted list",
    "so.spellcheck": "Check spelling",
    "so.spellchecking": "Checking…",
    "so.toolbar_hint": "Rich-text editor · Ctrl+B/I/U · lists · manual spellcheck",
    "so.editor.generating": "Claire is drafting with a \u201c{tone}\u201d tone…",
    "so.changes.title": "{n} correction(s) applied",
    "so.attach": "Attach file",
    "so.attaching": "Uploading…",
    "so.attach_hint": "PDF, PPT, DOCX, XLS, images · max 15 MB each",
    "so.signature.custom_active": "Custom signature active",
    "so.signature.edit": "Edit signature",
    "so.signature.title": "Edit / import your rich signature with logo, links and formatting",
    "so.banner.sent_ok": "Email sent successfully to {email}",
    "so.banner.retry": "Try again",
    "so.send.last_sent": "Sent {at}",
    "so.send.enroll": "Enroll",
    "so.send.enroll_title": "Enroll contact in a cadence",
    "so.send.enroll_missing": "Create a cadence in /smith/sequences first",
    "so.send.enroll_pick": "Pick a cadence",
    "so.send.manage_cadences": "+ Manage cadences",
    "so.send.button": "Send via Resend",
    "so.send.sending": "Sending…",
    "so.recipient.recipient_bracket": "\u003c{email}\u003e",
    "so.badge.sent": "Sent",
    "so.badge.unverified": "Unverified",
    "so.badge.unverified_title": "Email not publicly confirmed — may fail. Verified sources: Apollo/Hunter.",
    "so.badge.blocked": "Blocked",
    "so.badge.blocked_title": "This contact is on the blacklist. Remove them in /smith/blacklist to resend.",
    "so.badge.champion": "Champion",
    "so.badge.champion_title": "Champion since {date} — 2+ replies detected",
    "so.badge.delete_unverified": "Delete this unverified lead",
    "so.badge.flag_add": "Flag contact",
    "so.badge.flag_remove": "Remove flag",
    "so.enrich_turbo": "Enrich with Turbo",
    "so.enrich_turbo_title": "Run Apollo → Hunter → Apify (Turbo) on every hidden lead to try filling the missing emails",
    "so.enrich_hidden_show": "Show",
    "so.enrich_hidden_hide": "Hide",
    "so.hidden_noemail_banner": "{n} lead(s) without email hidden automatically",
    "so.autoclean.title": "Auto-Cleanup Cron",
    "so.autoclean.next_run": "· next daily 03:00 UTC",
    "so.autoclean.eligible": "eligible",
    "so.autoclean.last_run": "Last: {date} ({n} deleted)",
    "so.autoclean.candidates": "Candidates",
    "so.autoclean.eligible_label": "Eligible",
    "so.autoclean.skipped": "Skip (safety)",
    "so.autoclean.criteria": "Criteria: ≥3 failed / bounced / blocked / skipped attempts and zero successful sends. Prospects with send history or outside the safe pipeline (New Prospect / Researching / Junk) are preserved automatically.",
    "so.autoclean.dry_run": "Run Now (dry-run)",
    "so.autoclean.running_dry": "Running…",
    "so.autoclean.run_live": "Run cleanup",
    "so.autoclean.running_live": "Executing…",
    "so.autoclean.live_title": "Requires Super Admin. Runs the real cleanup.",
    "so.autoclean.refresh": "↻ Refresh",
    "so.tab.contacts.title": "Contact directory",
    "so.tab.contacts.subtitle": "{n} decision-makers aggregated from Apollo/Hunter/Sunbiz/Import",
    "so.tab.contacts.bulk_find": "Bulk find emails",
    "so.tab.contacts.bulk_find_title": "Run find-email on prospects without contact (Apollo → Hunter → web-scrape)",
    "so.tab.contacts.bulk_processed": "{n} processed",
    "so.tab.contacts.bulk_progress": "Bulk find-email running — {done} processed · {found} new emails",
    "so.tab.contacts.empty": "No contacts — import a spreadsheet or run Apollo/Hunter in /smith/prospects.",
    "so.tab.contacts.showing_of": "Showing 200 of {total} — use the full page for pagination/export.",
    "so.tab.contacts.compose": "Compose",
    "so.cleanup.clear_n": "Clear {n}",
    "so.cleanup.cleaning": "Cleaning…",
    "so.cleanup.title": "Permanently delete every failed / blocked / no-email lead",

    // ── Iter317 · Sequences page ────────────────────────────────────
    "seq.header.title": "Smith · Sequences",
    "seq.header.subtitle": "{n} cadences · {active} active enrollments · Cron 15 min",
    "seq.btn.refresh": "Refresh",
    "seq.btn.run_now": "Run now",
    "seq.btn.run_now_title": "Trigger a manual sweep — sends every step that is due right now",
    "seq.btn.new": "New cadence",
    "seq.list.title": "Cadences",
    "seq.list.empty": "No cadences yet. Click New cadence to create one.",
    "seq.card.day": "Day {n}",
    "seq.card.active_pill": "{n} active",
    "seq.card.edit": "Edit",
    "seq.card.stats_active": "Active",
    "seq.card.stats_completed": "Completed",
    "seq.card.stats_stopped": "Stopped",
    "seq.enroll.title": "Enrollments ({n})",
    "seq.enroll.empty_prefix": "No prospects enrolled. Go to",
    "seq.enroll.empty_link": "Outreach AI",
    "seq.enroll.empty_suffix": ", pick a contact and click Enroll.",
    "seq.enroll.step": "step {n}",
    "seq.enroll.next": "next {at}",
    "seq.editor.title_new": "New cadence",
    "seq.editor.title_edit": "Edit cadence",
    "seq.editor.name": "Name",
    "seq.editor.description": "Description",
    "seq.editor.steps": "Steps",
    "seq.editor.add_step": "Add",
    "seq.editor.days": "days",
    "seq.editor.stop_on_reply": "Stop automatically when the prospect replies",
    "seq.editor.cancel": "Cancel",
    "seq.editor.save": "Save",
    "seq.toast.no_templates": "You must create at least 1 template in Outreach AI first.",
    "seq.toast.name_min": "Name must be at least 2 characters.",
    "seq.toast.updated": "Sequence updated",
    "seq.toast.created": "Sequence created",
    "seq.toast.deleted": "Deleted",
    "seq.toast.stopped": "Stopped",
    "seq.toast.sweep_ok": "Sweep run: {sent} sent, {stopped} stopped, {picked} picked",
    "seq.toast.load_failed": "Failed to load sequences",
    "seq.toast.save_failed": "Save failed",
    "seq.toast.delete_failed": "Delete failed",
    "seq.toast.sweep_failed": "Sweep failed",
    "seq.confirm.delete": "Delete \"{name}\"? Only works if there are no active enrollments.",
    "seq.confirm.stop": "Stop cadence for prospect \"{name}\"?",
    "seq.confirm.run_now": "Run manual sweep now? It will send real emails to every eligible enrollment (step due).",
    "seq.step.initial": "Initial",
    "seq.step.follow": "Follow #{n}",
    "seq.step.last": "Final",
    "seq.status.active": "Active",
    "seq.status.completed": "Completed",
    "seq.status.stopped_reply": "Replied",
    "seq.status.stopped_manual": "Stopped",
    "seq.status.stopped_pipeline": "Won/Lost",

    // ── Iter319 · Delivery chip statuses (Resend) ───────────────────
    "so.deliv.queued": "Queued",
    "so.deliv.sent": "Sent",
    "so.deliv.delivered": "Delivered",
    "so.deliv.opened": "Opened",
    "so.deliv.clicked": "Clicked",
    "so.deliv.bounced": "Bounced",
    "so.deliv.complained": "Spam",
    "so.deliv.failed": "Failed",
    "so.deliv.sandbox": "Sandbox",
    "so.deliv.skipped": "Skipped",
    "so.deliv.tooltip": "Resend status: {label}",

    "vs.geo.title": "Central Florida — Vehicle Security Coverage",
    "vs.geo.summary": "{cities} cities · {leads} leads",
    "vs.geo.critical_extra": "· {n} critical",
    "vs.geo.refresh": "Refresh",
    "vs.discovery.title": "Vehicle Security Discovery",
    "vs.discovery.subtitle": "OpenAI web-search + Smith CRM cross-reference",
    "vs.discovery.city": "City",
    "vs.discovery.state": "State",
    "vs.discovery.openai": "OpenAI search",
    "vs.discovery.crm": "CRM cross-ref",
    "vs.discovery.run": "Run Discovery",
    "vs.discovery.running": "Discovering…",
    "vs.discovery.segments_hint": "Segments — pick 1-3 for best cost (each = 1 OpenAI web_search)",
    "vs.discovery.copy_link": "Copy link",
    "vs.discovery.copy_link_title": "Copies the URL with selected segments + city so you can share this filtered view with another rep",
    "vs.discovery.link_copied": "Filtered link copied — paste to share",
    "vs.discovery.link_copy_failed": "Could not copy. Grab it from the URL bar instead.",
    "vs.leads.section_title": "Vehicle Security Leads",
    "vs.leads.count": "· {shown}/{total} leads",
    "vs.leads.filter_prefix": "(filter: {seg})",
    "vs.leads.radius_label": "· radius {miles}mi",
    "vs.leads.route_label": "· optimized route",
    "vs.filter.tier_all": "All tiers",
    "vs.filter.tier_critical": "🔥 Critical (90+)",
    "vs.filter.tier_very_high": "🟠 Very High (80-89)",
    "vs.filter.tier_high": "🟡 High (70-79)",
    "vs.filter.tier_medium": "🔵 Medium (60-69)",
    "vs.filter.tier_low": "⚪ Low (<60)",
    "vs.filter.flock_all": "All ALPR status",
    "vs.filter.flock_only": "Only Flock-detected",
    "vs.filter.flock_exclude": "Exclude Flock-detected",
    "vs.tbl.property": "Property",
    "vs.tbl.segment": "Segment",
    "vs.tbl.score": "Score",
    "vs.tbl.signals": "Signals",
    "vs.tbl.opportunity": "Estimated Opportunity",
    "vs.tbl.status": "Status",
    "vs.tbl.actions": "Actions",
    "vs.tbl.loading": "Loading…",
    "vs.tbl.empty_run_discovery": "No leads yet — run Discovery above to get started.",
    "vs.tbl.empty_filters": "No leads match the active filters (tier / Flock / map radius).",
    "vs.tbl.unknown_signals": "Unknown",
    "vs.tbl.status_new": "New",
    "vs.tbl.stop_title": "Stop #{n} on optimized route",
    "vs.action.view_sources": "View Sources",
    "vs.action.open_details": "Open details",

    "claire.open_integrations": "Open Integrations",
    "claire.close": "Close",
    "claire.reset": "Restart conversation",
    "claire.engine": "Engine",
    "claire.engine.deep": "Deep",
    "claire.engine.fast": "Fast",
    "claire.engine.deep_title": "Claude Sonnet 5 — deep reasoning (~3s)",
    "claire.engine.fast_title": "Perplexity Sonar Pro — web search, faster",
    "claire.typing": "Claire is typing…",
    "claire.voice.hint": "Fix any word Claire misheard, then tap send.",
    "claire.voice.clear": "Clear",
    "claire.whatsapp": "Talk to a human on WhatsApp",

    // ── Iter313 · Sidebar extras ────────────────────────────────────
    "sidebar.brand": "AgenteLead Pro",
    "sidebar.switch_persona": "Switch persona",
    "sidebar.loading": "Loading…",
    "sidebar.personas_failed": "Failed to load personas",
    "sidebar.logged_as": "Logged in as:",
    "sidebar.role": "Role:",
    "sidebar.role_not_admin": "Your role is NOT in the admin set. Contact a super-admin to upgrade.",
    "sidebar.retry": "Retry",
    "sidebar.demo_seed_prompt": "No demo accounts yet — seed the 5 defaults in one click:",
    "sidebar.demo_profiles": "Demo Profiles",
    "sidebar.demo_open": "Open",
    "sidebar.demo_magic": "Magic",
    "sidebar.demo_manage": "Manage profiles →",
    "sidebar.demo_seeded_toast": "Demo accounts seeded",
    "sidebar.no_token_toast": "No token returned",
    "sidebar.new_24h": "New in last 24h",

    // ── Iter313 · Header + Mobile drawer extras ─────────────────────
    "header.theme": "Theme",
    "header.language": "Language",
    "header.help": "Help",
    "header.open_nav": "Open navigation",
    "header.open_menu": "Open menu",
    "mobile.close_menu": "Close menu",
    "mobile.nav_label": "Mobile navigation",
    "mobile.scrapers_title": "Scrapers",
    "mobile.smith_title": "Smith Protective",
    "btn.go": "Go",
    "vsm.exact_mode_hint": "Exact address mode active — Google geocoding. Internal sales-team use only.",
    "vsm.city_mode_hint": "City Mode: pins aggregated by neighborhood/city. Exact addresses are hidden by default.",
    "settings.language.title": "Language / Idioma",
    "settings.language.description": "Pick the language you want to use across the app. Preference syncs across devices.",
    "settings.language.current": "Current",
    "settings.language.preview": "Preview",
    "settings.language.unsaved": "Unsaved change — click Save to apply",
    "lang.saved": "Language preference saved",
    "lang.saved_local": "Saved locally (backend unavailable)",
    "lang.picker_open": "Change language",
    "lang.picker_title": "Language",
    "lang.picker_settings": "Language settings",
    "btn.save": "Save",
    "btn.saving": "Saving…",
    "signup.language_auto": "We detected your browser language: {lang}",
    "signup.language_change": "Change",

    "sidebar.collapse": "Collapse",
    "sidebar.expand": "Expand sidebar",
    "sidebar.agency_dashboard": "Agency Dashboard",
    "sidebar.saas_configurator": "Auto Pilot",
    "sidebar.prospecting": "Lead Discovery",
    "sidebar.integrations": "Integrations",
    "sidebar.kanban": "CRM Kanban",
    "sidebar.gov_kanban": "Gov · Public Works",
    "sidebar.funnel": "Sales Funnel",
    "sidebar.campaigns": "Campaigns",
    "sidebar.insights": "Insights",
    "sidebar.roi": "ROI",
    "sidebar.marketing_apis": "Marketing APIs",
    "sidebar.webhooks": "Webhooks",
    "sidebar.free_sources": "Free Sources",
    "sidebar.activity_log": "Activity Log",
    "sidebar.affiliate_portal": "Affiliate Portal",
    "sidebar.library": "Library",
    "sidebar.b2c_intent": "B2C Intent & Social Listening",
    "sidebar.b2c_radar": "B2C Lead Radar",
    "sidebar.b2c_group": "B2C",
    "sidebar.gov_group": "Government",
    "sidebar.sunbiz": "Sunbiz Connector",
    "sidebar.multi_state": "Multi-State Capture",
    "sidebar.no_website": "Leads Sem Website",
    "sidebar.yelp": "Yelp Finder",
    "sidebar.auto_cruise": "Auto-Cruise",
    "sidebar.lead_gap": "Lead Gap Intelligence",
    "sidebar.instagram": "Instagram Scraper",
    "sidebar.linkedin": "LinkedIn Sales Nav",
    "sidebar.youtube": "YouTube Scraper",
    "sidebar.replies": "AI Replies Inbox",
    "sidebar.scrapers": "Scrapers",
    "sidebar.saas_education": "SaaS Education",
    "sidebar.mobile_app": "Mobile App",
    "sidebar.app_marketplace": "App Marketplace",
    "sidebar.billing": "Billing",
    "sidebar.upgrade": "UPGRADE",
    "sidebar.support": "Support",
    "sidebar.account": "Account info",
    "sidebar.public_works": "Procurement Scanner",
    "sidebar.gc_leaderboard": "GC Leaderboard",
    "sidebar.product_catalog": "Product Catalog",
    "sidebar.leads_finder": "Leads Finder",
    "sidebar.leads_map": "Leads Map",
    "sidebar.more": "More",
    "sidebar.logout": "Sign out",
    "sidebar.extended_dash": "Extended Dash",

    // Top header
    "header.back": "Back to Prospect Accounts",
    "header.title": "Find Local Leads, Run Audits & Push to CRM",
    "header.add_manual": "Add Virtual Business Manually",

    // Search bar
    "search.business_placeholder": "Business Type — e.g., Pest Control, Roofing, HVAC…",
    "search.category_label": "Category",
    "search.category_all": "All",
    "search.location_placeholder": "e.g., Orlando FL 32801",
    "search.structured_show": "Pick City · State · Zipcode",
    "search.structured_hide": "Hide structured picker",
    "search.state_all": "All states",
    "search.city_all": "All cities",
    "search.city_empty": "No cities saved yet",
    "search.zip_all": "All zipcodes",
    "search.zip_empty": "No zipcodes saved yet",
    "search.button": "Search",
    "search.unit_km": "KM",
    "search.unit_mi": "MI",
    "search.status_all": "All",
    "search.status_open": "Open Now",
    "search.status_label": "Status:",
    "search.types_builtin": "Built-in types",
    "search.types_custom": "Custom",
    "search.types_add_option": "+ Add new business type…",
    "search.types_add_placeholder": "e.g., Solar Cleaning",
    "search.types_save": "Save",
    "search.types_delete": "Remove custom type",
    "search.type_too_short": "Type name must have at least 2 characters",
    "search.type_added": "Added: {name}",
    "search.type_add_failed": "Failed to add business type",
    "search.type_deleted": "Removed: {name}",
    "search.type_delete_failed": "Failed to remove",
    "search.type_delete_confirm": "Remove '{name}' from your business types? Your saved leads keep this sector.",
    "search.advanced": "Advanced",
    "search.adv_rating_min": "Min. rating",
    "search.adv_reviews_min": "Min. reviews",
    "search.adv_score_max": "Max. score (hotter)",
    "search.adv_has_website": "Has website",
    "search.adv_any": "Any",
    "search.adv_yes": "Yes",
    "search.adv_no": "No",
    "search.adv_only_quente": "QUENTE only (≤33)",
    "search.adv_quente_morno": "QUENTE+MORNO (≤66)",
    "search.adv_reset": "Reset advanced filters",

    // Empty state
    "empty.title": "Discover Hot Leads Around You!",
    "empty.body": "Pull real businesses from Google Maps — no scrapers or spreadsheets. Save leads, generate audits, and kick off outreach with Automation. Already have a lead?",
    "empty.body_link": "Add it manually.",

    // Lead card
    "lead.score_label": "Digital Score",
    "lead.save_crm": "Save to CRM",
    "lead.similar": "Similar Leads",
    "lead.similar_tooltip": "Show similar leads from your saved CRM",
    "lead.sequence": "Start Sequence",
    "lead.sequence_tooltip": "Kick off a multi-step cold-email sequence",
    "outreach.config_button": "Email Config",
    "lead.run_audit": "Run Audit",
    "lead.send_email": "Send Email",
    "lead.view_maps": "View on Maps",
    "lead.found": "leads found",
    "lead.found_subtitle": "Sorted by relevance · Lower score = hotter lead",
    "lead.no_results": "No leads found. Try a different business type.",

    // Status pills
    "status.open": "Open",
    "status.closed": "Closed",
    "status.operational": "Operational",

    // Toasts
    "toast.found": "Found {count} leads",
    "toast.found_filtered": "Found {count} leads ({hidden} hidden by filters)",
    "toast.saved": "Lead saved to AgenteLead Pro!",
    "toast.search_failed": "Search failed. Try again.",
    "toast.save_failed": "Failed to save lead",
    "toast.audit_failed": "Audit failed. Check your LLM key.",
    "toast.email_failed": "Email generation failed.",
    "toast.business_added": "Business added to CRM!",
    "toast.business_failed": "Failed to add business",

    // Dashboard
    "dash.title": "Agency Dashboard",
    "dash.subtitle": "Overview · KPIs · Free lead sources",
    "dash.refresh": "Refresh",
    "dash.last_updated": "Last update",
    "dash.notifications": "Notifications",
    "dash.notif_empty": "No HOT mentions right now — quiet is good.",
    "dash.notif_hot": "HOT mentions in the last 24h.",
    "dash.notif_see": "See in B2C Intent",
    "header.admin": "Admin · Library",
    "dash.kpi.saved": "Saved Leads",
    "dash.kpi.saved_sub": "Total in CRM",
    "dash.kpi.score": "Avg Digital Score",
    "dash.kpi.score_sub": "Lower = more opportunity",
    "dash.kpi.hot": "Hot Leads (QUENTE)",
    "dash.kpi.hot_sub_zero": "—",
    "dash.kpi.activity": "Activity Events",
    "dash.kpi.activity_sub": "Latest tracked actions",
    "dash.distrib_title": "Distribution by temperature",
    "dash.distrib_empty": "No leads saved yet. Go to Prospecting and click Save to CRM.",
    "dash.top_sectors": "Top sectors in CRM",
    "dash.activity_by_type": "Activity by type",
    "dash.no_data": "No data yet.",
    "dash.no_records": "No records yet.",
    "dash.integrations_title": "🔌 Integration with Existing Tools",
    "dash.integrations_subtitle": "tools — execute to automate flows",
    "dash.integrations_col_tool": "Tool",
    "dash.integrations_col_cat": "Category",
    "dash.integrations_col_desc": "Dashboard Integration",
    "dash.integrations_col_status": "Status",
    "dash.integrations_col_action": "Action",
    "dash.execute": "Execute",
    "dash.free_sources_title": "💡 Free Lead Generation Sources",
    "dash.free_sources_subtitle_pre": "sources · Updated on",
    "dash.free_sources_curated": "Curated list",
    "dash.captured_title": "📦 Captured Leads by Business Type",
    "dash.captured_subtitle": "Saved leads grouped by sector",
    "dash.captured_empty": "No saved leads yet. Use the Prospecting page to start capturing.",
    "dash.captured_show": "Show leads",
    "dash.captured_hide": "Hide leads",
    "dash.enrich_button": "Re-enrich",
    "dash.enrich_running": "Enriching…",
    "dash.enrich_button_tooltip": "Re-scrape the website to refresh social signals and recalculate the digital score.",
    "dash.enrich_no_website_tooltip": "No website on file — cannot re-enrich.",
    "dash.enrich_last": "Enriched · {at}",
    "dash.enrich_pending": "Not enriched yet",
    "dash.enrich_no_site_label": "No website",
    "dash.enrich_success": "{name} re-enriched · score {score} · {badge}",
    "dash.enrich_no_website": "{name} has no website on file",
    "dash.enrich_failed": "Failed to enrich {name}: {reason}",
    "dash.enrich_not_found": "Lead not found in database",
    "dash.activity_link_tooltip": "View {label} events in the Activity Log",
    "dash.kpi_link_tooltip": "Click to drill in",
    "dash.funnel_title": "Lead Conversion Funnel",
    "dash.funnel_subtitle": "Each stage shows total events tracked and conversion vs. the previous stage",
    "dash.funnel_step_search": "Search",
    "dash.funnel_step_save": "Save to CRM",
    "dash.funnel_step_audit": "Run Audit",
    "dash.funnel_step_email": "Generate Email",
    "dash.funnel_step_enrich": "Re-enrich",
    "dash.funnel_conv_label": "vs prev",
    "dash.funnel_drilldown_tooltip": "Open Activity Log filtered by {step}",
    "dash.funnel_empty": "Run a few searches and saves to populate the funnel.",

    // Free sources cols
    "fs.col_num": "#",
    "fs.col_name": "Source Name",
    "fs.col_type": "Type",
    "fs.col_credits": "Credits / Month",
    "fs.col_extracts": "What it extracts",
    "fs.col_how": "How to use",
    "fs.col_open": "Open",
    "fs.page_title": "Free Lead Generation Sources",
    "fs.page_subtitle": "Curated public directories and free APIs to source leads at zero cost",

    // Kanban
    "kanban.title": "CRM Kanban",
    "kanban.subtitle": "leads in pipeline",
    "kanban.col.NEW": "New",
    "kanban.col.CONTACTED": "Contacted",
    "kanban.col.QUALIFIED": "Qualified",
    "kanban.col.PROPOSAL": "Proposal",
    "kanban.col.WON": "Won",
    "kanban.col.LOST": "Lost",
    "kanban.empty": "Nothing here yet",
    "kanban.move_to": "Move to",
    "kanban.dedup_label": "merged",
    "kanban.dedup_tooltip": "This lead absorbed duplicates from re-saves",
    "kanban.search_placeholder": "Search by company name…",
    "kanban.filter_temp_all": "All temperatures",
    "kanban.filter_sector_all": "All sectors",
    "kanban.no_results": "No leads match the current filters.",
    "kanban.stale_tooltip": "Stale: stuck in this column for {days} days",
    "kanban.status_age_tooltip": "In this column for {days} days",
    "kanban.today": "today",
    "kanban.d_ago": "{days}d ago",
    "kanban.last_email_tooltip": "Last email {days}d ago · {count} total touches",
    "kanban.silent_tooltip": "Contacted status with no logged email — did you actually send?",
    "kanban.silent_label": "no email yet",
    "kanban.filter_silent": "No-contact leads",
    "kanban.filter_silent_tooltip": "Show only leads with no email logged (CONTACTED+ columns)",
    "kanban.followup_tooltip": "Next follow-up: {date}",
    "kanban.followup_overdue": "Follow-up overdue ({date})",
    "kanban.score_tooltip": "Lead Score: {score}/100 — lower is hotter",
    "kanban.lookalike_seed_won": "Find similar to this Won lead",
    "kanban.drag_hint": "Drag a card to another column to update its status",
    "kanban.meta_check_label": "Check Meta Ads",
    "kanban.meta_check_tooltip": "Click to check if this business is running Facebook/Instagram ads right now (24h cache)",
    "kanban.meta_checking": "Checking…",
    "kanban.meta_active": "{count} live ads",
    "kanban.meta_active_tooltip": "Running {count} active Meta ads — they buy traffic, probably buy your service too",
    "kanban.meta_inactive": "no ads",
    "kanban.meta_inactive_tooltip": "No active Meta ads found for this business in the last 24h",
    "kanban.delete_tooltip": "Remove this lead from the pipeline",
    "kanban.delete_confirm": "Remove \"{name}\" from the pipeline? This can't be undone.",
    "kanban.delete_ok": "\"{name}\" removed from the pipeline",
    "kanban.delete_fail": "Could not delete this lead — try again.",
    // Lead detail drawer
    "ldd.title": "Lead details",
    "ldd.tab_overview": "Overview",
    "ldd.tab_history": "History",
    "ldd.tab_notes": "Notes",
    "ldd.field_phone": "Phone",
    "ldd.field_email": "Email",
    "ldd.field_website": "Website",
    "ldd.field_address": "Address",
    "ldd.field_sector": "Sector",
    "ldd.field_status": "CRM Status",
    "ldd.field_score": "Digital Score",
    "ldd.field_followup": "Next follow-up",
    "ldd.followup_clear": "Clear",
    "ldd.followup_save": "Save",
    "ldd.followup_saved": "Follow-up updated",
    "ldd.followup_failed": "Failed to save follow-up",
    "ldd.notes_placeholder": "Type meeting notes, objections, next steps…",
    "ldd.notes_save": "Save notes",
    "ldd.notes_saved": "Notes saved",
    "ldd.history_empty": "No activity yet on this lead.",
    "ldd.actions_title": "Quick actions",
    "ldd.action_wa": "WhatsApp",
    "ldd.action_call": "Call",
    "ldd.action_email": "Email",
    "ldd.action_audit": "Audit",
    "ldd.no_email": "No email on file",
    "ldd.no_phone": "No phone on file",

    // Webhooks
    "wh.page_title": "Webhooks",
    "wh.page_subtitle": "Send real-time events to Zapier, Make, n8n or any HTTP endpoint",
    "wh.add_title": "Register a new endpoint",
    "wh.add_button": "Register webhook",
    "wh.list_title": "Registered endpoints",
    "wh.empty": "No webhooks yet — register one above.",
    "wh.col_url": "URL",
    "wh.col_events": "Events",
    "wh.col_state": "State",
    "wh.col_last": "Last delivery",
    "wh.col_actions": "Actions",
    "wh.state_active": "Active",
    "wh.state_paused": "Paused",
    "wh.never": "Never delivered",
    "wh.deliveries": "deliveries",
    "wh.test_tooltip": "Send test payload",
    "wh.toggle_tooltip": "Enable/disable",
    "wh.delete_tooltip": "Delete",
    "wh.created": "Webhook registered: {url}",
    "wh.removed": "Webhook removed: {url}",
    "wh.create_failed": "Failed to register webhook",
    "wh.remove_failed": "Failed to remove webhook",
    "wh.toggle_failed": "Failed to toggle state",
    "wh.test_failed": "Test delivery failed",
    "wh.help_title": "How to consume these events",
    "wh.help_p1": "Each registered endpoint receives an HTTPS POST per matching event with a signed body:",
    "wh.help_p2": "Verify the signature against your stored secret to confirm authenticity. Failed deliveries are logged but never retried automatically (yet).",

    // Bulk search
    "bulk.modal_title": "Bulk Search across multiple cities",
    "bulk.cities_label": "Cities (comma-separated)",
    "bulk.cities_placeholder": "Orlando, FL, Miami, FL, Tampa, FL",
    "bulk.run_button": "Run bulk search",
    "bulk.auto_save": "Auto-save QUENTE leads",
    "bulk.results_summary": "{total} found · {dedup} after dedup · {saved} auto-saved",
    "bulk.open_modal": "Bulk search",

    // Score breakdown
    "lead.score_tooltip": "Click to see why this lead scored what it did",
    "score.tooltip": "View score breakdown",
    "score.modal_title": "Score Breakdown",
    "score.criteria_title": "Criteria",
    "score.opportunities_title": "Sales opportunities (missing signals)",

    // AI Lookalike Lead Finder
    "look.button": "AI Lookalike",
    "look.modal_title": "AI Lookalike Lead Finder",
    "look.modal_subtitle": "Find more leads similar to your top {n} QUENTE/QUALIFIED ones",
    "look.locations_label": "Target cities (one per line)",
    "look.locations_placeholder": "Tampa, FL\nSaint Petersburg, FL",
    "look.locations_hint": "Leave blank to auto-derive cities from the seed leads' addresses.",
    "look.run_button": "Find lookalikes (uses GPT)",
    "look.queries_count": "AI generated {n} search strategies",
    "look.locations_used": "Cities searched",
    "look.candidates_title": "Candidates ({n})",
    "look.no_candidates": "No new candidates found — try expanding the city list or adding more QUENTE seeds.",
    "look.save_btn": "Save",
    "look.found": "{n} lookalike candidates found",
    "look.failed": "Lookalike search failed",
    "look.saved": "Saved {name} to CRM",
    "look.already_saved": "Already in your CRM (deduplicated)",
    "look.save_failed": "Failed to save lead",

    // WhatsApp
    "wa.button": "WhatsApp",
    "wa.title": "Send WhatsApp",
    "wa.body_label": "Message",
    "wa.send_btn": "Send via WhatsApp",
    "wa.sent": "Sent to {name}",
    "wa.failed_short": "Send failed — see details",
    "wa.queued": "Queued · sid …{sid} · status {status}",
    "wa.disclaimer": "Twilio sandbox: the recipient must first text 'join <code>' to your sandbox number to receive messages. For production, register your number as an approved WhatsApp Sender on Twilio.",
    "wa.no_phone": "No phone number on this lead",

    // Integration status
    "integ.status.connected": "Connected",
    "integ.status.mocked": "Mocked",
    "integ.status.configure": "Configure",
    "integ.page_title": "Integrations",
    "integ.page_subtitle": "Connect external tools and automate flows",
    "integ.error_title": "Couldn't load integrations",
    "integ.execute_failed": "Failed to execute {name}",
    "integ.hero_title": "Pluggable, by design",
    "integ.hero_body": "AgenteLead Pro talks to 50+ tools across communication, automation, CRM, enrichment, marketing, payments, documents, analytics and AI. Connect once and the data flows in both directions.",
    "integ.kpi_total": "Total",
    "integ.kpi_connected": "Connected",
    "integ.kpi_configure": "To configure",
    "integ.search_placeholder": "Search integration by name, category or description…",
    "integ.cat_all": "All",
    "integ.cat_communication": "Communication",
    "integ.cat_automation": "Automation",
    "integ.cat_crm": "CRM",
    "integ.cat_enrichment": "Prospecting & Enrichment",
    "integ.cat_marketing": "Marketing",
    "integ.cat_payments": "Payments",
    "integ.cat_documents": "Documents",
    "integ.cat_analytics": "Analytics",
    "integ.cat_ai": "AI",
    "integ.cat_count_apps": "apps",
    "integ.empty_filtered": "No integrations match the current filters.",
    "integ.read_more": "Learn more",
    "integ.run": "Run",
    "integ.connect": "Connect",
    "integ.update": "Update",
    // Configuration modal
    "cfg.title_connect": "Connect {name}",
    "cfg.title_update": "Update {name}",
    "cfg.already_connected": "Already connected",
    "cfg.current_key": "Current key",
    "cfg.where_to_get": "Get your credentials from",
    "cfg.field_api_key": "API key / token",
    "cfg.placeholder_keep": "Leave empty to keep current key",
    "cfg.never_displayed": "We never display your key again — only the masked version.",
    "cfg.update": "Update",
    "cfg.connect": "Connect",
    "cfg.disconnect": "Disconnect",
    "cfg.disconnect_confirm": "Disconnect {name}? You'll need to reconfigure the API key to reconnect.",
    "cfg.disconnected": "{name} disconnected",
    "cfg.saved": "{name} connected successfully",
    "cfg.save_failed": "Failed to save credentials",
    // App Marketplace
    "mkt.title": "App Marketplace",
    "mkt.subtitle": "Curated 3-tier integration ladder — Essentials → Differentials → Advanced",
    "mkt.error_title": "Couldn't load the marketplace",
    "mkt.eyebrow": "3-tier integration ladder",
    "mkt.hero_title": "Your prospecting stack, one click away.",
    "mkt.hero_body": "We mapped the 22 integrations that take AgenteLead Pro from MVP to a Clay/Apollo competitor. Pick your tier, click Install and we'll guide you through credentials in seconds.",
    "mkt.kpi_total": "Total apps",
    "mkt.kpi_connected": "Connected",
    "mkt.kpi_to_configure": "To configure",
    "mkt.search_placeholder": "Search across all marketplace apps…",
    "mkt.tier_all": "All tiers",
    "mkt.tier_essentials_short": "Essentials",
    "mkt.tier_differentials_short": "Differentials",
    "mkt.tier_advanced_short": "Advanced",
    "mkt.tier_connected": "connected",
    "mkt.tier_pending": "pending",
    "mkt.empty_filtered": "No apps match the current filters.",
    "mkt.install": "Install",
    "mkt.installed": "Installed",
    "mkt.coming_soon": "Coming soon",
    "mkt.status_coming_soon": "Coming Soon",

    // Onboarding tour
    "tour.skip": "Skip tour",
    "tour.next": "Next",
    "tour.back": "Back",
    "tour.done": "Got it",
    "tour.restart": "Restart tour",
    "tour.step_label": "Step {current} of {total}",
    "tour.s1.title": "Welcome to AgenteLead Pro",
    "tour.s1.body": "A 60-second walkthrough of how to find local B2B leads, qualify them with AI and run multi-channel outreach — all inside one app.",
    "tour.s1.b1": "Find leads on Google Maps without copy-paste or extensions",
    "tour.s1.b2": "Score, audit and email each lead with GPT",
    "tour.s1.b3": "Pipeline them in a Kanban CRM with WhatsApp and follow-ups",
    "tour.s2.title": "1. Prospect by niche + city",
    "tour.s2.body": "Open the Prospecting page, pick a niche (Roofing, HVAC, Plumbing…) and a city. The platform queries Google Maps live and brings each business with score, badge, phone, website and address.",
    "tour.s2.b1": "Bulk Search across multiple cities in one click",
    "tour.s2.b2": "Auto-save QUENTE leads straight into your CRM",
    "tour.s2.b3": "Built-in deduplication so the same business never appears twice",
    "tour.s2.cta": "Open Prospecting",
    "tour.s3.title": "2. Score & audit with AI",
    "tour.s3.body": "Each lead gets a Digital Score (lower = hotter — bigger sales opportunity). Click Run Audit and GPT produces a 6-section website analysis. Click Send Email and it drafts personalized outreach using rating, reviews and site cues.",
    "tour.s3.b1": "QUENTE 0-33 · MORNO 34-66 · FRIO 67-100",
    "tour.s3.b2": "GPT audit covers Web, Local SEO, Social, Reviews, Opportunities, Pitch",
    "tour.s3.b3": "AI Lookalike: turn your best Won customer into 5 more like it",
    "tour.s4.title": "3. Pipeline in CRM Kanban",
    "tour.s4.body": "Saved leads land in Kanban. Drag & drop between New → Contacted → Qualified → Proposal → Won/Lost. Click any card to open a side drawer with full history, notes and next follow-up date.",
    "tour.s4.b1": "Quick actions: WhatsApp · Call · Email — one click",
    "tour.s4.b2": "Stale-card alert if a lead sits >7 days in the same column",
    "tour.s4.b3": "Filter by name, temperature or sector at the top",
    "tour.s4.cta": "Open CRM Kanban",
    "tour.s5.title": "You're ready 🚀",
    "tour.s5.body": "Track your funnel, conversion and ROI in real time on the Agency Dashboard. You can re-open this tour any time from the sidebar.",
    "tour.s5.b1": "Lead Conversion Funnel + clickable KPIs",
    "tour.s5.b2": "Webhooks fire on every key event (save, status change, audit, WhatsApp)",
    "tour.s5.b3": "Activity Log with one-click drill-down",
    "tour.s5.cta": "Go to Dashboard",

    // Campaigns page
    "camp.greeting": "Hi, Reach Soul!",
    "camp.trial_left": "14 days left in your Premium trial",
    "camp.view_plans": "View billing plans",
    "camp.nav_title": "Campaigns",
    "camp.nav_subtitle": "Email marketing for the leads in your CRM",
    "camp.cta_primary": "Get started for free",
    "camp.cta_pricing": "View pricing",
    "camp.cta_hint": "Free during trial",
    "camp.hero_eyebrow": "Email marketing",
    "camp.hero_title": "Send email marketing campaigns that get clicks",
    "camp.hero_body": "Bring marketing and sales together in one workspace. Design beautiful emails, automate the right message at the right time and turn replies into pipeline — without leaving your CRM.",
    "camp.hero_button_label": "Open audit",
    "camp.b1_title": "Create stunning emails",
    "camp.b1_body": "Pick from professional, customizable templates and craft on-brand campaigns in minutes with a drag-and-drop editor.",
    "camp.b2_title": "Nurture your contacts",
    "camp.b2_body": "Trigger automations so the right message lands at the right moment — based on lead score, status changes or website signals.",
    "camp.b3_title": "Boost campaign performance",
    "camp.b3_body": "See opens, clicks and conversions in real time and benchmark across campaigns with side-by-side reporting.",
    "camp.video_label": "Live demo",
    "camp.video_demo": "Demo video would play here in production.",
    "camp.reasons_title": "Even more reasons to try Campaigns",
    "camp.reasons_subtitle": "All the heavy lifting handled inside AgenteLead Pro.",
    "camp.r1": "No more importing/exporting contacts — your CRM is the source of truth.",
    "camp.r2": "Modern templates plus a drag-and-drop editor — no HTML required.",
    "camp.r3": "Engagement automatically syncs back to sales, so reps see who's hot.",
    "camp.r4": "Start engaging leads in just a few steps — no setup wizards.",
    "camp.list_title": "Your campaigns",
    "camp.list_subtitle": "Drafts and scheduled sends",
    "camp.count_label": "campaigns",
    "camp.empty": "No campaigns yet — your first draft is just one click away.",
    "camp.draft_name": "Untitled campaign · {date}",
    "camp.draft_subject": "A quick note from AgenteLead Pro",
    "camp.draft_created": "Created draft: {name}",
    "camp.draft_failed": "Failed to create draft",
    "camp.col_subject": "Subject",
    "camp.col_recipients": "recipients",
    "camp.action_edit": "Edit",
    "camp.action_assign": "Assign leads",
    "camp.edit_hint": "Open the email editor to refine — coming soon",
    "camp.final_title": "Ready to turn leads into clicks?",
    "camp.final_body": "Spin up a draft now and we'll pre-fill it with your top QUENTE leads.",

    // Insights / Reports page
    "ins.greeting": "Hi, Reach Soul!",
    "ins.trial_left": "You have 14 days left in your Premium trial",
    "ins.view_plans": "View billing plans",
    "ins.title": "Insights",
    "ins.search_placeholder": "Search dashboards, goals, reports…",
    "ins.notifications": "Notifications",
    "ins.avatar_tooltip": "Access settings and tools — You can find all your account and personal settings and tools under the avatar menu.",
    "ins.section_dashboards": "Dashboards",
    "ins.section_goals": "Goals",
    "ins.section_reports": "Reports",
    "ins.my_dashboards": "My dashboards",
    "ins.my_goals": "My goals",
    "ins.my_reports": "My reports",
    "ins.no_dashboards": "No dashboards yet",
    "ins.no_goals": "No goals yet",
    "ins.no_reports": "No reports yet",
    "ins.eyebrow": "Real-time analytics",
    "ins.hero_title": "Identify growth opportunities. Take action.",
    "ins.hero_body": "Set up your personalized, customizable reporting dashboard. Track AgenteLead data related to your sales activities. Make informed decisions at the right time.",
    "ins.cta_create": "Create dashboard",
    "ins.cta_ai": "Generate report (AI)",
    "ins.cta_video": "Watch video (0:35)",
    "ins.video_demo": "Demo video would play here in production.",
    "ins.generating_ai": "AI report generation queued — we'll notify you when it's ready.",
    "ins.chart_sectors": "Leads by sector",
    "ins.chart_temperature": "Temperature mix",
    "ins.chart_actions": "Activity by action",
    "ins.chart_realtime": "live",
    "ins.kpi_saved": "Saved leads",
    "ins.kpi_saved_drill": "Open Kanban pipeline",
    "ins.kpi_avg_score": "Avg. score",
    "ins.kpi_avg_drill": "See scored leads",
    "ins.kpi_quente": "QUENTE",
    "ins.kpi_quente_drill": "View HOT leads only",
    "ins.kpi_activity": "Activity events",
    "ins.kpi_activity_drill": "Open activity log",
    "ins.last_updated": "Last updated",
    "ins.refresh_now": "Refresh now",
    "ins.refreshed": "Insights refreshed",
    "ins.extra_title": "Strategic visualizations",
    "ins.extra_subtitle": "Last 30 days · auto-refresh",
    "ins.funnel_title": "Sales pipeline funnel",
    "ins.source_title": "Leads by source",
    "ins.gauge_no_goal_title": "Goal tracker",
    "ins.gauge_of_target": "of target {target}",
    "ins.gauge_metric": "Metric",
    "ins.gauge_no_goal": "Create a goal to surface progress here.",
    "ins.timeline_title": "Leads vs activity (30d)",
    "ins.timeline_badge": "trend",
    "ins.timeline_leads": "Leads added",
    "ins.timeline_activity": "Activity events",
    "ins.efficiency_title": "Action efficiency",
    "ins.efficiency_events": "Events",
    "ins.efficiency_qualified": "Moved to QUALIFIED+",
    "ins.efficiency_legend": "Higher green-bar share = more conversion-driving actions.",
    "ins.heatmap_title": "Sector × Temperature heatmap",
    "ins.heatmap_empty": "No sector data yet — save a few leads to populate.",
    "ins.heatmap_legend": "Darker cell = denser bucket. Use this to spot hot sectors at a glance.",
    "ins.report_generated": "AI insights report generated",
    "ins.report_failed": "Failed to generate AI report",
    "ins.report_deleted": "Report deleted",
    "ins.cta_goal": "New goal",
    "ins.dash_modal_title": "Create dashboard",
    "ins.dash_field_name": "Name",
    "ins.dash_field_desc": "Description",
    "ins.dash_placeholder_name": "e.g., Florida — Roofing pipeline",
    "ins.dash_placeholder_desc": "Optional. What does this dashboard track?",
    "ins.dash_save": "Create",
    "ins.dash_name_required": "Dashboard name is required",
    "ins.dash_created": "Dashboard '{name}' created",
    "ins.dash_failed": "Operation failed",
    "ins.dash_deleted": "Dashboard removed",
    "ins.dash_delete_confirm": "Remove dashboard '{name}'?",
    "ins.goal_modal_title": "Create goal",
    "ins.goal_field_name": "Name",
    "ins.goal_field_metric": "Metric",
    "ins.goal_field_target": "Target",
    "ins.goal_placeholder_name": "e.g., 200 saved leads in April",
    "ins.goal_save": "Create",
    "ins.goal_name_required": "Goal name is required",
    "ins.goal_created": "Goal '{name}' created",
    "ins.goal_failed": "Failed to create goal",
    "ins.goal_m_saved": "Saved leads",
    "ins.goal_m_quente": "QUENTE leads",
    "ins.goal_m_activity": "Activity events",
    "ins.goal_m_avg": "Avg. score",
    "ins.ai_report_title": "AI Insights Report",
    "ins.ai_wins": "Wins",
    "ins.ai_risks": "Risks",
    "ins.ai_actions": "Next actions",
    "common.cancel": "Cancel",

    // Free Sources V2 + Prospecting Wizard
    "fs.page_title_v2": "Settings · Data Sources",
    "fs.page_subtitle_v2": "Manage your data sources · Pick a playbook · Run the Prospecting Engine",
    "fs.view_dashboard": "View on Dashboard",
    "fs.cta_engine": "Run Prospecting Engine",
    "fs.error_title": "Couldn't load free sources",
    "fs.curated_count": "curated sources, refreshed weekly",
    "fs.hero_eyebrow": "Free + Freemium",
    "fs.hero_title": "From \"I want leads\" to \"I have a clean, ready-to-action list\" — without 5 paid tools.",
    "fs.hero_body": "We've curated the best free / freemium B2B lead sources, tagged them by difficulty, cost and data type, and connected each one to our Prospecting Engine. Pick a source or playbook below and we'll handle dedup, scoring and routing to your CRM.",
    "fs.recommended_title": "Recommended for you",
    "fs.tag_recommended": "Smart pick",
    "fs.search_placeholder": "Search by name, type, or extracted data…",
    "fs.group_all": "All categories",
    "fs.group_directory": "Public directories",
    "fs.group_email": "Email finders",
    "fs.group_scraper": "Scrapers / Extensions",
    "fs.group_b2b": "B2B databases",
    "fs.cost_any": "Any cost",
    "fs.cost_free": "Free",
    "fs.cost_freemium": "Freemium",
    "fs.cost_credits": "Credits",
    "fs.diff_any": "Any difficulty",
    "fs.diff_beginner": "Beginner",
    "fs.diff_intermediate": "Intermediate",
    "fs.diff_advanced": "Advanced",
    "fs.filter_clear": "Clear filters",
    "fs.sources_count": "sources",
    "fs.empty_filtered": "No sources match the current filters.",
    "fs.card_credits": "Free tier",
    "fs.card_send_engine": "Send to Engine",
    "fs.tab_all": "All sources",
    "fs.tab_general": "🏢 General Prospecting",
    "fs.tab_gov": "🏛️ Gov & Construction",
    "fs.open_in_app": "Open in app",
    "fs.credits_internal": "Uses AgenteLead Credits (built-in engine)",
    "fs.credits_external": "Uses YOUR credits on the external platform",
    "fs.card_open": "Open source",
    "fs.playbooks_title": "Prospecting Playbooks",
    "fs.playbooks_subtitle": "Pre-built workflows that pick the right sources, parameters and outputs for the most common prospecting goals.",
    "fs.pb1_title": "Find local B2B in my city",
    "fs.pb1_body": "Roofing, HVAC, Construction businesses near a city — straight from Google Maps + BBB + Yellow Pages, deduped and scored.",
    "fs.pb2_title": "Validate emails from an old list",
    "fs.pb2_body": "Run a list of contacts through Hunter / Prospeo / Snov to filter only verified emails before launching outreach.",
    "fs.pb3_title": "Find decision-makers in construction",
    "fs.pb3_body": "Use Apollo + Lusha + BBB to surface owners, GMs and Marketing Directors of construction firms.",
    "fs.pb4_title": "Build a high-rating bulk list",
    "fs.pb4_body": "Pull 4★+ HVAC/Plumbing businesses with 50+ reviews — high credibility leads ready for cold outreach.",
    "fs.pb_recommended_sources": "Recommended sources",
    "fs.pb_run": "Run playbook",
    "fs.faq_title": "FAQ & support",
    "fs.faq1_q": "Do I need to install anything to use these sources?",
    "fs.faq1_a": "No. Most sources work directly inside the Prospecting Engine. Some scrapers (Web Scraper, Octoparse) require a free Chrome extension — we'll prompt you only when relevant.",
    "fs.faq2_q": "Will the engine deduplicate across sources?",
    "fs.faq2_a": "Yes. We dedupe by phone, normalized website domain and place_id. If you save a lead that already exists, we increment its dedup_hits counter instead of duplicating.",
    "fs.faq3_q": "Are the leads sent to my CRM the moment I run the engine?",
    "fs.faq3_a": "Only if you choose 'Send to CRM' in the last wizard step. You can also export to CSV or seed a campaign without saving to the CRM.",
    "fs.faq4_q": "What's the difference between this Hub and direct prospecting?",
    "fs.faq4_a": "Direct prospecting (the search bar) is fast — one source at a time. The Hub plus Engine are best when you want to combine multiple sources, follow a playbook and route the output to a specific destination.",
    "fs.final_cta_title": "Ready to fill your pipeline?",
    "fs.final_cta_body": "One wizard, five steps, your CRM populated with qualified leads. No more spreadsheet juggling.",

    // Wizard
    "wiz.title": "Prospecting Engine",
    "wiz.next": "Next",
    "wiz.back": "Back",
    "wiz.finish": "Finish",
    "wiz.step_label": "Step {current} of {total}",
    "wiz.error_fetch": "Search failed. Please try again.",
    "wiz.success_crm": "Saved {count} leads to your CRM Kanban",
    "wiz.success_campaign": "Draft campaign created with these leads",
    "wiz.success_csv": "CSV with {count} leads downloaded",
    "wiz.campaign_name": "{type} prospects · {loc}",
    "wiz.campaign_subject": "A quick note for {type} businesses",
    // s0
    "wiz.s0_title": "What's your prospecting objective?",
    "wiz.s0_subtitle": "Choose a goal — we'll preset sources and parameters for you.",
    "wiz.s0_local_title": "Find local B2B businesses",
    "wiz.s0_local_body": "Roofing, HVAC, Plumbing, etc. near a city",
    "wiz.s0_validate_title": "Validate emails",
    "wiz.s0_validate_body": "Verify a list of contacts before outreach",
    "wiz.s0_decision_title": "Find decision-makers",
    "wiz.s0_decision_body": "Owners, GMs, Marketing Directors",
    "wiz.s0_bulk_title": "High-rating bulk list",
    "wiz.s0_bulk_body": "Top-rated, well-reviewed businesses in a sector",
    "wiz.s0_custom_title": "Custom",
    "wiz.s0_custom_body": "Build my own from scratch",
    // s1
    "wiz.s1_title": "Pick recommended sources",
    "wiz.s1_subtitle": "Combine multiple sources for better coverage. We'll dedupe automatically.",
    "wiz.s1_selected": "selected",
    // s2
    "wiz.s2_title": "Search parameters",
    "wiz.s2_subtitle": "Tell the engine what kind of business and where to look.",
    "wiz.s2_business": "Business type",
    "wiz.s2_business_placeholder": "e.g., Roofing, HVAC, Pest Control",
    "wiz.s2_location": "Location",
    "wiz.s2_radius": "Radius",
    "wiz.s2_score": "Lead temperature filter",
    "wiz.s2_score_any": "Any temperature",
    "wiz.s2_score_quente_morno": "QUENTE + MORNO only (≤66)",
    "wiz.s2_score_quente": "QUENTE only (≤33)",
    // s3
    "wiz.s3_title": "Review & run",
    "wiz.s3_subtitle": "We'll query Google Maps, deduplicate and score every lead.",
    "wiz.s3_run": "Run engine",
    "wiz.s3_running": "Searching, deduplicating and scoring leads…",
    "wiz.s3_done": "{count} qualified leads ready",
    "wiz.s3_source": "Source",
    // s4
    "wiz.s4_title": "Choose output",
    "wiz.s4_subtitle": "Where should we send your {count} leads?",
    "wiz.s4_crm_title": "Add to CRM Kanban",
    "wiz.s4_crm_body": "Each lead lands in 'New' column with score and audit ready",
    "wiz.s4_campaign_title": "Seed an email campaign",
    "wiz.s4_campaign_body": "Create a draft pre-filled with these leads",
    "wiz.s4_csv_title": "Download CSV",
    "wiz.s4_csv_body": "Spreadsheet with name, phone, website, score, etc.",

    // Products page
    "prod.greeting": "Hi, Reach Soul!",
    "prod.trial_left": "You have 14 days left in your Premium trial",
    "prod.view_plans": "View billing plans",
    "prod.title": "Products",
    "prod.search_placeholder": "Search AgenteLead",
    "prod.add_tooltip": "Add new product",
    "prod.add_product": "Add product",
    "prod.ai_tooltip": "AI quick action — pre-fill products from your top deals",
    "prod.help": "Help",
    "prod.notifications": "Notifications",
    "prod.nav_marketplace": "Marketplace",
    "prod.nav_automations": "Automations",
    "prod.nav_assignment": "Automatic assignment",
    "prod.nav_sequences": "Sequences",
    "prod.nav_documents": "Documents",
    "prod.nav_import": "Import data",
    "prod.nav_export": "Export data",
    "prod.nav_restore": "Restore data",
    "prod.products_count": "products",
    "prod.empty_title": "No matched products",
    "prod.empty_subtitle": "Try resetting your filter or view all products.",
    "prod.reset_filter": "Reset filter",
    "prod.view_all": "View all products",
    "prod.col_name": "Product",
    "prod.col_owner": "Owner",
    "prod.col_sku": "SKU",
    "prod.draft_name": "New product · {date}",
    "prod.created": "Product created: {name}",
    "prod.create_failed": "Failed to create product",

    // ── Tutorials Center ("Aprenda a usar") ─────────────────────────
    "tut.nav.title": "Learn to use",
    "tut.page.title": "Learn to use AgenteLead Pro",
    "tut.page.subtitle": "Short tutorials for every block in the app.",
    "tut.search.placeholder": "Search by tool or task…",
    "tut.filter.all": "All",
    "tut.filter.discovery": "Discovery",
    "tut.filter.outreach": "Outreach",
    "tut.filter.pipeline": "Pipeline",
    "tut.filter.analytics": "Analytics",
    "tut.filter.specialty": "Specialty",
    "tut.filter.onboarding": "Start here",
    "tut.status.not_started": "Not started",
    "tut.status.in_progress": "In progress",
    "tut.status.completed": "Completed",
    "tut.card.duration": "{sec}s",
    "tut.card.go": "Open tool",
    "tut.card.watch": "Watch tutorial",
    "tut.card.prereq": "Prerequisites",
    "tut.section.objective": "Objective",
    "tut.section.when": "When to use",
    "tut.section.prep": "Preparation",
    "tut.section.demo": "Demonstration",
    "tut.section.result": "Result",
    "tut.section.next": "Next action",
    "tut.section.steps": "Step by step",
    "tut.section.success": "How to know it worked",
    "tut.section.errors": "Common errors",
    "tut.section.transcript": "Transcript",
    "tut.mark.done": "Mark as completed",
    "tut.mark.undo": "Undo completion",
    "tut.feedback.q": "Did this tutorial help?",
    "tut.feedback.yes": "Yes",
    "tut.feedback.no": "No",
    "tut.feedback.thanks": "Thanks for your feedback!",
    "tut.production.status": "Production status",
    "tut.production.script_ready": "Script ready — video pending",
    "tut.production.in_production": "Video in production",
    "tut.production.review": "Awaiting review",
    "tut.production.published": "Published",
    "tut.player.pending": "Video pending. Follow the illustrated step-by-step below meanwhile.",
    "tut.help.button": "How to use",
    "tut.help.tooltip": "Watch a short tutorial about this block",
    "tut.help.float": "Help",
    "tut.recommended": "Recommended path",
    "tut.start.here": "Start here",
    "tut.updated": "Last reviewed",
  },

  pt: {
    "lang.toggle": "EN",
    "sidebar.subtitle": "FIND. ENGAGE. GROW.",
    "sidebar.footer": "v1.0 — Módulo de Prospecção",

    // ── Iter313 · Vehicle Security Map (VS Map) ─────────────────────
    "vsm.tier": "Tier",
    "vsm.flock_alpr": "Flock/ALPR",
    "vsm.flock": "Flock",
    "vsm.tier.all": "Todos",
    "vsm.tier.critical": "Critical",
    "vsm.tier.very_high": "V. High",
    "vsm.tier.high": "High",
    "vsm.tier.medium": "Medium",
    "vsm.tier.low": "Low",
    "vsm.flock.all": "Todos",
    "vsm.flock.only": "Só Flock",
    "vsm.flock.exclude": "Excluir Flock",
    "vsm.leads_count": "{count}/{total} leads",
    "vsm.address_placeholder": "Endereço, cidade ou bairro (ex: Dr. Phillips, Orlando)",
    "vsm.radius": "Raio",
    "vsm.radius.off": "Off",
    "vsm.radius.clear": "Limpar raio",
    "vsm.route.optimizer": "Roteirizador",
    "vsm.route.optimize": "Roteirizar {n} paradas",
    "vsm.route.navigate": "Navegar no Google Maps",
    "vsm.route.hint": "Ordem otimizada por proximidade (nearest-neighbor)",
    "vsm.osm_loading": "Carregando limites reais dos bairros (OpenStreetMap)…",
    "vsm.geocoding": "Geocodificando…",
    "vsm.privacy.city": "Modo Cidade",
    "vsm.privacy.exact": "Endereço Exato",
    "vsm.privacy.city_title": "Modo cidade (privacidade preservada)",
    "vsm.privacy.exact_title": "Modo endereço exato (uso interno)",
    "vsm.privacy.master_required": "Endereço exato requer perfil MASTER",
    "vsm.legend": "Legenda",
    "vsm.footer.city_mode": "Modo Cidade: pins agregados no bairro/cidade (endereço não exposto)",
    "vsm.info.est_contract": "Contrato est.:",
    "vsm.info.details": "Ver detalhes",
    "vsm.info.street_view": "Street View",
    "vsm.info.street_view_open": "Abrir Street View",
    "vsm.empty": "Nenhum lead encontrado com os filtros atuais.",
    "vsm.missing_key": "Google Maps API key ausente. Configure REACT_APP_GOOGLE_MAPS_API_KEY.",

    // ── Iter314 · Vehicle Security page body ────────────────────────
    "vs.disclaimer_loading": "Carregando aviso regulatório…",
    "vs.google_ads": "Google Ads",
    "vs.google_ads_sub": "Keywords + Negativos",
    "vs.google_ads_title": "Google Ads: pacotes de keywords + negativos por segmento",
    "vs.reg_watch": "Vigilância Regulatória",
    "vs.reg_items_tracked": "{n} itens monitorados",
    "vs.reg_open": "Abrir",
    "vs.kpi.total_leads": "Total de Leads",
    "vs.kpi.critical": "Crítico (90+)",
    "vs.kpi.high_opportunity": "Alta Oportunidade (80+)",
    "vs.kpi.existing_cctv": "CCTV Existente",
    "vs.kpi.existing_alpr": "ALPR Existente",
    "vs.kpi.guard_house": "Guarita",
    "vs.kpi.security_officers": "Vigilantes",
    "vs.kpi.multi_entrance": "Múltiplas Entradas",
    "vs.kpi.large_parking": "Estacionamento Grande",
    "vs.kpi.theft_risk": "Risco de Roubo",
    "vs.kpi.replacement_alpr": "Substituição ALPR",
    "vs.kpi.cross_sell": "Cross-Sell",
    "vs.kpi.active": "Ativo",
    "vs.kpi.clear_filter": "Limpar filtro",
    "vs.kpi.filter_by": "Filtrar leads por: {label}",
    "vs.kpi.no_matches": "Nenhum lead correspondente",
    "vs.pipeline_label": "Pipeline Estimado de Tecnologia",
    "vs.pipeline_footer": "+ monitoramento / rondas / vigilantes recorrentes",
    "vs.header.title": "Smith SecureVehicle™",
    "vs.header.subtitle": "Inteligência de Veículos & Segurança Patrimonial · Saiba quem entra na sua propriedade.",

    // ── Iter314 · Smith Outreach main surface ───────────────────────
    "so.header.title": "Smith · Outreach AI",
    "so.header.subtitle": "{n} contatos · Claire redige · Resend envia",
    "so.btn.replies": "Respostas",
    "so.btn.sender": "Remetente",
    "so.btn.sender_title": "Configurar identidade de envio (Marcelo Borges @ smithprotective.com)",
    "so.btn.nudge": "Nudge SMS",
    "so.btn.nudge_title": "Auto-Nudge SMS 48h — SMS automático quando email não é aberto em 48h",
    "so.btn.dedupe": "Dedupe",
    "so.btn.dedupe_title": "Limpar emails/prospects duplicados",
    "so.btn.refresh": "Atualizar",
    "so.btn.imports": "Imports",
    "so.btn.imports_title": "Import Hub — templates e mídia",
    "so.tab.compose": "Compor",
    "so.tab.drafts": "Rascunhos",
    "so.tab.contacts": "Contatos",
    "so.tab.templates": "Templates",
    "so.tab.sent": "Enviados",
    "so.tab.retry": "Fila de Retry",
    "so.tab.analytics": "Analytics",
    "so.bucket.available": "Com email",
    "so.bucket.missing": "Sem email",
    "so.bucket.unresolvable": "Repositório",
    "so.search_placeholder": "Buscar nome, email ou empresa",
    "so.filter.advanced_title": "Filtros avançados",
    "so.filter.source_any": "Toda fonte",
    "so.filter.tier_any": "Todos tiers",
    "so.filter.tier_hot": "🔥 Hot",
    "so.filter.tier_high": "🟢 High",
    "so.filter.tier_qualified": "🟡 Qualified",
    "so.filter.tier_nurture": "🔵 Nurture",
    "so.filter.hide_no_email": "Ocultar leads sem e-mail",
    "so.filter.hide_no_email_hint": "(leads sem e-mail nunca são disparados)",
    "so.filter.only_failed": "Só falhados / bloqueados",
    "so.contacts.empty": "Nenhum contato encontrado com esses filtros.",
    "so.contacts.loading_discovery": "Claire está buscando emails na cascata Apollo → Hunter → Apify → Heurística…",
    "so.bulk.select_visible": "Selecionar visíveis",
    "so.bulk.clear": "Limpar",
    "so.bulk.action": "Bulk",
    "so.footer.count": "{shown} de {total} contatos",
    "so.empty.title": "Selecione um contato para começar",
    "so.empty.body": "Clique em qualquer contato à esquerda — a Claire vai redigir uma carta de apresentação personalizada da Smith Protective baseada no cargo, empresa e segmento do lead.",
    "so.recipient.to": "Para",
    "so.recipient.no_name": "(sem nome)",
    "so.recipient.find_email": "Buscar email com IA",
    "so.recipient.finding": "Buscando…",
    "so.recipient.find_email_title": "Rodar Apollo → Hunter → Apify → Website scrape para descobrir o email deste decision-maker",
    "so.tone.prefix": "Tom",
    "so.tone.consultative": "Consultivo",
    "so.tone.urgent": "Urgente",
    "so.tone.empathetic": "Empático",
    "so.tone.roi": "ROI (números)",
    "so.lang.current": "Idioma atual",
    "so.lang.translate_to": "Traduzir para {label}",
    "so.regenerate": "Regerar",
    "so.regenerating": "Gerando…",
    "so.templates.title": "Templates",
    "so.templates.empty": "Nenhum template ainda. Depois de compor uma carta que você goste, clique em Salvar como template.",
    "so.templates.delete": "Excluir",
    "so.save_template": "Salvar como template",
    "so.save_template_title": "Salvar draft atual como template reutilizável",
    "so.subject.label": "Assunto",
    "so.subject.placeholder": "Assunto do email",
    "so.subject.counter": "{n}/78 caracteres",
    "so.tool.bold": "Negrito (Ctrl+B)",
    "so.tool.italic": "Itálico",
    "so.tool.underline": "Sublinhado",
    "so.tool.list": "Lista com marcadores",
    "so.spellcheck": "Revisar Ortografia",
    "so.spellchecking": "Revisando…",
    "so.toolbar_hint": "Editor rich-text · Ctrl+B/I/U · listas · spellcheck manual",
    "so.editor.generating": "Claire está redigindo com o tom \u201c{tone}\u201d…",
    "so.changes.title": "{n} correção(ões) aplicada(s)",
    "so.attach": "Anexar arquivo",
    "so.attaching": "Enviando…",
    "so.attach_hint": "PDF, PPT, DOCX, XLS, imagens · máx 15 MB cada",
    "so.signature.custom_active": "Assinatura personalizada ativa",
    "so.signature.edit": "Editar assinatura",
    "so.signature.title": "Editar / importar assinatura rica com logo, links e formatação",
    "so.banner.sent_ok": "E-mail enviado com sucesso para {email}",
    "so.banner.retry": "Tentar novamente",
    "so.send.last_sent": "Enviado {at}",
    "so.send.enroll": "Enroll",
    "so.send.enroll_title": "Inscrever contato em uma cadência",
    "so.send.enroll_missing": "Crie uma cadência em /smith/sequences primeiro",
    "so.send.enroll_pick": "Selecione uma cadência",
    "so.send.manage_cadences": "+ Gerenciar cadências",
    "so.send.button": "Enviar via Resend",
    "so.send.sending": "Enviando…",
    "so.recipient.recipient_bracket": "\u003c{email}\u003e",
    "so.badge.sent": "Enviado",
    "so.badge.unverified": "Não confirmado",
    "so.badge.unverified_title": "Email não confirmado publicamente — pode falhar. Sources verificados: Apollo/Hunter.",
    "so.badge.blocked": "Bloqueado",
    "so.badge.blocked_title": "Este contato está na blacklist. Remova em /smith/blacklist para reenviar.",
    "so.badge.champion": "Champion",
    "so.badge.champion_title": "Champion desde {date} — 2+ replies detectadas",
    "so.badge.delete_unverified": "Excluir este lead não confirmado",
    "so.badge.flag_add": "Sinalizar contato",
    "so.badge.flag_remove": "Remover sinalização",
    "so.enrich_turbo": "Enriquecer com Turbo",
    "so.enrich_turbo_title": "Rodar Apollo → Hunter → Apify (Turbo) em todos os leads ocultos para tentar preencher os e-mails faltantes",
    "so.enrich_hidden_show": "Mostrar",
    "so.enrich_hidden_hide": "Ocultar",
    "so.hidden_noemail_banner": "{n} lead(s) sem e-mail ocultos automaticamente",
    "so.autoclean.title": "Auto-Cleanup Cron",
    "so.autoclean.next_run": "· próximo diário 03:00 UTC",
    "so.autoclean.eligible": "elegíveis",
    "so.autoclean.last_run": "Última: {date} ({n} apagados)",
    "so.autoclean.candidates": "Candidatos",
    "so.autoclean.eligible_label": "Elegíveis",
    "so.autoclean.skipped": "Skip (safety)",
    "so.autoclean.criteria": "Critério: ≥3 tentativas falhadas / bounced / blocked / skipped e zero envios bem-sucedidos. Prospects com histórico de envio ou fora do pipeline seguro (New Prospect / Researching / Junk) são preservados automaticamente.",
    "so.autoclean.dry_run": "Rodar Agora (dry-run)",
    "so.autoclean.running_dry": "Rodando…",
    "so.autoclean.run_live": "Executar limpeza",
    "so.autoclean.running_live": "Executando…",
    "so.autoclean.live_title": "Requer Super Admin. Executa a limpeza real.",
    "so.autoclean.refresh": "↻ Atualizar",
    "so.tab.contacts.title": "Diretório de contatos",
    "so.tab.contacts.subtitle": "{n} decision-makers agregados de Apollo/Hunter/Sunbiz/Import",
    "so.tab.contacts.bulk_find": "Buscar emails em lote",
    "so.tab.contacts.bulk_find_title": "Roda find-email nos prospects sem contato (Apollo → Hunter → web-scrape)",
    "so.tab.contacts.bulk_processed": "{n} processados",
    "so.tab.contacts.bulk_progress": "Bulk find-email em andamento — {done} processados · {found} novos emails",
    "so.tab.contacts.empty": "Nenhum contato — importe uma planilha ou rode Apollo/Hunter em /smith/prospects.",
    "so.tab.contacts.showing_of": "Mostrando 200 de {total} — use a página completa para paginação/export.",
    "so.tab.contacts.compose": "Compose",
    "so.cleanup.clear_n": "Limpar {n}",
    "so.cleanup.cleaning": "Limpando…",
    "so.cleanup.title": "Excluir permanentemente todos os leads falhados/bloqueados/sem-email",

    // ── Iter317 · Sequences page ────────────────────────────────────
    "seq.header.title": "Smith · Sequences",
    "seq.header.subtitle": "{n} cadências · {active} inscrições ativas · Cron 15 min",
    "seq.btn.refresh": "Atualizar",
    "seq.btn.run_now": "Rodar agora",
    "seq.btn.run_now_title": "Disparar sweep manual — envia todos os steps vencidos agora",
    "seq.btn.new": "Nova cadência",
    "seq.list.title": "Cadências",
    "seq.list.empty": "Nenhuma cadência ainda. Clique em Nova cadência pra criar.",
    "seq.card.day": "Dia {n}",
    "seq.card.active_pill": "{n} ativos",
    "seq.card.edit": "Editar",
    "seq.card.stats_active": "Ativos",
    "seq.card.stats_completed": "Completos",
    "seq.card.stats_stopped": "Parados",
    "seq.enroll.title": "Inscrições ({n})",
    "seq.enroll.empty_prefix": "Nenhum prospect inscrito. Vá até",
    "seq.enroll.empty_link": "Outreach AI",
    "seq.enroll.empty_suffix": ", escolha um contato e clique em Enroll.",
    "seq.enroll.step": "step {n}",
    "seq.enroll.next": "próx {at}",
    "seq.editor.title_new": "Nova cadência",
    "seq.editor.title_edit": "Editar cadência",
    "seq.editor.name": "Nome",
    "seq.editor.description": "Descrição",
    "seq.editor.steps": "Steps",
    "seq.editor.add_step": "Adicionar",
    "seq.editor.days": "dias",
    "seq.editor.stop_on_reply": "Parar automaticamente quando o prospect responder",
    "seq.editor.cancel": "Cancelar",
    "seq.editor.save": "Salvar",
    "seq.toast.no_templates": "Você precisa criar pelo menos 1 template no Outreach AI antes.",
    "seq.toast.name_min": "Nome mínimo 2 caracteres.",
    "seq.toast.updated": "Sequência atualizada",
    "seq.toast.created": "Sequência criada",
    "seq.toast.deleted": "Excluída",
    "seq.toast.stopped": "Parada",
    "seq.toast.sweep_ok": "Sweep executado: {sent} enviados, {stopped} parados, {picked} escolhidos",
    "seq.toast.load_failed": "Falha ao carregar sequências",
    "seq.toast.save_failed": "Falha ao salvar",
    "seq.toast.delete_failed": "Falha ao excluir",
    "seq.toast.sweep_failed": "Falha no sweep",
    "seq.confirm.delete": "Excluir \"{name}\"? Só funciona se não houver inscrições ativas.",
    "seq.confirm.stop": "Parar cadência do prospect \"{name}\"?",
    "seq.confirm.run_now": "Rodar sweep manual agora? Vai disparar emails reais para todos os enrollments elegíveis (step vencido).",
    "seq.step.initial": "Inicial",
    "seq.step.follow": "Follow #{n}",
    "seq.step.last": "Última",
    "seq.status.active": "Ativa",
    "seq.status.completed": "Completa",
    "seq.status.stopped_reply": "Respondeu",
    "seq.status.stopped_manual": "Parada",
    "seq.status.stopped_pipeline": "Won/Lost",

    // ── Iter319 · Delivery chip statuses (Resend) ───────────────────
    "so.deliv.queued": "Fila",
    "so.deliv.sent": "Enviado",
    "so.deliv.delivered": "Entregue",
    "so.deliv.opened": "Aberto",
    "so.deliv.clicked": "Clicou",
    "so.deliv.bounced": "Bounce",
    "so.deliv.complained": "Spam",
    "so.deliv.failed": "Falhou",
    "so.deliv.sandbox": "Sandbox",
    "so.deliv.skipped": "Ignorado",
    "so.deliv.tooltip": "Status Resend: {label}",

    "vs.geo.title": "Central Florida — Cobertura de Vehicle Security",
    "vs.geo.summary": "{cities} cidades · {leads} leads",
    "vs.geo.critical_extra": "· {n} críticos",
    "vs.geo.refresh": "Atualizar",
    "vs.discovery.title": "Vehicle Security Discovery",
    "vs.discovery.subtitle": "Busca OpenAI + cruzamento com CRM Smith",
    "vs.discovery.city": "Cidade",
    "vs.discovery.state": "Estado",
    "vs.discovery.openai": "Busca OpenAI",
    "vs.discovery.crm": "Cruzar CRM",
    "vs.discovery.run": "Rodar Discovery",
    "vs.discovery.running": "Descobrindo…",
    "vs.discovery.segments_hint": "Segmentos — escolha 1-3 para melhor custo (cada = 1 web_search OpenAI)",
    "vs.discovery.copy_link": "Copiar link",
    "vs.discovery.copy_link_title": "Copia a URL com os segmentos + cidade selecionados para compartilhar com outro rep",
    "vs.discovery.link_copied": "Link com filtro copiado — cole para compartilhar",
    "vs.discovery.link_copy_failed": "Não foi possível copiar. Copie da barra de URL.",
    "vs.leads.section_title": "Leads de Vehicle Security",
    "vs.leads.count": "· {shown}/{total} leads",
    "vs.leads.filter_prefix": "(filtro: {seg})",
    "vs.leads.radius_label": "· raio {miles}mi",
    "vs.leads.route_label": "· rota otimizada",
    "vs.filter.tier_all": "Todos os tiers",
    "vs.filter.tier_critical": "🔥 Crítico (90+)",
    "vs.filter.tier_very_high": "🟠 Muito Alto (80-89)",
    "vs.filter.tier_high": "🟡 Alto (70-79)",
    "vs.filter.tier_medium": "🔵 Médio (60-69)",
    "vs.filter.tier_low": "⚪ Baixo (<60)",
    "vs.filter.flock_all": "Todos ALPR",
    "vs.filter.flock_only": "Só com Flock",
    "vs.filter.flock_exclude": "Excluir Flock",
    "vs.tbl.property": "Propriedade",
    "vs.tbl.segment": "Segmento",
    "vs.tbl.score": "Score",
    "vs.tbl.signals": "Sinais",
    "vs.tbl.opportunity": "Oportunidade Estimada",
    "vs.tbl.status": "Status",
    "vs.tbl.actions": "Ações",
    "vs.tbl.loading": "Carregando…",
    "vs.tbl.empty_run_discovery": "Nenhum lead ainda — rode Discovery acima para começar.",
    "vs.tbl.empty_filters": "Nenhum lead corresponde aos filtros ativos (tier / Flock / raio no mapa).",
    "vs.tbl.unknown_signals": "Desconhecido",
    "vs.tbl.status_new": "Novo",
    "vs.tbl.stop_title": "Parada #{n} na rota otimizada",
    "vs.action.view_sources": "Ver Fontes",
    "vs.action.open_details": "Abrir detalhes",


    // ── Iter313 · Claire Widget ─────────────────────────────────────
    "claire.config_required": "Configuração necessária",
    "claire.open_integrations": "Abrir Integrações",
    "claire.close": "Fechar",
    "claire.reset": "Reiniciar conversa",
    "claire.engine": "Motor",
    "claire.engine.deep": "Deep",
    "claire.engine.fast": "Fast",
    "claire.engine.deep_title": "Claude Sonnet 5 — raciocínio profundo (~3s)",
    "claire.engine.fast_title": "Perplexity Sonar Pro — pesquisa web, respostas rápidas",
    "claire.typing": "Claire está digitando…",
    "claire.voice.hint": "Ajuste o texto se a Claire ouviu errado, depois toque em enviar.",
    "claire.voice.clear": "Limpar",
    "claire.whatsapp": "Falar com humano no WhatsApp",

    // ── Iter313 · Sidebar extras ────────────────────────────────────
    "sidebar.brand": "AgenteLead Pro",
    "sidebar.switch_persona": "Trocar persona",
    "sidebar.loading": "Carregando…",
    "sidebar.personas_failed": "Falha ao carregar personas",
    "sidebar.logged_as": "Logado como:",
    "sidebar.role": "Perfil:",
    "sidebar.role_not_admin": "Seu perfil NÃO está no grupo admin. Contate um super-admin para upgrade.",
    "sidebar.retry": "Tentar novamente",
    "sidebar.demo_seed_prompt": "Ainda sem contas demo — crie as 5 padrão com 1 clique:",
    "sidebar.demo_profiles": "Perfis Demo",
    "sidebar.demo_open": "Abrir",
    "sidebar.demo_magic": "Magic",
    "sidebar.demo_manage": "Gerenciar perfis →",
    "sidebar.demo_seeded_toast": "Contas demo criadas",
    "sidebar.no_token_toast": "Token não retornado",
    "sidebar.new_24h": "Novos nas últimas 24h",

    // ── Iter313 · Header + Mobile drawer extras ─────────────────────
    "header.theme": "Tema",
    "header.language": "Idioma",
    "header.help": "Ajuda",
    "header.open_nav": "Abrir navegação",
    "header.open_menu": "Abrir menu",
    "mobile.close_menu": "Fechar menu",
    "mobile.nav_label": "Navegação mobile",
    "mobile.scrapers_title": "Scrapers",
    "mobile.smith_title": "Smith Protective",
    "btn.go": "Ir",
    "vsm.exact_mode_hint": "Modo endereço exato ativo — geocoding via Google. Apenas para uso interno da equipe de vendas.",
    "vsm.city_mode_hint": "Modo Cidade: pins agregados no bairro/cidade. Endereços exatos ficam ocultos por padrão.",
    "settings.language.title": "Idioma / Language",
    "settings.language.description": "Escolha o idioma que quer usar no app. A preferência sincroniza entre dispositivos.",
    "settings.language.current": "Atual",
    "settings.language.preview": "Prévia",
    "settings.language.unsaved": "Mudança pendente — clique Salvar para aplicar",
    "lang.saved": "Preferência de idioma salva",
    "lang.saved_local": "Salvo localmente (backend indisponível)",
    "lang.picker_open": "Trocar idioma",
    "lang.picker_title": "Idioma",
    "lang.picker_settings": "Configurações de idioma",
    "btn.save": "Salvar",
    "btn.saving": "Salvando…",
    "signup.language_auto": "Detectamos seu idioma no navegador: {lang}",
    "signup.language_change": "Trocar",

    "sidebar.collapse": "Recolher",
    "sidebar.expand": "Expandir menu",
    "sidebar.agency_dashboard": "Dashboard da Agência",
    "sidebar.saas_configurator": "Auto Pilot",
    "sidebar.prospecting": "Lead Discovery",
    "sidebar.integrations": "Integrações",
    "sidebar.kanban": "CRM Kanban",
    "sidebar.gov_kanban": "Gov · Obras Públicas",
    "sidebar.funnel": "Funil de Vendas",
    "sidebar.campaigns": "Campanhas",
    "sidebar.insights": "Insights",
    "sidebar.roi": "ROI",
    "sidebar.marketing_apis": "APIs de Marketing",
    "sidebar.products": "Produtos",
    "sidebar.webhooks": "Webhooks",
    "sidebar.free_sources": "Fontes Gratuitas",
    "sidebar.activity_log": "Log de Atividades",
    "sidebar.affiliate_portal": "Portal de Afiliados",
    "sidebar.library": "Biblioteca",
    "sidebar.b2c_intent": "B2C Intent & Social Listening",
    "sidebar.b2c_radar": "B2C Lead Radar",
    "sidebar.b2c_group": "B2C",
    "sidebar.gov_group": "Governo",
    "sidebar.account": "Conta",
    "sidebar.support": "Suporte",
    "sidebar.sunbiz": "Sunbiz Connector",
    "sidebar.multi_state": "Multi-State Capture",
    "sidebar.no_website": "Leads Sem Website",
    "sidebar.yelp": "Yelp Finder",
    "sidebar.auto_cruise": "Auto-Cruise",
    "sidebar.lead_gap": "Lead Gap Intelligence",
    "sidebar.instagram": "Instagram Scraper",
    "sidebar.linkedin": "LinkedIn Sales Nav",
    "sidebar.youtube": "YouTube Scraper",
    "sidebar.replies": "AI Replies Inbox",
    "sidebar.scrapers": "Scrapers",
    "sidebar.saas_education": "Educação SaaS",
    "sidebar.mobile_app": "App Mobile",
    "sidebar.app_marketplace": "Marketplace de Apps",
    "sidebar.billing": "Cobrança",
    "sidebar.upgrade": "UPGRADE",
    "sidebar.public_works": "Procurement Scanner",
    "sidebar.gc_leaderboard": "Ranking de Empreiteiras",
    "sidebar.product_catalog": "Catálogo de Produtos",
    "sidebar.leads_finder": "Leads Finder",
    "sidebar.leads_map": "Mapa de Leads",
    "sidebar.more": "Mais",
    "sidebar.logout": "Sair",
    "sidebar.extended_dash": "Dashboard Estendido",

    "header.back": "Voltar para Contas de Prospecção",
    "header.title": "Encontre leads locais, gere auditorias e envie ao CRM",
    "header.add_manual": "Adicionar negócio virtualmente",

    "search.business_placeholder": "Tipo de Negócio — ex.: Pest Control, Roofing, HVAC…",
    "search.category_label": "Categoria",
    "search.category_all": "Todas",
    "search.location_placeholder": "ex.: Orlando FL 32801",
    "search.structured_show": "Escolher Cidade · Estado · CEP",
    "search.structured_hide": "Ocultar seletor estruturado",
    "search.state_all": "Todos os estados",
    "search.city_all": "Todas as cidades",
    "search.city_empty": "Sem cidades salvas ainda",
    "search.zip_all": "Todos os CEPs",
    "search.zip_empty": "Sem CEPs salvos ainda",
    "search.button": "Buscar",
    "search.unit_km": "KM",
    "search.unit_mi": "Milhas",
    "search.status_all": "Todos",
    "search.status_open": "Abertos agora",
    "search.status_label": "Status:",
    "search.types_builtin": "Tipos padrão",
    "search.types_custom": "Personalizados",
    "search.types_add_option": "+ Adicionar novo tipo de negócio…",
    "search.types_add_placeholder": "ex.: Limpeza de Painéis Solares",
    "search.types_save": "Salvar",
    "search.types_delete": "Remover tipo personalizado",
    "search.type_too_short": "O nome precisa de pelo menos 2 caracteres",
    "search.type_added": "Adicionado: {name}",
    "search.type_add_failed": "Falha ao adicionar tipo de negócio",
    "search.type_deleted": "Removido: {name}",
    "search.type_delete_failed": "Falha ao remover",
    "search.type_delete_confirm": "Remover '{name}' dos seus tipos de negócio? Os leads já salvos mantêm este nicho.",
    "search.advanced": "Avançado",
    "search.adv_rating_min": "Avaliação mín.",
    "search.adv_reviews_min": "Reviews mín.",
    "search.adv_score_max": "Score máx. (mais quente)",
    "search.adv_has_website": "Tem site?",
    "search.adv_any": "Qualquer",
    "search.adv_yes": "Sim",
    "search.adv_no": "Não",
    "search.adv_only_quente": "Só QUENTE (≤33)",
    "search.adv_quente_morno": "QUENTE+MORNO (≤66)",
    "search.adv_reset": "Resetar filtros avançados",

    "empty.title": "Descubra leads quentes ao seu redor!",
    "empty.body": "Importe negócios reais do Google Maps — sem scrapers ou planilhas. Salve leads, gere auditorias e dispare automações de outreach. Já tem um lead?",
    "empty.body_link": "Adicione manualmente.",

    "lead.score_label": "Score Digital",
    "lead.save_crm": "Salvar no CRM",
    "lead.similar": "Similares",
    "lead.similar_tooltip": "Ver leads similares no seu CRM",
    "lead.sequence": "Iniciar Sequência",
    "lead.sequence_tooltip": "Disparar uma sequência de cold-email multi-step",
    "outreach.config_button": "Config Email",
    "lead.run_audit": "Rodar Auditoria",
    "lead.send_email": "Enviar Email",
    "lead.view_maps": "Ver no Maps",
    "lead.found": "leads encontrados",
    "lead.found_subtitle": "Ordenado por relevância · Score menor = lead mais quente",
    "lead.no_results": "Nenhum lead encontrado. Tente outro tipo de negócio.",

    "status.open": "Aberto",
    "status.closed": "Fechado",
    "status.operational": "Operacional",

    "toast.found": "{count} leads encontrados",
    "toast.found_filtered": "{count} leads encontrados ({hidden} ocultos por filtros)",
    "toast.saved": "Lead salvo no AgenteLead Pro!",
    "toast.search_failed": "Falha na busca. Tente novamente.",
    "toast.save_failed": "Falha ao salvar lead",
    "toast.audit_failed": "Auditoria falhou. Verifique sua LLM key.",
    "toast.email_failed": "Geração de email falhou.",
    "toast.business_added": "Negócio adicionado ao CRM!",
    "toast.business_failed": "Falha ao adicionar negócio",

    "dash.title": "Dashboard da Agência",
    "dash.subtitle": "Visão geral · KPIs · Fontes gratuitas de leads",
    "dash.refresh": "Atualizar",
    "dash.last_updated": "Última atualização",
    "dash.notifications": "Notificações",
    "dash.notif_empty": "Nenhuma menção HOT agora — silêncio é bom sinal.",
    "dash.notif_hot": "menções HOT nas últimas 24h.",
    "dash.notif_see": "Ver em B2C Intent",
    "header.admin": "Admin · Biblioteca",
    "dash.kpi.saved": "Leads Salvos",
    "dash.kpi.saved_sub": "Total no CRM",
    "dash.kpi.score": "Score Digital Médio",
    "dash.kpi.score_sub": "Menor = mais oportunidade",
    "dash.kpi.hot": "Leads Quentes (QUENTE)",
    "dash.kpi.hot_sub_zero": "—",
    "dash.kpi.activity": "Eventos de Atividade",
    "dash.kpi.activity_sub": "Últimas ações registradas",
    "dash.distrib_title": "Distribuição por temperatura",
    "dash.distrib_empty": "Nenhum lead salvo ainda. Vá ao Prospecting e clique em Salvar no CRM.",
    "dash.top_sectors": "Top setores no CRM",
    "dash.activity_by_type": "Atividade por tipo",
    "dash.no_data": "Sem dados ainda.",
    "dash.no_records": "Sem registros ainda.",
    "dash.integrations_title": "🔌 Integração com Ferramentas Existentes",
    "dash.integrations_subtitle": "ferramentas — execute para automatizar fluxos",
    "dash.integrations_col_tool": "Ferramenta",
    "dash.integrations_col_cat": "Categoria",
    "dash.integrations_col_desc": "Integração com Dashboard",
    "dash.integrations_col_status": "Status",
    "dash.integrations_col_action": "Ação",
    "dash.execute": "Executar",
    "dash.free_sources_title": "💡 Fontes Gratuitas de Geração de Leads",
    "dash.free_sources_subtitle_pre": "fontes · Atualizado em",
    "dash.free_sources_curated": "Lista curada",
    "dash.captured_title": "📦 Leads Captados por Tipo de Negócio",
    "dash.captured_subtitle": "Leads salvos agrupados por setor",
    "dash.captured_empty": "Nenhum lead salvo ainda. Use a Prospecting para começar a captar.",
    "dash.captured_show": "Ver leads",
    "dash.captured_hide": "Ocultar leads",
    "dash.enrich_button": "Re-enriquecer",
    "dash.enrich_running": "Enriquecendo…",
    "dash.enrich_button_tooltip": "Re-scrapeia o site do lead para atualizar sinais sociais e recalcular o score digital.",
    "dash.enrich_no_website_tooltip": "Sem website cadastrado — impossível re-enriquecer.",
    "dash.enrich_last": "Enriquecido · {at}",
    "dash.enrich_pending": "Ainda não enriquecido",
    "dash.enrich_no_site_label": "Sem website",
    "dash.enrich_success": "{name} re-enriquecido · score {score} · {badge}",
    "dash.enrich_no_website": "{name} não tem website cadastrado",
    "dash.enrich_failed": "Falha ao enriquecer {name}: {reason}",
    "dash.enrich_not_found": "Lead não encontrado no banco",
    "dash.activity_link_tooltip": "Ver eventos {label} no Log de Atividades",
    "dash.kpi_link_tooltip": "Clique para detalhar",
    "dash.funnel_title": "Funil de Conversão de Leads",
    "dash.funnel_subtitle": "Cada etapa mostra os eventos totais e a conversão em relação à etapa anterior",
    "dash.funnel_step_search": "Buscar",
    "dash.funnel_step_save": "Salvar no CRM",
    "dash.funnel_step_audit": "Rodar Auditoria",
    "dash.funnel_step_email": "Gerar Email",
    "dash.funnel_step_enrich": "Re-enriquecer",
    "dash.funnel_conv_label": "vs anterior",
    "dash.funnel_drilldown_tooltip": "Abrir Log de Atividades filtrado por {step}",
    "dash.funnel_empty": "Realize buscas e saves para popular o funil.",

    "fs.col_num": "#",
    "fs.col_name": "Nome da Fonte",
    "fs.col_type": "Tipo",
    "fs.col_credits": "Créditos / Mês",
    "fs.col_extracts": "O que extrai",
    "fs.col_how": "Como usar",
    "fs.col_open": "Abrir",
    "fs.page_title": "Fontes Gratuitas de Geração de Leads",
    "fs.page_subtitle": "Diretórios públicos e APIs gratuitas para captar leads a custo zero",

    // Kanban
    "kanban.title": "CRM Kanban",
    "kanban.subtitle": "leads no pipeline",
    "kanban.col.NEW": "Novo",
    "kanban.col.CONTACTED": "Contactado",
    "kanban.col.QUALIFIED": "Qualificado",
    "kanban.col.PROPOSAL": "Proposta",
    "kanban.col.WON": "Ganho",
    "kanban.col.LOST": "Perdido",
    "kanban.empty": "Vazio por enquanto",
    "kanban.move_to": "Mover para",
    "kanban.dedup_label": "mesclados",
    "kanban.dedup_tooltip": "Este lead absorveu duplicatas de re-saves",
    "kanban.search_placeholder": "Buscar pelo nome da empresa…",
    "kanban.filter_temp_all": "Todas as temperaturas",
    "kanban.filter_sector_all": "Todos os nichos",
    "kanban.no_results": "Nenhum lead corresponde aos filtros atuais.",
    "kanban.stale_tooltip": "Parado: há {days} dias na mesma coluna",
    "kanban.status_age_tooltip": "Nesta coluna há {days} dias",
    "kanban.today": "hoje",
    "kanban.d_ago": "{days}d",
    "kanban.last_email_tooltip": "Último email há {days}d · {count} toques no total",
    "kanban.silent_tooltip": "Está em status contatado mas sem email registrado — chegou a mandar algo?",
    "kanban.silent_label": "sem email",
    "kanban.filter_silent": "Leads sem contato",
    "kanban.filter_silent_tooltip": "Mostrar só leads sem email registrado (colunas CONTACTED+)",
    "kanban.followup_tooltip": "Próximo follow-up: {date}",
    "kanban.followup_overdue": "Follow-up atrasado ({date})",
    "kanban.score_tooltip": "Lead Score: {score}/100 — menor = mais quente",
    "kanban.lookalike_seed_won": "Buscar similares a este Ganho",
    "kanban.drag_hint": "Arraste um card para outra coluna para atualizar o status",
    "kanban.meta_check_label": "Ver Meta Ads",
    "kanban.meta_check_tooltip": "Clique para checar se esta empresa está rodando anúncios no Facebook/Instagram agora (cache 24h)",
    "kanban.meta_checking": "Buscando…",
    "kanban.meta_active": "{count} ads ativos",
    "kanban.meta_active_tooltip": "Rodando {count} anúncios Meta agora — compra tráfego, provavelmente compra seu serviço",
    "kanban.meta_inactive": "sem ads",
    "kanban.meta_inactive_tooltip": "Nenhum anúncio Meta ativo encontrado nas últimas 24h",
    "kanban.delete_tooltip": "Remover este lead do pipeline",
    "kanban.delete_confirm": "Remover \"{name}\" do pipeline? Não é possível desfazer.",
    "kanban.delete_ok": "\"{name}\" removido do pipeline",
    "kanban.delete_fail": "Não foi possível excluir este lead — tente novamente.",
    // Lead detail drawer
    "ldd.title": "Detalhes do lead",
    "ldd.tab_overview": "Visão geral",
    "ldd.tab_history": "Histórico",
    "ldd.tab_notes": "Anotações",
    "ldd.field_phone": "Telefone",
    "ldd.field_email": "Email",
    "ldd.field_website": "Site",
    "ldd.field_address": "Endereço",
    "ldd.field_sector": "Nicho",
    "ldd.field_status": "Status no CRM",
    "ldd.field_score": "Score Digital",
    "ldd.field_followup": "Próximo follow-up",
    "ldd.followup_clear": "Limpar",
    "ldd.followup_save": "Salvar",
    "ldd.followup_saved": "Follow-up atualizado",
    "ldd.followup_failed": "Falha ao salvar follow-up",
    "ldd.notes_placeholder": "Digite anotações de reunião, objeções, próximos passos…",
    "ldd.notes_save": "Salvar anotações",
    "ldd.notes_saved": "Anotações salvas",
    "ldd.history_empty": "Nenhuma atividade registrada para este lead ainda.",
    "ldd.actions_title": "Ações rápidas",
    "ldd.action_wa": "WhatsApp",
    "ldd.action_call": "Ligar",
    "ldd.action_email": "Email",
    "ldd.action_audit": "Auditoria",
    "ldd.no_email": "Sem email cadastrado",
    "ldd.no_phone": "Sem telefone cadastrado",

    // Webhooks
    "wh.page_title": "Webhooks",
    "wh.page_subtitle": "Envie eventos em tempo real para Zapier, Make, n8n ou qualquer endpoint HTTP",
    "wh.add_title": "Registrar novo endpoint",
    "wh.add_button": "Registrar webhook",
    "wh.list_title": "Endpoints registrados",
    "wh.empty": "Nenhum webhook ainda — registre um acima.",
    "wh.col_url": "URL",
    "wh.col_events": "Eventos",
    "wh.col_state": "Estado",
    "wh.col_last": "Última entrega",
    "wh.col_actions": "Ações",
    "wh.state_active": "Ativo",
    "wh.state_paused": "Pausado",
    "wh.never": "Nunca entregue",
    "wh.deliveries": "entregas",
    "wh.test_tooltip": "Enviar payload de teste",
    "wh.toggle_tooltip": "Ativar/Desativar",
    "wh.delete_tooltip": "Remover",
    "wh.created": "Webhook registrado: {url}",
    "wh.removed": "Webhook removido: {url}",
    "wh.create_failed": "Falha ao registrar webhook",
    "wh.remove_failed": "Falha ao remover webhook",
    "wh.toggle_failed": "Falha ao alternar estado",
    "wh.test_failed": "Falha no envio de teste",
    "wh.help_title": "Como consumir estes eventos",
    "wh.help_p1": "Cada endpoint registrado recebe um POST HTTPS por evento correspondente, com corpo assinado:",
    "wh.help_p2": "Valide a assinatura contra seu secret armazenado para confirmar a autenticidade. Entregas com falha são registradas mas (ainda) não retentadas automaticamente.",

    // Bulk search
    "bulk.modal_title": "Bulk Search em múltiplas cidades",
    "bulk.cities_label": "Cidades (separadas por vírgula)",
    "bulk.cities_placeholder": "Orlando, FL, Miami, FL, Tampa, FL",
    "bulk.run_button": "Executar bulk search",
    "bulk.auto_save": "Salvar automaticamente leads QUENTE",
    "bulk.results_summary": "{total} encontrados · {dedup} após dedup · {saved} auto-salvos",
    "bulk.open_modal": "Bulk search",

    // Score breakdown
    "lead.score_tooltip": "Clique para ver por que este lead recebeu este score",
    "score.tooltip": "Ver detalhamento do score",
    "score.modal_title": "Detalhamento do Score",
    "score.criteria_title": "Critérios",
    "score.opportunities_title": "Oportunidades de venda (sinais ausentes)",

    // AI Lookalike Lead Finder
    "look.button": "AI Lookalike",
    "look.modal_title": "Buscador de Leads Similares (IA)",
    "look.modal_subtitle": "Encontre mais leads parecidos com os seus {n} melhores QUENTE/QUALIFIED",
    "look.locations_label": "Cidades-alvo (uma por linha)",
    "look.locations_placeholder": "Tampa, FL\nSaint Petersburg, FL",
    "look.locations_hint": "Deixe em branco para extrair automaticamente das cidades dos leads-semente.",
    "look.run_button": "Buscar lookalikes (usa GPT)",
    "look.queries_count": "IA gerou {n} estratégias de busca",
    "look.locations_used": "Cidades pesquisadas",
    "look.candidates_title": "Candidatos ({n})",
    "look.no_candidates": "Nenhum candidato novo — tente expandir as cidades ou adicionar mais leads QUENTE como semente.",
    "look.save_btn": "Salvar",
    "look.found": "{n} candidatos similares encontrados",
    "look.failed": "Busca de lookalikes falhou",
    "look.saved": "{name} salvo no CRM",
    "look.already_saved": "Já está no seu CRM (deduplicado)",
    "look.save_failed": "Falha ao salvar lead",

    // WhatsApp
    "wa.button": "WhatsApp",
    "wa.title": "Enviar WhatsApp",
    "wa.body_label": "Mensagem",
    "wa.send_btn": "Enviar via WhatsApp",
    "wa.sent": "Enviado para {name}",
    "wa.failed_short": "Falha no envio — veja detalhes",
    "wa.queued": "Enfileirado · sid …{sid} · status {status}",
    "wa.disclaimer": "Sandbox Twilio: o destinatário precisa primeiro enviar 'join <código>' ao seu número sandbox para receber mensagens. Para produção, registre seu número como WhatsApp Sender aprovado no Twilio.",
    "wa.no_phone": "Lead sem número de telefone",

    "integ.status.connected": "Conectado",
    "integ.status.mocked": "Mockado",
    "integ.status.configure": "Configurar",
    "integ.page_title": "Integrações",
    "integ.page_subtitle": "Conecte ferramentas externas e automatize fluxos",
    "integ.error_title": "Não foi possível carregar as integrações",
    "integ.execute_failed": "Falha ao executar {name}",
    "integ.hero_title": "Plugável por design",
    "integ.hero_body": "O AgenteLead Pro conversa com 50+ ferramentas em comunicação, automação, CRM, enriquecimento, marketing, pagamentos, documentos, analytics e IA. Conecte uma vez e o dado flui nas duas direções.",
    "integ.kpi_total": "Total",
    "integ.kpi_connected": "Conectadas",
    "integ.kpi_configure": "A configurar",
    "integ.search_placeholder": "Buscar integração por nome, categoria ou descrição…",
    "integ.cat_all": "Todas",
    "integ.cat_communication": "Comunicação",
    "integ.cat_automation": "Automação",
    "integ.cat_crm": "CRM",
    "integ.cat_enrichment": "Prospecção & Enriquecimento",
    "integ.cat_marketing": "Marketing",
    "integ.cat_payments": "Pagamentos",
    "integ.cat_documents": "Documentos",
    "integ.cat_analytics": "Analytics",
    "integ.cat_ai": "IA",
    "integ.cat_count_apps": "apps",
    "integ.empty_filtered": "Nenhuma integração corresponde aos filtros atuais.",
    "integ.read_more": "Saiba mais",
    "integ.run": "Executar",
    "integ.connect": "Conectar",
    "integ.update": "Atualizar",
    // Configuration modal
    "cfg.title_connect": "Conectar {name}",
    "cfg.title_update": "Atualizar {name}",
    "cfg.already_connected": "Já conectado",
    "cfg.current_key": "Chave atual",
    "cfg.where_to_get": "Obtenha suas credenciais em",
    "cfg.field_api_key": "API key / token",
    "cfg.placeholder_keep": "Deixe vazio para manter a chave atual",
    "cfg.never_displayed": "Nunca exibimos sua chave novamente — só a versão mascarada.",
    "cfg.update": "Atualizar",
    "cfg.connect": "Conectar",
    "cfg.disconnect": "Desconectar",
    "cfg.disconnect_confirm": "Desconectar {name}? Você precisará reconfigurar a API key para reconectar.",
    "cfg.disconnected": "{name} desconectado",
    "cfg.saved": "{name} conectado com sucesso",
    "cfg.save_failed": "Falha ao salvar credenciais",
    // App Marketplace
    "mkt.title": "App Marketplace",
    "mkt.subtitle": "Escada curada de 3 níveis — Essenciais → Diferenciais → Avançados",
    "mkt.error_title": "Não foi possível carregar o marketplace",
    "mkt.eyebrow": "Escada de integrações em 3 níveis",
    "mkt.hero_title": "Seu stack de prospecção a um clique de distância.",
    "mkt.hero_body": "Mapeamos as 22 integrações que levam o AgenteLead Pro de MVP a concorrente do Clay/Apollo. Escolha seu nível, clique Instalar e a gente te guia pelas credenciais em segundos.",
    "mkt.kpi_total": "Total de apps",
    "mkt.kpi_connected": "Conectados",
    "mkt.kpi_to_configure": "A configurar",
    "mkt.search_placeholder": "Buscar em todos os apps do marketplace…",
    "mkt.tier_all": "Todos os níveis",
    "mkt.tier_essentials_short": "Essenciais",
    "mkt.tier_differentials_short": "Diferenciais",
    "mkt.tier_advanced_short": "Avançados",
    "mkt.tier_connected": "conectados",
    "mkt.tier_pending": "pendentes",
    "mkt.empty_filtered": "Nenhum app corresponde aos filtros atuais.",
    "mkt.install": "Instalar",
    "mkt.installed": "Instalado",
    "mkt.coming_soon": "Em breve",
    "mkt.status_coming_soon": "Em breve",

    // Onboarding tour
    "tour.skip": "Pular tour",
    "tour.next": "Próximo",
    "tour.back": "Voltar",
    "tour.done": "Entendi",
    "tour.restart": "Reabrir tour",
    "tour.step_label": "Passo {current} de {total}",
    "tour.s1.title": "Bem-vindo ao AgenteLead Pro",
    "tour.s1.body": "Um tour de 60 segundos mostrando como achar leads B2B locais, qualificá-los com IA e executar abordagem multicanal — tudo dentro de um único app.",
    "tour.s1.b1": "Pesquisa no Google Maps sem copiar-colar nem extensão externa",
    "tour.s1.b2": "Score, auditoria e e-mail personalizado por GPT em cada lead",
    "tour.s1.b3": "Pipeline visual com WhatsApp, follow-up e histórico no CRM Kanban",
    "tour.s2.title": "1. Prospecção por nicho + cidade",
    "tour.s2.body": "Abra Prospecção, escolha o nicho (Roofing, HVAC, Plumbing…) e a cidade. A plataforma consulta o Google Maps ao vivo e traz cada negócio já com score, badge, telefone, site e endereço.",
    "tour.s2.b1": "Bulk Search em várias cidades de uma vez só",
    "tour.s2.b2": "Auto-save de leads QUENTE direto no seu CRM",
    "tour.s2.b3": "Deduplicação automática — o mesmo negócio nunca aparece duas vezes",
    "tour.s2.cta": "Abrir Prospecção",
    "tour.s3.title": "2. Score e Auditoria com IA",
    "tour.s3.body": "Cada lead recebe um Score Digital (quanto MENOR, mais QUENTE — maior oportunidade de venda). Clique em \"Run Audit\" e o GPT gera uma análise do site em 6 seções. Em \"Send Email\", a IA escreve outreach personalizado citando rating, reviews e detalhes do site.",
    "tour.s3.b1": "QUENTE 0-33 · MORNO 34-66 · FRIO 67-100",
    "tour.s3.b2": "Auditoria GPT cobre Web, SEO Local, Social, Reviews, Oportunidades e Pitch",
    "tour.s3.b3": "AI Lookalike: vire um cliente Ganho em 5 outros parecidos com ele",
    "tour.s4.title": "3. Pipeline no CRM Kanban",
    "tour.s4.body": "Leads salvos vão para o Kanban. Arraste entre Novo → Contactado → Qualificado → Proposta → Ganho/Perdido. Clique no card para abrir o painel lateral com histórico, anotações e próximo follow-up.",
    "tour.s4.b1": "Quick actions: WhatsApp · Ligar · Email — um clique",
    "tour.s4.b2": "Alerta visual em cards parados há mais de 7 dias na mesma coluna",
    "tour.s4.b3": "Busca por nome, filtro por temperatura ou nicho no topo do quadro",
    "tour.s4.cta": "Abrir CRM Kanban",
    "tour.s5.title": "Pronto pra voar 🚀",
    "tour.s5.body": "Acompanhe seu funil, conversão e ROI em tempo real no Dashboard da Agência. Você pode reabrir este tour a qualquer momento pelo botão na barra lateral.",
    "tour.s5.b1": "Funil de Conversão de Leads com KPIs clicáveis",
    "tour.s5.b2": "Webhooks disparam em cada evento-chave (save, mudança de status, auditoria, WhatsApp)",
    "tour.s5.b3": "Log de Atividades com drill-down em um clique",
    "tour.s5.cta": "Ir para o Dashboard",

    // Campaigns page
    "camp.greeting": "Olá, Reach Soul!",
    "camp.trial_left": "Faltam 14 dias do seu trial Premium",
    "camp.view_plans": "Ver planos",
    "camp.nav_title": "Campanhas",
    "camp.nav_subtitle": "Email marketing para os leads do seu CRM",
    "camp.cta_primary": "Começar grátis",
    "camp.cta_pricing": "Ver preços",
    "camp.cta_hint": "Grátis durante o trial",
    "camp.hero_eyebrow": "Email marketing",
    "camp.hero_title": "Envie campanhas de email que geram cliques",
    "camp.hero_body": "Marketing e vendas no mesmo lugar. Crie e-mails bonitos, automatize a mensagem certa no momento certo e transforme respostas em pipeline — sem sair do CRM.",
    "camp.hero_button_label": "Abrir auditoria",
    "camp.b1_title": "Crie e-mails impecáveis",
    "camp.b1_body": "Escolha entre templates profissionais e personalizáveis e monte campanhas com a sua marca em minutos com um editor drag-and-drop.",
    "camp.b2_title": "Nutra seus contatos",
    "camp.b2_body": "Dispare automações para que a mensagem certa chegue no momento certo — baseado no score do lead, mudança de status ou sinais do site.",
    "camp.b3_title": "Aumente a performance",
    "camp.b3_body": "Veja aberturas, cliques e conversões em tempo real e compare campanhas lado a lado em relatórios prontos.",
    "camp.video_label": "Demo ao vivo",
    "camp.video_demo": "Em produção, o vídeo demo abriria aqui.",
    "camp.reasons_title": "Mais motivos para usar Campanhas",
    "camp.reasons_subtitle": "Todo o trabalho pesado dentro do AgenteLead Pro.",
    "camp.r1": "Sem importar/exportar contatos — seu CRM é a fonte da verdade.",
    "camp.r2": "Templates modernos e editor drag-and-drop — sem precisar de HTML.",
    "camp.r3": "Engajamento volta automático para o time de vendas — todos veem quem está quente.",
    "camp.r4": "Comece a engajar leads em poucos passos — sem assistente de configuração.",
    "camp.list_title": "Suas campanhas",
    "camp.list_subtitle": "Rascunhos e envios agendados",
    "camp.count_label": "campanhas",
    "camp.empty": "Nenhuma campanha ainda — o primeiro rascunho está a um clique.",
    "camp.draft_name": "Campanha sem título · {date}",
    "camp.draft_subject": "Um recado rápido do AgenteLead Pro",
    "camp.draft_created": "Rascunho criado: {name}",
    "camp.draft_failed": "Falha ao criar rascunho",
    "camp.col_subject": "Assunto",
    "camp.col_recipients": "destinatários",
    "camp.action_edit": "Editar",
    "camp.action_assign": "Atribuir leads",
    "camp.edit_hint": "Abra o editor de e-mail para refinar — em breve",
    "camp.final_title": "Pronto para transformar leads em cliques?",
    "camp.final_body": "Crie um rascunho agora e nós já preenchemos com seus melhores leads QUENTE.",

    // Insights / Reports page
    "ins.greeting": "Olá, Reach Soul!",
    "ins.trial_left": "Faltam 14 dias do seu trial Premium",
    "ins.view_plans": "Ver planos",
    "ins.title": "Insights",
    "ins.search_placeholder": "Buscar dashboards, metas, relatórios…",
    "ins.notifications": "Notificações",
    "ins.avatar_tooltip": "Acesse configurações e ferramentas — todas as opções da sua conta estão no menu do avatar.",
    "ins.section_dashboards": "Dashboards",
    "ins.section_goals": "Metas",
    "ins.section_reports": "Relatórios",
    "ins.my_dashboards": "Meus dashboards",
    "ins.my_goals": "Minhas metas",
    "ins.my_reports": "Meus relatórios",
    "ins.no_dashboards": "Nenhum dashboard ainda",
    "ins.no_goals": "Nenhuma meta ainda",
    "ins.no_reports": "Nenhum relatório ainda",
    "ins.eyebrow": "Analytics em tempo real",
    "ins.hero_title": "Identifique oportunidades de crescimento. Aja.",
    "ins.hero_body": "Configure seu dashboard personalizável. Acompanhe os dados do AgenteLead relacionados às suas atividades de vendas. Tome decisões informadas no momento certo.",
    "ins.cta_create": "Criar dashboard",
    "ins.cta_ai": "Gerar relatório (IA)",
    "ins.cta_video": "Assistir vídeo (0:35)",
    "ins.video_demo": "Em produção, o vídeo demo abriria aqui.",
    "ins.generating_ai": "Geração de relatório por IA enfileirada — avisamos quando ficar pronto.",
    "ins.chart_sectors": "Leads por nicho",
    "ins.chart_temperature": "Mix por temperatura",
    "ins.chart_actions": "Atividade por ação",
    "ins.chart_realtime": "ao vivo",
    "ins.kpi_saved": "Leads salvos",
    "ins.kpi_saved_drill": "Abrir Kanban",
    "ins.kpi_avg_score": "Score médio",
    "ins.kpi_avg_drill": "Ver leads pontuados",
    "ins.kpi_quente": "QUENTE",
    "ins.kpi_quente_drill": "Ver apenas leads QUENTE",
    "ins.kpi_activity": "Eventos de atividade",
    "ins.kpi_activity_drill": "Abrir log de atividade",
    "ins.last_updated": "Atualizado",
    "ins.refresh_now": "Atualizar agora",
    "ins.refreshed": "Insights atualizados",
    "ins.extra_title": "Visualizações estratégicas",
    "ins.extra_subtitle": "Últimos 30 dias · auto-refresh",
    "ins.funnel_title": "Funil do pipeline de vendas",
    "ins.source_title": "Leads por origem",
    "ins.gauge_no_goal_title": "Acompanhamento de meta",
    "ins.gauge_of_target": "da meta {target}",
    "ins.gauge_metric": "Métrica",
    "ins.gauge_no_goal": "Crie uma meta para ver o progresso aqui.",
    "ins.timeline_title": "Leads vs atividade (30d)",
    "ins.timeline_badge": "tendência",
    "ins.timeline_leads": "Leads capturados",
    "ins.timeline_activity": "Eventos de atividade",
    "ins.efficiency_title": "Eficiência por ação",
    "ins.efficiency_events": "Eventos",
    "ins.efficiency_qualified": "Movidos para QUALIFIED+",
    "ins.efficiency_legend": "Mais barra verde = ações que mais movem o ponteiro de conversão.",
    "ins.heatmap_title": "Mapa de calor Setor × Temperatura",
    "ins.heatmap_empty": "Ainda sem dados de setor — salve alguns leads para popular.",
    "ins.heatmap_legend": "Célula mais escura = bucket mais denso. Identifique setores quentes em segundos.",
    "ins.report_generated": "Relatório IA gerado",
    "ins.report_failed": "Falha ao gerar relatório IA",
    "ins.report_deleted": "Relatório removido",
    "ins.cta_goal": "Nova meta",
    "ins.dash_modal_title": "Criar dashboard",
    "ins.dash_field_name": "Nome",
    "ins.dash_field_desc": "Descrição",
    "ins.dash_placeholder_name": "ex.: Florida — Pipeline de Roofing",
    "ins.dash_placeholder_desc": "Opcional. O que este dashboard acompanha?",
    "ins.dash_save": "Criar",
    "ins.dash_name_required": "Nome do dashboard é obrigatório",
    "ins.dash_created": "Dashboard '{name}' criado",
    "ins.dash_failed": "Operação falhou",
    "ins.dash_deleted": "Dashboard removido",
    "ins.dash_delete_confirm": "Remover o dashboard '{name}'?",
    "ins.goal_modal_title": "Criar meta",
    "ins.goal_field_name": "Nome",
    "ins.goal_field_metric": "Métrica",
    "ins.goal_field_target": "Alvo",
    "ins.goal_placeholder_name": "ex.: 200 leads salvos em Abril",
    "ins.goal_save": "Criar",
    "ins.goal_name_required": "Nome da meta é obrigatório",
    "ins.goal_created": "Meta '{name}' criada",
    "ins.goal_failed": "Falha ao criar meta",
    "ins.goal_m_saved": "Leads salvos",
    "ins.goal_m_quente": "Leads QUENTE",
    "ins.goal_m_activity": "Eventos de atividade",
    "ins.goal_m_avg": "Score médio",
    "ins.ai_report_title": "Relatório IA de Insights",
    "ins.ai_wins": "Vitórias",
    "ins.ai_risks": "Riscos",
    "ins.ai_actions": "Próximas ações",
    "common.cancel": "Cancelar",

    // Free Sources V2 + Prospecting Wizard
    "fs.page_title_v2": "Settings · Data Sources",
    "fs.page_subtitle_v2": "Gerencie suas fontes de dados · Escolha um playbook · Rode o Motor de Prospecção",
    "fs.view_dashboard": "Ver no Dashboard",
    "fs.cta_engine": "Rodar Motor de Prospecção",
    "fs.error_title": "Não foi possível carregar as fontes",
    "fs.curated_count": "fontes curadas, atualizadas semanalmente",
    "fs.hero_eyebrow": "Free + Freemium",
    "fs.hero_title": "De \"quero leads\" para \"tenho uma lista organizada e pronta pra ação\" — sem 5 ferramentas pagas.",
    "fs.hero_body": "Curamos as melhores fontes free / freemium de leads B2B, etiquetamos por dificuldade, custo e tipo de dado, e conectamos cada uma ao nosso Motor de Prospecção. Escolha uma fonte ou playbook abaixo e cuidamos da deduplicação, score e roteamento ao seu CRM.",
    "fs.recommended_title": "Recomendado para você",
    "fs.tag_recommended": "Top pick",
    "fs.search_placeholder": "Buscar por nome, tipo ou tipo de dado…",
    "fs.group_all": "Todas as categorias",
    "fs.group_directory": "Diretórios públicos",
    "fs.group_email": "Email finders",
    "fs.group_scraper": "Scrapers / Extensões",
    "fs.group_b2b": "Bases B2B",
    "fs.cost_any": "Qualquer custo",
    "fs.cost_free": "Free",
    "fs.cost_freemium": "Freemium",
    "fs.cost_credits": "Créditos",
    "fs.diff_any": "Qualquer dificuldade",
    "fs.diff_beginner": "Iniciante",
    "fs.diff_intermediate": "Intermediário",
    "fs.diff_advanced": "Avançado",
    "fs.filter_clear": "Limpar filtros",
    "fs.sources_count": "fontes",
    "fs.empty_filtered": "Nenhuma fonte corresponde aos filtros atuais.",
    "fs.card_credits": "Free tier",
    "fs.card_send_engine": "Mandar pro Motor",
    "fs.tab_all": "Todas as fontes",
    "fs.tab_general": "🏢 General Prospecting",
    "fs.tab_gov": "🏛️ Gov & Construção",
    "fs.open_in_app": "Abrir no app",
    "fs.credits_internal": "Usa Créditos AgenteLead (motor integrado)",
    "fs.credits_external": "Usa os SEUS créditos na plataforma externa",
    "fs.card_open": "Abrir fonte",
    "fs.playbooks_title": "Playbooks de Prospecção",
    "fs.playbooks_subtitle": "Fluxos prontos que escolhem fontes, parâmetros e saídas para os objetivos mais comuns.",
    "fs.pb1_title": "Encontrar B2B locais na minha cidade",
    "fs.pb1_body": "Empresas de Roofing, HVAC, Construção perto de uma cidade — direto do Google Maps + BBB + Yellow Pages, deduplicadas e com score.",
    "fs.pb2_title": "Validar e-mails de uma lista antiga",
    "fs.pb2_body": "Passe sua lista de contatos pelo Hunter / Prospeo / Snov para ficar só com e-mails verificados antes do disparo.",
    "fs.pb3_title": "Encontrar decisores em construção",
    "fs.pb3_body": "Use Apollo + Lusha + BBB para chegar nos donos, GMs e Marketing Directors de construtoras.",
    "fs.pb4_title": "Lista bulk com alta avaliação",
    "fs.pb4_body": "Pegue empresas HVAC/Plumbing 4★+ com 50+ reviews — leads de alta credibilidade prontos para cold outreach.",
    "fs.pb_recommended_sources": "Fontes recomendadas",
    "fs.pb_run": "Rodar playbook",
    "fs.faq_title": "FAQ & suporte",
    "fs.faq1_q": "Preciso instalar algo para usar essas fontes?",
    "fs.faq1_a": "Não. A maioria das fontes funciona direto dentro do Motor de Prospecção. Alguns scrapers (Web Scraper, Octoparse) pedem extensão Chrome free — só avisamos quando for relevante.",
    "fs.faq2_q": "O motor faz deduplicação entre fontes?",
    "fs.faq2_a": "Sim. Deduplicamos por telefone, domínio do site normalizado e place_id. Ao salvar um lead que já existe, incrementamos o contador dedup_hits ao invés de duplicar.",
    "fs.faq3_q": "Os leads vão pro meu CRM no momento que rodo o motor?",
    "fs.faq3_a": "Só se você escolher 'Adicionar ao CRM' no último passo do wizard. Também dá pra exportar CSV ou popular uma campanha sem salvar no CRM.",
    "fs.faq4_q": "Qual a diferença entre o Hub e a prospecção direta?",
    "fs.faq4_a": "Prospecção direta (a barra de busca) é rápida — uma fonte por vez. Hub + Motor são ideais quando você quer combinar várias fontes, seguir um playbook e rotear a saída pra um destino específico.",
    "fs.final_cta_title": "Pronto para encher seu pipeline?",
    "fs.final_cta_body": "Um wizard, cinco passos, seu CRM populado de leads qualificados. Adeus malabarismo de planilhas.",

    // Wizard
    "wiz.title": "Motor de Prospecção",
    "wiz.next": "Próximo",
    "wiz.back": "Voltar",
    "wiz.finish": "Concluir",
    "wiz.step_label": "Passo {current} de {total}",
    "wiz.error_fetch": "Falha na busca. Tente novamente.",
    "wiz.success_crm": "{count} leads salvos no seu CRM Kanban",
    "wiz.success_campaign": "Rascunho de campanha criado com esses leads",
    "wiz.success_csv": "CSV com {count} leads baixado",
    "wiz.campaign_name": "Prospects {type} · {loc}",
    "wiz.campaign_subject": "Um recado rápido para empresas de {type}",
    // s0
    "wiz.s0_title": "Qual seu objetivo de prospecção?",
    "wiz.s0_subtitle": "Escolha um objetivo — pré-configuramos fontes e parâmetros pra você.",
    "wiz.s0_local_title": "Encontrar empresas B2B locais",
    "wiz.s0_local_body": "Roofing, HVAC, Plumbing etc. perto de uma cidade",
    "wiz.s0_validate_title": "Validar e-mails",
    "wiz.s0_validate_body": "Verificar uma lista antes do outreach",
    "wiz.s0_decision_title": "Encontrar decisores",
    "wiz.s0_decision_body": "Owners, GMs, Marketing Directors",
    "wiz.s0_bulk_title": "Lista bulk de alta avaliação",
    "wiz.s0_bulk_body": "Empresas top-rated com muitos reviews",
    "wiz.s0_custom_title": "Personalizado",
    "wiz.s0_custom_body": "Montar do zero",
    // s1
    "wiz.s1_title": "Escolha as fontes recomendadas",
    "wiz.s1_subtitle": "Combine várias fontes pra mais cobertura. Deduplicamos automaticamente.",
    "wiz.s1_selected": "selecionadas",
    // s2
    "wiz.s2_title": "Parâmetros da busca",
    "wiz.s2_subtitle": "Diga ao motor que tipo de negócio e onde procurar.",
    "wiz.s2_business": "Tipo de negócio",
    "wiz.s2_business_placeholder": "ex.: Roofing, HVAC, Pest Control",
    "wiz.s2_location": "Localização",
    "wiz.s2_radius": "Raio",
    "wiz.s2_score": "Filtro por temperatura",
    "wiz.s2_score_any": "Qualquer temperatura",
    "wiz.s2_score_quente_morno": "QUENTE + MORNO (≤66)",
    "wiz.s2_score_quente": "Só QUENTE (≤33)",
    // s3
    "wiz.s3_title": "Revisar & rodar",
    "wiz.s3_subtitle": "Vamos consultar o Google Maps, deduplicar e dar score em cada lead.",
    "wiz.s3_run": "Rodar motor",
    "wiz.s3_running": "Buscando, deduplicando e pontuando leads…",
    "wiz.s3_done": "{count} leads qualificados prontos",
    "wiz.s3_source": "Fonte",
    // s4
    "wiz.s4_title": "Escolher saída",
    "wiz.s4_subtitle": "Para onde mandar os {count} leads?",
    "wiz.s4_crm_title": "Adicionar ao CRM Kanban",
    "wiz.s4_crm_body": "Cada lead vai para a coluna 'Novo' com score e auditoria prontos",
    "wiz.s4_campaign_title": "Popular campanha de email",
    "wiz.s4_campaign_body": "Cria um rascunho preenchido com esses leads",
    "wiz.s4_csv_title": "Baixar CSV",
    "wiz.s4_csv_body": "Planilha com nome, telefone, site, score etc.",

    // Products page
    "prod.greeting": "Olá, Reach Soul!",
    "prod.trial_left": "Faltam 14 dias do seu trial Premium",
    "prod.view_plans": "Ver planos",
    "prod.title": "Produtos",
    "prod.search_placeholder": "Buscar no AgenteLead",
    "prod.add_tooltip": "Adicionar novo produto",
    "prod.add_product": "Adicionar produto",
    "prod.ai_tooltip": "Ação rápida com IA — preencha produtos a partir dos seus melhores deals",
    "prod.help": "Ajuda",
    "prod.notifications": "Notificações",
    "prod.nav_marketplace": "Marketplace",
    "prod.nav_automations": "Automações",
    "prod.nav_assignment": "Atribuição automática",
    "prod.nav_sequences": "Sequências",
    "prod.nav_documents": "Documentos",
    "prod.nav_import": "Importar dados",
    "prod.nav_export": "Exportar dados",
    "prod.nav_restore": "Restaurar dados",
    "prod.products_count": "produtos",
    "prod.empty_title": "Nenhum produto encontrado",
    "prod.empty_subtitle": "Tente resetar o filtro ou ver todos os produtos.",
    "prod.reset_filter": "Resetar filtro",
    "prod.view_all": "Ver todos os produtos",
    "prod.col_name": "Produto",
    "prod.col_owner": "Responsável",
    "prod.col_sku": "SKU",
    "prod.draft_name": "Novo produto · {date}",
    "prod.created": "Produto criado: {name}",
    "prod.create_failed": "Falha ao criar produto",

    // ── Central de Tutoriais ("Aprenda a usar") ────────────────────
    "tut.nav.title": "Aprenda a usar",
    "tut.page.title": "Aprenda a usar o AgenteLead Pro",
    "tut.page.subtitle": "Tutoriais curtos para cada bloco do aplicativo.",
    "tut.search.placeholder": "Buscar por ferramenta ou tarefa…",
    "tut.filter.all": "Todos",
    "tut.filter.discovery": "Discovery",
    "tut.filter.outreach": "Outreach",
    "tut.filter.pipeline": "Pipeline",
    "tut.filter.analytics": "Analytics",
    "tut.filter.specialty": "Especializado",
    "tut.filter.onboarding": "Comece aqui",
    "tut.status.not_started": "Não iniciado",
    "tut.status.in_progress": "Em andamento",
    "tut.status.completed": "Concluído",
    "tut.card.duration": "{sec}s",
    "tut.card.go": "Ir para a ferramenta",
    "tut.card.watch": "Assistir tutorial",
    "tut.card.prereq": "Pré-requisitos",
    "tut.section.objective": "Objetivo",
    "tut.section.when": "Quando usar",
    "tut.section.prep": "Preparação",
    "tut.section.demo": "Demonstração",
    "tut.section.result": "Resultado",
    "tut.section.next": "Próxima ação",
    "tut.section.steps": "Passo a passo",
    "tut.section.success": "Como saber que deu certo",
    "tut.section.errors": "Erros comuns",
    "tut.section.transcript": "Transcrição",
    "tut.mark.done": "Marcar como concluído",
    "tut.mark.undo": "Desmarcar conclusão",
    "tut.feedback.q": "Este tutorial ajudou?",
    "tut.feedback.yes": "Sim",
    "tut.feedback.no": "Não",
    "tut.feedback.thanks": "Obrigado pelo feedback!",
    "tut.production.status": "Status de produção",
    "tut.production.script_ready": "Roteiro pronto — vídeo pendente",
    "tut.production.in_production": "Vídeo em produção",
    "tut.production.review": "Aguardando revisão",
    "tut.production.published": "Publicado",
    "tut.player.pending": "Vídeo pendente. Siga o passo a passo ilustrado abaixo enquanto isso.",
    "tut.help.button": "Como usar",
    "tut.help.tooltip": "Ver um tutorial curto sobre este bloco",
    "tut.help.float": "Ajuda",
    "tut.recommended": "Sequência recomendada",
    "tut.start.here": "Comece aqui",
    "tut.updated": "Última revisão",
  },

  es: {
    "lang.toggle": "EN",
    "sidebar.subtitle": "ENCUENTRA. PARTICIPA. CRECE.",
    "sidebar.footer": "v1.0 — Módulo de Prospección",

    // ── Iter313 · Vehicle Security Map (VS Map) ─────────────────────
    "vsm.tier": "Nivel",
    "vsm.flock_alpr": "Flock/ALPR",
    "vsm.flock": "Flock",
    "vsm.tier.all": "Todos",
    "vsm.tier.critical": "Critical",
    "vsm.tier.very_high": "M. Alto",
    "vsm.tier.high": "Alto",
    "vsm.tier.medium": "Medio",
    "vsm.tier.low": "Bajo",
    "vsm.flock.all": "Todos",
    "vsm.flock.only": "Sólo Flock",
    "vsm.flock.exclude": "Excluir Flock",
    "vsm.leads_count": "{count}/{total} leads",
    "vsm.address_placeholder": "Dirección, ciudad o barrio (ej: Dr. Phillips, Orlando)",
    "vsm.radius": "Radio",
    "vsm.radius.off": "Off",
    "vsm.radius.clear": "Limpiar radio",
    "vsm.route.optimizer": "Constructor de rutas",
    "vsm.route.optimize": "Rutear {n} paradas",
    "vsm.route.navigate": "Abrir en Google Maps",
    "vsm.route.hint": "Orden optimizado por proximidad (nearest-neighbor)",
    "vsm.osm_loading": "Cargando límites reales de los barrios (OpenStreetMap)…",
    "vsm.geocoding": "Geocodificando…",
    "vsm.privacy.city": "Modo Ciudad",
    "vsm.privacy.exact": "Dirección Exacta",
    "vsm.privacy.city_title": "Modo ciudad (privacidad preservada)",
    "vsm.privacy.exact_title": "Modo dirección exacta (uso interno)",
    "vsm.privacy.master_required": "Dirección exacta requiere rol MASTER",
    "vsm.legend": "Leyenda",
    "vsm.footer.city_mode": "Modo Ciudad: pins agregados por barrio/ciudad (dirección no expuesta)",
    "vsm.info.est_contract": "Contrato est.:",
    "vsm.info.details": "Ver detalles",
    "vsm.info.street_view": "Street View",
    "vsm.info.street_view_open": "Abrir Street View",
    "vsm.empty": "Sin leads con los filtros activos.",
    "vsm.missing_key": "Falta Google Maps API key. Configure REACT_APP_GOOGLE_MAPS_API_KEY.",

    // ── Iter314 · Vehicle Security page body ────────────────────────
    "vs.disclaimer_loading": "Cargando aviso regulatorio…",
    "vs.google_ads": "Google Ads",
    "vs.google_ads_sub": "Keywords + Negativas",
    "vs.google_ads_title": "Google Ads: paquetes de keywords + negativas por segmento",
    "vs.reg_watch": "Vigilancia Regulatoria",
    "vs.reg_items_tracked": "{n} elementos monitoreados",
    "vs.reg_open": "Abrir",
    "vs.kpi.total_leads": "Total de Leads",
    "vs.kpi.critical": "Crítico (90+)",
    "vs.kpi.high_opportunity": "Alta Oportunidad (80+)",
    "vs.kpi.existing_cctv": "CCTV Existente",
    "vs.kpi.existing_alpr": "ALPR Existente",
    "vs.kpi.guard_house": "Caseta de Guardia",
    "vs.kpi.security_officers": "Vigilantes",
    "vs.kpi.multi_entrance": "Múltiples Entradas",
    "vs.kpi.large_parking": "Estacionamiento Grande",
    "vs.kpi.theft_risk": "Riesgo de Robo",
    "vs.kpi.replacement_alpr": "Reemplazo ALPR",
    "vs.kpi.cross_sell": "Cross-Sell",
    "vs.kpi.active": "Activo",
    "vs.kpi.clear_filter": "Limpiar filtro",
    "vs.kpi.filter_by": "Filtrar leads por: {label}",
    "vs.kpi.no_matches": "Sin leads coincidentes",
    "vs.pipeline_label": "Pipeline Estimado de Tecnología",
    "vs.pipeline_footer": "+ monitoreo / patrullas / vigilantes recurrentes",
    "vs.header.title": "Smith SecureVehicle™",
    "vs.header.subtitle": "Inteligencia de Vehículos & Seguridad Patrimonial · Sabe quién entra en tu propiedad.",

    // ── Iter314 · Smith Outreach main surface ───────────────────────
    "so.header.title": "Smith · Outreach AI",
    "so.header.subtitle": "{n} contactos · Claire redacta · Resend envía",
    "so.btn.replies": "Respuestas",
    "so.btn.sender": "Remitente",
    "so.btn.sender_title": "Configurar identidad de envío (Marcelo Borges @ smithprotective.com)",
    "so.btn.nudge": "Nudge SMS",
    "so.btn.nudge_title": "Auto-Nudge SMS 48h — SMS automático cuando el email no se abre en 48h",
    "so.btn.dedupe": "Dedupe",
    "so.btn.dedupe_title": "Limpiar emails/prospects duplicados",
    "so.btn.refresh": "Actualizar",
    "so.btn.imports": "Imports",
    "so.btn.imports_title": "Import Hub — plantillas y medios",
    "so.tab.compose": "Redactar",
    "so.tab.drafts": "Borradores",
    "so.tab.contacts": "Contactos",
    "so.tab.templates": "Plantillas",
    "so.tab.sent": "Enviados",
    "so.tab.retry": "Cola de Retry",
    "so.tab.analytics": "Analytics",
    "so.bucket.available": "Con email",
    "so.bucket.missing": "Sin email",
    "so.bucket.unresolvable": "Repositorio",
    "so.search_placeholder": "Buscar nombre, email o empresa",
    "so.filter.advanced_title": "Filtros avanzados",
    "so.filter.source_any": "Cualquier fuente",
    "so.filter.tier_any": "Todos los tiers",
    "so.filter.tier_hot": "🔥 Hot",
    "so.filter.tier_high": "🟢 High",
    "so.filter.tier_qualified": "🟡 Qualified",
    "so.filter.tier_nurture": "🔵 Nurture",
    "so.filter.hide_no_email": "Ocultar leads sin email",
    "so.filter.hide_no_email_hint": "(leads sin email nunca se disparan)",
    "so.filter.only_failed": "Solo fallidos / bloqueados",
    "so.contacts.empty": "Ningún contacto coincide con esos filtros.",
    "so.contacts.loading_discovery": "Claire está buscando emails en la cascada Apollo → Hunter → Apify → Heurística…",
    "so.bulk.select_visible": "Seleccionar visibles",
    "so.bulk.clear": "Limpiar",
    "so.bulk.action": "Bulk",
    "so.footer.count": "{shown} de {total} contactos",
    "so.empty.title": "Elige un contacto para comenzar",
    "so.empty.body": "Haz clic en cualquier contacto a la izquierda — Claire redactará una carta personalizada de Smith Protective basada en el cargo, empresa y segmento del lead.",
    "so.recipient.to": "Para",
    "so.recipient.no_name": "(sin nombre)",
    "so.recipient.find_email": "Buscar email con IA",
    "so.recipient.finding": "Buscando…",
    "so.recipient.find_email_title": "Ejecutar Apollo → Hunter → Apify → Web scrape para descubrir el email de este decision-maker",
    "so.tone.prefix": "Tono",
    "so.tone.consultative": "Consultivo",
    "so.tone.urgent": "Urgente",
    "so.tone.empathetic": "Empático",
    "so.tone.roi": "ROI (números)",
    "so.lang.current": "Idioma actual",
    "so.lang.translate_to": "Traducir a {label}",
    "so.regenerate": "Regenerar",
    "so.regenerating": "Generando…",
    "so.templates.title": "Plantillas",
    "so.templates.empty": "Aún no hay plantillas. Después de componer una carta que te guste, haz clic en Guardar como plantilla.",
    "so.templates.delete": "Eliminar",
    "so.save_template": "Guardar como plantilla",
    "so.save_template_title": "Guardar el borrador actual como plantilla reutilizable",
    "so.subject.label": "Asunto",
    "so.subject.placeholder": "Asunto del email",
    "so.subject.counter": "{n}/78 caracteres",
    "so.tool.bold": "Negrita (Ctrl+B)",
    "so.tool.italic": "Cursiva",
    "so.tool.underline": "Subrayado",
    "so.tool.list": "Lista con viñetas",
    "so.spellcheck": "Revisar ortografía",
    "so.spellchecking": "Revisando…",
    "so.toolbar_hint": "Editor rich-text · Ctrl+B/I/U · listas · spellcheck manual",
    "so.editor.generating": "Claire está redactando con el tono \u201c{tone}\u201d…",
    "so.changes.title": "{n} corrección(es) aplicada(s)",
    "so.attach": "Adjuntar archivo",
    "so.attaching": "Subiendo…",
    "so.attach_hint": "PDF, PPT, DOCX, XLS, imágenes · máx 15 MB cada uno",
    "so.signature.custom_active": "Firma personalizada activa",
    "so.signature.edit": "Editar firma",
    "so.signature.title": "Editar / importar firma con logo, enlaces y formato",
    "so.banner.sent_ok": "Email enviado con éxito a {email}",
    "so.banner.retry": "Intentar de nuevo",
    "so.send.last_sent": "Enviado {at}",
    "so.send.enroll": "Enroll",
    "so.send.enroll_title": "Inscribir contacto en una cadencia",
    "so.send.enroll_missing": "Crea una cadencia en /smith/sequences primero",
    "so.send.enroll_pick": "Elige una cadencia",
    "so.send.manage_cadences": "+ Gestionar cadencias",
    "so.send.button": "Enviar vía Resend",
    "so.send.sending": "Enviando…",
    "so.recipient.recipient_bracket": "\u003c{email}\u003e",
    "so.badge.sent": "Enviado",
    "so.badge.unverified": "No confirmado",
    "so.badge.unverified_title": "Email no confirmado públicamente — puede fallar. Fuentes verificadas: Apollo/Hunter.",
    "so.badge.blocked": "Bloqueado",
    "so.badge.blocked_title": "Este contacto está en la blacklist. Elimínalo en /smith/blacklist para reenviar.",
    "so.badge.champion": "Champion",
    "so.badge.champion_title": "Champion desde {date} — 2+ respuestas detectadas",
    "so.badge.delete_unverified": "Eliminar este lead no confirmado",
    "so.badge.flag_add": "Marcar contacto",
    "so.badge.flag_remove": "Quitar marca",
    "so.enrich_turbo": "Enriquecer con Turbo",
    "so.enrich_turbo_title": "Ejecutar Apollo → Hunter → Apify (Turbo) en todos los leads ocultos para intentar rellenar los emails faltantes",
    "so.enrich_hidden_show": "Mostrar",
    "so.enrich_hidden_hide": "Ocultar",
    "so.hidden_noemail_banner": "{n} lead(s) sin email ocultos automáticamente",
    "so.autoclean.title": "Auto-Cleanup Cron",
    "so.autoclean.next_run": "· próxima diaria 03:00 UTC",
    "so.autoclean.eligible": "elegibles",
    "so.autoclean.last_run": "Última: {date} ({n} eliminados)",
    "so.autoclean.candidates": "Candidatos",
    "so.autoclean.eligible_label": "Elegibles",
    "so.autoclean.skipped": "Skip (safety)",
    "so.autoclean.criteria": "Criterio: ≥3 intentos fallidos / bounced / blocked / skipped y cero envíos exitosos. Prospects con historial de envío o fuera del pipeline seguro (New Prospect / Researching / Junk) se preservan automáticamente.",
    "so.autoclean.dry_run": "Ejecutar Ahora (dry-run)",
    "so.autoclean.running_dry": "Ejecutando…",
    "so.autoclean.run_live": "Ejecutar limpieza",
    "so.autoclean.running_live": "Ejecutando…",
    "so.autoclean.live_title": "Requiere Super Admin. Ejecuta la limpieza real.",
    "so.autoclean.refresh": "↻ Actualizar",
    "so.tab.contacts.title": "Directorio de contactos",
    "so.tab.contacts.subtitle": "{n} decision-makers agregados de Apollo/Hunter/Sunbiz/Import",
    "so.tab.contacts.bulk_find": "Buscar emails en lote",
    "so.tab.contacts.bulk_find_title": "Ejecuta find-email en los prospects sin contacto (Apollo → Hunter → web-scrape)",
    "so.tab.contacts.bulk_processed": "{n} procesados",
    "so.tab.contacts.bulk_progress": "Bulk find-email en curso — {done} procesados · {found} nuevos emails",
    "so.tab.contacts.empty": "Sin contactos — importa una hoja o ejecuta Apollo/Hunter en /smith/prospects.",
    "so.tab.contacts.showing_of": "Mostrando 200 de {total} — usa la página completa para paginación/export.",
    "so.tab.contacts.compose": "Compose",
    "so.cleanup.clear_n": "Limpiar {n}",
    "so.cleanup.cleaning": "Limpiando…",
    "so.cleanup.title": "Eliminar permanentemente todos los leads fallidos/bloqueados/sin-email",

    // ── Iter317 · Sequences page ────────────────────────────────────
    "seq.header.title": "Smith · Sequences",
    "seq.header.subtitle": "{n} cadencias · {active} inscripciones activas · Cron 15 min",
    "seq.btn.refresh": "Actualizar",
    "seq.btn.run_now": "Ejecutar ahora",
    "seq.btn.run_now_title": "Disparar sweep manual — envía todos los pasos vencidos ahora",
    "seq.btn.new": "Nueva cadencia",
    "seq.list.title": "Cadencias",
    "seq.list.empty": "Aún no hay cadencias. Haz clic en Nueva cadencia para crear una.",
    "seq.card.day": "Día {n}",
    "seq.card.active_pill": "{n} activos",
    "seq.card.edit": "Editar",
    "seq.card.stats_active": "Activos",
    "seq.card.stats_completed": "Completos",
    "seq.card.stats_stopped": "Detenidos",
    "seq.enroll.title": "Inscripciones ({n})",
    "seq.enroll.empty_prefix": "Sin prospects inscritos. Ve a",
    "seq.enroll.empty_link": "Outreach AI",
    "seq.enroll.empty_suffix": ", elige un contacto y haz clic en Enroll.",
    "seq.enroll.step": "step {n}",
    "seq.enroll.next": "próx {at}",
    "seq.editor.title_new": "Nueva cadencia",
    "seq.editor.title_edit": "Editar cadencia",
    "seq.editor.name": "Nombre",
    "seq.editor.description": "Descripción",
    "seq.editor.steps": "Steps",
    "seq.editor.add_step": "Añadir",
    "seq.editor.days": "días",
    "seq.editor.stop_on_reply": "Detener automáticamente cuando el prospect responda",
    "seq.editor.cancel": "Cancelar",
    "seq.editor.save": "Guardar",
    "seq.toast.no_templates": "Debes crear al menos 1 plantilla en Outreach AI primero.",
    "seq.toast.name_min": "Nombre mínimo 2 caracteres.",
    "seq.toast.updated": "Cadencia actualizada",
    "seq.toast.created": "Cadencia creada",
    "seq.toast.deleted": "Eliminada",
    "seq.toast.stopped": "Detenida",
    "seq.toast.sweep_ok": "Sweep ejecutado: {sent} enviados, {stopped} detenidos, {picked} seleccionados",
    "seq.toast.load_failed": "Error al cargar cadencias",
    "seq.toast.save_failed": "Error al guardar",
    "seq.toast.delete_failed": "Error al eliminar",
    "seq.toast.sweep_failed": "Error en el sweep",
    "seq.confirm.delete": "¿Eliminar \"{name}\"? Solo funciona si no hay inscripciones activas.",
    "seq.confirm.stop": "¿Detener cadencia del prospect \"{name}\"?",
    "seq.confirm.run_now": "¿Ejecutar sweep manual ahora? Enviará emails reales a todos los enrollments elegibles (step vencido).",
    "seq.step.initial": "Inicial",
    "seq.step.follow": "Follow #{n}",
    "seq.step.last": "Última",
    "seq.status.active": "Activa",
    "seq.status.completed": "Completa",
    "seq.status.stopped_reply": "Respondió",
    "seq.status.stopped_manual": "Detenida",
    "seq.status.stopped_pipeline": "Won/Lost",

    // ── Iter319 · Delivery chip statuses (Resend) ───────────────────
    "so.deliv.queued": "Cola",
    "so.deliv.sent": "Enviado",
    "so.deliv.delivered": "Entregado",
    "so.deliv.opened": "Abierto",
    "so.deliv.clicked": "Clicado",
    "so.deliv.bounced": "Bounce",
    "so.deliv.complained": "Spam",
    "so.deliv.failed": "Falló",
    "so.deliv.sandbox": "Sandbox",
    "so.deliv.skipped": "Ignorado",
    "so.deliv.tooltip": "Estado Resend: {label}",

    "vs.geo.title": "Central Florida — Cobertura de Vehicle Security",
    "vs.geo.summary": "{cities} ciudades · {leads} leads",
    "vs.geo.critical_extra": "· {n} críticos",
    "vs.geo.refresh": "Actualizar",
    "vs.discovery.title": "Vehicle Security Discovery",
    "vs.discovery.subtitle": "Búsqueda OpenAI + cruce con CRM Smith",
    "vs.discovery.city": "Ciudad",
    "vs.discovery.state": "Estado",
    "vs.discovery.openai": "Búsqueda OpenAI",
    "vs.discovery.crm": "Cruzar CRM",
    "vs.discovery.run": "Ejecutar Discovery",
    "vs.discovery.running": "Descubriendo…",
    "vs.discovery.segments_hint": "Segmentos — elige 1-3 para mejor costo (cada = 1 web_search OpenAI)",
    "vs.discovery.copy_link": "Copiar enlace",
    "vs.discovery.copy_link_title": "Copia la URL con los segmentos + ciudad seleccionados para compartir con otro rep",
    "vs.discovery.link_copied": "Enlace con filtro copiado — pégalo para compartir",
    "vs.discovery.link_copy_failed": "No se pudo copiar. Cópialo desde la barra de URL.",
    "vs.leads.section_title": "Leads de Vehicle Security",
    "vs.leads.count": "· {shown}/{total} leads",
    "vs.leads.filter_prefix": "(filtro: {seg})",
    "vs.leads.radius_label": "· radio {miles}mi",
    "vs.leads.route_label": "· ruta optimizada",
    "vs.filter.tier_all": "Todos los tiers",
    "vs.filter.tier_critical": "🔥 Crítico (90+)",
    "vs.filter.tier_very_high": "🟠 Muy Alto (80-89)",
    "vs.filter.tier_high": "🟡 Alto (70-79)",
    "vs.filter.tier_medium": "🔵 Medio (60-69)",
    "vs.filter.tier_low": "⚪ Bajo (<60)",
    "vs.filter.flock_all": "Todos ALPR",
    "vs.filter.flock_only": "Solo con Flock",
    "vs.filter.flock_exclude": "Excluir Flock",
    "vs.tbl.property": "Propiedad",
    "vs.tbl.segment": "Segmento",
    "vs.tbl.score": "Score",
    "vs.tbl.signals": "Señales",
    "vs.tbl.opportunity": "Oportunidad Estimada",
    "vs.tbl.status": "Estado",
    "vs.tbl.actions": "Acciones",
    "vs.tbl.loading": "Cargando…",
    "vs.tbl.empty_run_discovery": "Aún sin leads — ejecuta Discovery arriba para comenzar.",
    "vs.tbl.empty_filters": "Ningún lead coincide con los filtros activos (tier / Flock / radio del mapa).",
    "vs.tbl.unknown_signals": "Desconocido",
    "vs.tbl.status_new": "Nuevo",
    "vs.tbl.stop_title": "Parada #{n} en la ruta optimizada",
    "vs.action.view_sources": "Ver Fuentes",
    "vs.action.open_details": "Abrir detalles",


    // ── Iter313 · Claire Widget ─────────────────────────────────────
    "claire.config_required": "Configuración necesaria",
    "claire.open_integrations": "Abrir Integraciones",
    "claire.close": "Cerrar",
    "claire.reset": "Reiniciar conversación",
    "claire.engine": "Motor",
    "claire.engine.deep": "Deep",
    "claire.engine.fast": "Fast",
    "claire.engine.deep_title": "Claude Sonnet 5 — razonamiento profundo (~3s)",
    "claire.engine.fast_title": "Perplexity Sonar Pro — búsqueda web, respuestas rápidas",
    "claire.typing": "Claire está escribiendo…",
    "claire.voice.hint": "Ajuste el texto si Claire escuchó mal, luego toque enviar.",
    "claire.voice.clear": "Limpiar",
    "claire.whatsapp": "Hablar con humano por WhatsApp",

    // ── Iter313 · Sidebar extras ────────────────────────────────────
    "sidebar.brand": "AgenteLead Pro",
    "sidebar.switch_persona": "Cambiar persona",
    "sidebar.loading": "Cargando…",
    "sidebar.personas_failed": "Fallo al cargar personas",
    "sidebar.logged_as": "Sesión iniciada como:",
    "sidebar.role": "Rol:",
    "sidebar.role_not_admin": "Su rol NO está en el grupo admin. Contacte a un super-admin para upgrade.",
    "sidebar.retry": "Reintentar",
    "sidebar.demo_seed_prompt": "Aún sin cuentas demo — cree las 5 por defecto en 1 clic:",
    "sidebar.demo_profiles": "Perfiles Demo",
    "sidebar.demo_open": "Abrir",
    "sidebar.demo_magic": "Magic",
    "sidebar.demo_manage": "Gestionar perfiles →",
    "sidebar.demo_seeded_toast": "Cuentas demo creadas",
    "sidebar.no_token_toast": "Token no retornado",
    "sidebar.new_24h": "Nuevos en las últimas 24h",

    // ── Iter313 · Header + Mobile drawer extras ─────────────────────
    "header.theme": "Tema",
    "header.language": "Idioma",
    "header.help": "Ayuda",
    "header.open_nav": "Abrir navegación",
    "header.open_menu": "Abrir menú",
    "mobile.close_menu": "Cerrar menú",
    "mobile.nav_label": "Navegación móvil",
    "mobile.scrapers_title": "Scrapers",
    "mobile.smith_title": "Smith Protective",
    "btn.go": "Ir",
    "vsm.exact_mode_hint": "Modo dirección exacta activo — geocoding vía Google. Sólo para uso interno del equipo comercial.",
    "vsm.city_mode_hint": "Modo Ciudad: pins agregados por barrio/ciudad. Las direcciones exactas se ocultan por defecto.",
    "settings.language.title": "Idioma / Language",
    "settings.language.description": "Elija el idioma que quiere usar en la app. La preferencia sincroniza entre dispositivos.",
    "settings.language.current": "Actual",
    "settings.language.preview": "Vista previa",
    "settings.language.unsaved": "Cambio pendiente — haga clic en Guardar para aplicar",
    "lang.saved": "Preferencia de idioma guardada",
    "lang.saved_local": "Guardado localmente (backend no disponible)",
    "lang.picker_open": "Cambiar idioma",
    "lang.picker_title": "Idioma",
    "lang.picker_settings": "Configuración de idioma",
    "btn.save": "Guardar",
    "btn.saving": "Guardando…",
    "signup.language_auto": "Detectamos su idioma del navegador: {lang}",
    "signup.language_change": "Cambiar",

    "sidebar.collapse": "Colapsar",
    "sidebar.expand": "Expandir menú",
    "sidebar.agency_dashboard": "Tablero de la Agencia",
    "sidebar.saas_configurator": "Auto Pilot",
    "sidebar.prospecting": "Lead Discovery",
    "sidebar.integrations": "Integraciones",
    "sidebar.kanban": "CRM Kanban",
    "sidebar.gov_kanban": "Gov · Obras Públicas",
    "sidebar.campaigns": "Campañas",
    "sidebar.insights": "Insights",
    "sidebar.roi": "ROI",
    "sidebar.marketing_apis": "APIs de Marketing",
    "sidebar.products": "Productos",
    "sidebar.webhooks": "Webhooks",
    "sidebar.free_sources": "Fuentes Gratuitas",
    "sidebar.activity_log": "Log de Actividades",
    "sidebar.affiliate_portal": "Portal de Afiliados",
    "sidebar.library": "Biblioteca",
    "sidebar.b2c_intent": "Intento B2C & Escucha Social",
    "sidebar.account": "Cuenta",
    "sidebar.support": "Soporte",
    "sidebar.auto_cruise": "Auto-Cruise",
    "sidebar.b2c_group": "B2C",
    "sidebar.funnel": "Embudo de Ventas",
    "sidebar.gov_group": "Gobierno",
    "sidebar.multi_state": "Captura Multi-Estado",
    "sidebar.no_website": "Leads Sin Sitio Web",
    "sidebar.sunbiz": "Conector Sunbiz",
    "sidebar.yelp": "Buscador Yelp",
    "sidebar.b2c_radar": "B2C Lead Radar",
    "sidebar.lead_gap": "Lead Gap Intelligence",
    "sidebar.instagram": "Instagram Scraper",
    "sidebar.linkedin": "LinkedIn Sales Nav",
    "sidebar.youtube": "YouTube Scraper",
    "sidebar.replies": "AI Replies Inbox",
    "sidebar.scrapers": "Scrapers",
    "sidebar.saas_education": "Educación SaaS",
    "sidebar.mobile_app": "App Móvil",
    "sidebar.app_marketplace": "Marketplace de Apps",
    "sidebar.billing": "Facturación",
    "sidebar.upgrade": "UPGRADE",
    "sidebar.public_works": "Procurement Scanner",
    "sidebar.gc_leaderboard": "Ranking de Contratistas",
    "sidebar.product_catalog": "Catálogo de Productos",
    "sidebar.leads_finder": "Leads Finder",
    "sidebar.leads_map": "Mapa de Leads",
    "sidebar.more": "Más",
    "sidebar.logout": "Salir",
    "sidebar.extended_dash": "Tablero Extendido",
    "header.back": "Volver a Cuentas de Prospección",
    "header.title": "Encuentra clientes potenciales locales, genera auditorías y envía al CRM",
    "header.add_manual": "Agregar negocio virtualmente",
    "search.business_placeholder": "Tipo de Negocio — ej.: Control de Plagas, Techos, HVAC…",
    "search.category_label": "Categoría",
    "search.category_all": "Todas",
    "search.location_placeholder": "ej.: Orlando FL 32801",
    "search.structured_show": "Elegir Ciudad · Estado · C.P.",
    "search.structured_hide": "Ocultar selector estructurado",
    "search.state_all": "Todos los estados",
    "search.city_all": "Todas las ciudades",
    "search.city_empty": "Sin ciudades guardadas aún",
    "search.zip_all": "Todos los C.P.",
    "search.zip_empty": "Sin C.P. guardados aún",
    "search.button": "Buscar",
    "search.unit_km": "KM",
    "search.unit_mi": "Millas",
    "search.status_all": "Todos",
    "search.status_open": "Abiertos ahora",
    "search.status_label": "Estado:",
    "search.types_builtin": "Tipos predeterminados",
    "search.types_custom": "Personalizados",
    "search.types_add_option": "+ Añadir nuevo tipo de negocio…",
    "search.types_add_placeholder": "ej.: Limpieza de Paneles Solares",
    "search.types_save": "Guardar",
    "search.types_delete": "Eliminar tipo personalizado",
    "search.type_too_short": "El nombre necesita al menos 2 caracteres",
    "search.type_added": "Añadido: {name}",
    "search.type_add_failed": "Error al añadir tipo de negocio",
    "search.type_deleted": "Eliminado: {name}",
    "search.type_delete_failed": "Error al eliminar",
    "search.type_delete_confirm": "¿Eliminar '{name}' de tus tipos de negocio? Los leads ya guardados mantendrán este nicho.",
    "search.advanced": "Avanzado",
    "search.adv_rating_min": "Valoración mín.",
    "search.adv_reviews_min": "Reseñas mín.",
    "search.adv_score_max": "Puntuación máx. (más caliente)",
    "search.adv_has_website": "¿Tiene sitio web?",
    "search.adv_any": "Cualquiera",
    "search.adv_yes": "Sí",
    "search.adv_no": "No",
    "search.adv_only_quente": "Solo CALIENTE (≤33)",
    "search.adv_quente_morno": "CALIENTE+TEMPLADO (≤66)",
    "search.adv_reset": "Restablecer filtros avanzados",
    "empty.title": "¡Descubre leads calientes a tu alrededor!",
    "empty.body": "Importa negocios reales de Google Maps — sin scrapers o hojas de cálculo. Guarda leads, genera auditorías y lanza automatizaciones de outreach. ¿Ya tienes un lead?",
    "empty.body_link": "Añade manualmente.",
    "lead.score_label": "Puntuación Digital",
    "lead.save_crm": "Guardar en el CRM",
    "lead.similar": "Similares",
    "lead.similar_tooltip": "Ver leads similares en tu CRM",
    "lead.sequence": "Iniciar Secuencia",
    "lead.sequence_tooltip": "Lanzar una secuencia de cold-email de varios pasos",
    "outreach.config_button": "Config Email",
    "lead.run_audit": "Ejecutar Auditoría",
    "lead.send_email": "Enviar Email",
    "lead.view_maps": "Ver en Maps",
    "lead.found": "leads encontrados",
    "lead.found_subtitle": "Ordenado por relevancia · Menor puntuación = lead más caliente",
    "lead.no_results": "No se encontraron leads. Prueba con otro tipo de negocio.",
    "status.open": "Abierto",
    "status.closed": "Cerrado",
    "status.operational": "Operativo",
    "toast.found": "{count} leads encontrados",
    "toast.found_filtered": "{count} leads encontrados ({hidden} ocultos por filtros)",
    "toast.saved": "¡Lead guardado en AgenteLead Pro!",
    "toast.search_failed": "Error en la búsqueda. Intenta de nuevo.",
    "toast.save_failed": "Error al guardar lead",
    "toast.audit_failed": "Error en la auditoría. Verifica tu clave LLM.",
    "toast.email_failed": "Error en la generación del email.",
    "toast.business_added": "¡Negocio añadido al CRM!",
    "toast.business_failed": "Error al añadir negocio",
    "dash.title": "Panel de la Agencia",
    "dash.subtitle": "Vista general · KPIs · Fuentes gratuitas de leads",
    "dash.refresh": "Actualizar",
    "dash.last_updated": "Última actualización",
    "dash.notifications": "Notificaciones",
    "dash.notif_empty": "No hay menciones HOT ahora — el silencio es buena señal.",
    "dash.notif_hot": "menciones HOT en las últimas 24h.",
    "dash.notif_see": "Ver en B2C Intent",
    "header.admin": "Admin · Biblioteca",
    "dash.kpi.saved": "Leads Guardados",
    "dash.kpi.saved_sub": "Total en el CRM",
    "dash.kpi.score": "Puntuación Digital Promedio",
    "dash.kpi.score_sub": "Menor = más oportunidad",
    "dash.kpi.hot": "Leads Calientes (CALIENTE)",
    "dash.kpi.hot_sub_zero": "—",
    "dash.kpi.activity": "Eventos de Actividad",
    "dash.kpi.activity_sub": "Últimas acciones registradas",
    "dash.distrib_title": "Distribución por temperatura",
    "dash.distrib_empty": "Aún no hay leads guardados. Ve a Prospecting y haz clic en Guardar en el CRM.",
    "dash.top_sectors": "Sectores principales en el CRM",
    "dash.activity_by_type": "Actividad por tipo",
    "dash.no_data": "Aún no hay datos.",
    "dash.no_records": "Aún no hay registros.",
    "dash.integrations_title": "🔌 Integración con Herramientas Existentes",
    "dash.integrations_subtitle": "herramientas — ejecuta para automatizar flujos",
    "dash.integrations_col_tool": "Herramienta",
    "dash.integrations_col_cat": "Categoría",
    "dash.integrations_col_desc": "Integración con el Dashboard",
    "dash.integrations_col_status": "Estado",
    "dash.integrations_col_action": "Acción",
    "dash.execute": "Ejecutar",
    "dash.free_sources_title": "💡 Fuentes Gratuitas de Generación de Leads",
    "dash.free_sources_subtitle_pre": "fuentes · Actualizado en",
    "dash.free_sources_curated": "Lista seleccionada",
    "dash.captured_title": "📦 Leads Captados por Tipo de Negocio",
    "dash.captured_subtitle": "Leads guardados agrupados por sector",
    "dash.captured_empty": "Aún no hay leads guardados. Usa la Prospecting para comenzar a captar.",
    "dash.captured_show": "Ver leads",
    "dash.captured_hide": "Ocultar leads",
    "dash.enrich_button": "Re-enriquecer",
    "dash.enrich_running": "Enriqueciendo…",
    "dash.enrich_button_tooltip": "Re-scrapea el sitio del lead para actualizar señales sociales y recalcular el score digital.",
    "dash.enrich_no_website_tooltip": "Sin sitio web registrado — imposible re-enriquecer.",
    "dash.enrich_last": "Enriquecido · {at}",
    "dash.enrich_pending": "Aún no enriquecido",
    "dash.enrich_no_site_label": "Sin sitio web",
    "dash.enrich_success": "{name} re-enriquecido · score {score} · {badge}",
    "dash.enrich_no_website": "{name} no tiene sitio web registrado",
    "dash.enrich_failed": "Fallo al enriquecer {name}: {reason}",
    "dash.enrich_not_found": "Lead no encontrado en la base de datos",
    "dash.activity_link_tooltip": "Ver eventos {label} en el Registro de Actividades",
    "dash.kpi_link_tooltip": "Haz clic para detallar",
    "dash.funnel_title": "Embudo de Conversión de Leads",
    "dash.funnel_subtitle": "Cada etapa muestra los eventos totales y la conversión respecto a la etapa anterior",
    "dash.funnel_step_search": "Buscar",
    "dash.funnel_step_save": "Guardar en el CRM",
    "dash.funnel_step_audit": "Ejecutar Auditoría",
    "dash.funnel_step_email": "Generar Email",
    "dash.funnel_step_enrich": "Re-enriquecer",
    "dash.funnel_conv_label": "vs anterior",
    "dash.funnel_drilldown_tooltip": "Abrir Registro de Actividades filtrado por {step}",
    "dash.funnel_empty": "Realiza búsquedas y guardados para llenar el embudo.",
    "fs.col_num": "#",
    "fs.col_name": "Nombre de la Fuente",
    "fs.col_type": "Tipo",
    "fs.col_credits": "Créditos / Mes",
    "fs.col_extracts": "Qué extrae",
    "fs.col_how": "Cómo usar",
    "fs.col_open": "Abrir",
    "fs.page_title": "Fuentes Gratuitas de Generación de Leads",
    "fs.page_subtitle": "Directorios públicos y APIs gratuitas para captar leads a coste cero",
    "kanban.title": "Kanban del CRM",
    "kanban.subtitle": "leads en el pipeline",
    "kanban.col.NEW": "Nuevo",
    "kanban.col.CONTACTED": "Contactado",
    "kanban.col.QUALIFIED": "Calificado",
    "kanban.col.PROPOSAL": "Propuesta",
    "kanban.col.WON": "Ganado",
    "kanban.col.LOST": "Perdido",
    "kanban.empty": "Vacío por ahora",
    "kanban.move_to": "Mover a",
    "kanban.dedup_label": "fusionados",
    "kanban.dedup_tooltip": "Este lead absorbió duplicados de re-guardados",
    "kanban.search_placeholder": "Buscar por el nombre de la empresa…",
    "kanban.filter_temp_all": "Todas las temperaturas",
    "kanban.filter_sector_all": "Todos los nichos",
    "kanban.no_results": "Ningún lead coincide con los filtros actuales.",
    "kanban.stale_tooltip": "Parado: {days} días en la misma columna",
    "kanban.status_age_tooltip": "En esta columna {days} días",
    "kanban.today": "hoy",
    "kanban.d_ago": "hace {days}d",
    "kanban.last_email_tooltip": "Último email hace {days}d · {count} toques en total",
    "kanban.silent_tooltip": "Está en estado contactado pero sin email registrado — ¿llegaste a enviar algo?",
    "kanban.silent_label": "sin email",
    "kanban.filter_silent": "Leads sin contacto",
    "kanban.filter_silent_tooltip": "Mostrar solo leads sin email registrado (columnas CONTACTED+)",
    "kanban.followup_tooltip": "Próximo seguimiento: {date}",
    "kanban.followup_overdue": "Seguimiento atrasado ({date})",
    "kanban.score_tooltip": "Lead Score: {score}/100 — menor = más caliente",
    "kanban.lookalike_seed_won": "Buscar similares a este Ganado",
    "kanban.drag_hint": "Arrastra una tarjeta a otra columna para actualizar el estado",
    "kanban.meta_check_label": "Ver Meta Ads",
    "kanban.meta_check_tooltip": "Haz clic para verificar si esta empresa está publicando anuncios en Facebook/Instagram ahora (caché 24h)",
    "kanban.meta_checking": "Buscando…",
    "kanban.meta_active": "{count} anuncios activos",
    "kanban.meta_active_tooltip": "Publicando {count} anuncios Meta ahora — compra tráfico, probablemente compre tu servicio",
    "kanban.meta_inactive": "sin anuncios",
    "kanban.meta_inactive_tooltip": "No se encontraron anuncios Meta activos en las últimas 24h",
    "kanban.delete_tooltip": "Quitar este lead del pipeline",
    "kanban.delete_confirm": "¿Quitar \"{name}\" del pipeline? No se puede deshacer.",
    "kanban.delete_ok": "\"{name}\" eliminado del pipeline",
    "kanban.delete_fail": "No se pudo eliminar este lead — intenta de nuevo.",
    "ldd.title": "Detalles del lead",
    "ldd.tab_overview": "Visión general",
    "ldd.tab_history": "Historial",
    "ldd.tab_notes": "Notas",
    "ldd.field_phone": "Teléfono",
    "ldd.field_email": "Email",
    "ldd.field_website": "Sitio",
    "ldd.field_address": "Dirección",
    "ldd.field_sector": "Nicho",
    "ldd.field_status": "Estado en el CRM",
    "ldd.field_score": "Score Digital",
    "ldd.field_followup": "Próximo seguimiento",
    "ldd.followup_clear": "Limpiar",
    "ldd.followup_save": "Guardar",
    "ldd.followup_saved": "Seguimiento actualizado",
    "ldd.followup_failed": "Falló al guardar el seguimiento",
    "ldd.notes_placeholder": "Escribe notas de reunión, objeciones, próximos pasos…",
    "ldd.notes_save": "Guardar notas",
    "ldd.notes_saved": "Notas guardadas",
    "ldd.history_empty": "Aún no hay actividad registrada para este lead.",
    "ldd.actions_title": "Acciones rápidas",
    "ldd.action_wa": "WhatsApp",
    "ldd.action_call": "Llamar",
    "ldd.action_email": "Correo electrónico",
    "ldd.action_audit": "Auditoría",
    "ldd.no_email": "Sin correo registrado",
    "ldd.no_phone": "Sin teléfono registrado",
    "wh.page_title": "Webhooks",
    "wh.page_subtitle": "Envía eventos en tiempo real a Zapier, Make, n8n o cualquier endpoint HTTP",
    "wh.add_title": "Registrar nuevo endpoint",
    "wh.add_button": "Registrar webhook",
    "wh.list_title": "Endpoints registrados",
    "wh.empty": "Ningún webhook aún — registra uno arriba.",
    "wh.col_url": "URL",
    "wh.col_events": "Eventos",
    "wh.col_state": "Estado",
    "wh.col_last": "Última entrega",
    "wh.col_actions": "Acciones",
    "wh.state_active": "Activo",
    "wh.state_paused": "Pausado",
    "wh.never": "Nunca entregado",
    "wh.deliveries": "entregas",
    "wh.test_tooltip": "Enviar payload de prueba",
    "wh.toggle_tooltip": "Activar/Desactivar",
    "wh.delete_tooltip": "Eliminar",
    "wh.created": "Webhook registrado: {url}",
    "wh.removed": "Webhook eliminado: {url}",
    "wh.create_failed": "Error al registrar webhook",
    "wh.remove_failed": "Error al eliminar webhook",
    "wh.toggle_failed": "Error al cambiar estado",
    "wh.test_failed": "Error en el envío de prueba",
    "wh.help_title": "Cómo consumir estos eventos",
    "wh.help_p1": "Cada endpoint registrado recibe un POST HTTPS por evento correspondiente, con cuerpo firmado:",
    "wh.help_p2": "Valida la firma contra tu secret almacenado para confirmar la autenticidad. Entregas fallidas son registradas pero (aún) no reintentadas automáticamente.",
    "bulk.modal_title": "Búsqueda Masiva en múltiples ciudades",
    "bulk.cities_label": "Ciudades (separadas por coma)",
    "bulk.cities_placeholder": "Orlando, FL, Miami, FL, Tampa, FL",
    "bulk.run_button": "Ejecutar búsqueda masiva",
    "bulk.auto_save": "Guardar automáticamente leads CALIENTES",
    "bulk.results_summary": "{total} encontrados · {dedup} después de dedup · {saved} auto-guardados",
    "bulk.open_modal": "Búsqueda masiva",
    "lead.score_tooltip": "Haz clic para ver por qué este lead recibió este puntaje",
    "score.tooltip": "Ver desglose del puntaje",
    "score.modal_title": "Desglose del Puntaje",
    "score.criteria_title": "Criterios",
    "score.opportunities_title": "Oportunidades de venta (señales ausentes)",
    "look.button": "AI Lookalike",
    "look.modal_title": "Buscador de Leads Similares (IA)",
    "look.modal_subtitle": "Encuentra más leads parecidos a tus {n} mejores CALIENTES/CUALIFICADOS",
    "look.locations_label": "Ciudades objetivo (una por línea)",
    "look.locations_placeholder": "Tampa, FL\nSaint Petersburg, FL",
    "look.locations_hint": "Deja en blanco para extraer automáticamente de las ciudades de los leads semilla.",
    "look.run_button": "Buscar similares (usa GPT)",
    "look.queries_count": "IA generó {n} estrategias de búsqueda",
    "look.locations_used": "Ciudades investigadas",
    "look.candidates_title": "Candidatos ({n})",
    "look.no_candidates": "Ningún candidato nuevo — intenta expandir las ciudades o añadir más leads CALIENTES como semilla.",
    "look.save_btn": "Guardar",
    "look.found": "{n} candidatos similares encontrados",
    "look.failed": "Búsqueda de similares fallida",
    "look.saved": "{name} guardado en el CRM",
    "look.already_saved": "Ya está en tu CRM (deduplicado)",
    "look.save_failed": "Error al guardar lead",
    "wa.button": "WhatsApp",
    "wa.title": "Enviar WhatsApp",
    "wa.body_label": "Mensaje",
    "wa.send_btn": "Enviar vía WhatsApp",
    "wa.sent": "Enviado a {name}",
    "wa.failed_short": "Error al enviar — ver detalles",
    "wa.queued": "En cola · sid …{sid} · estado {status}",
    "wa.disclaimer": "Sandbox Twilio: el destinatario necesita primero enviar 'join <código>' a tu número sandbox para recibir mensajes. Para producción, registra tu número como WhatsApp Sender aprobado en Twilio.",
    "wa.no_phone": "Lead sin número de teléfono",
    "integ.status.connected": "Conectado",
    "integ.status.mocked": "Simulado",
    "integ.status.configure": "Configurar",
    "integ.page_title": "Integraciones",
    "integ.page_subtitle": "Conecta herramientas externas y automatiza flujos",
    "integ.error_title": "No se pudieron cargar las integraciones",
    "integ.execute_failed": "Error al ejecutar {name}",
    "integ.hero_title": "Conectable por diseño",
    "integ.hero_body": "AgenteLead Pro conversa con más de 50 herramientas en comunicación, automatización, CRM, prospección, marketing, pagos, documentos, analytics e IA. Conéctate una vez y el dato fluye en ambas direcciones.",
    "integ.kpi_total": "Total",
    "integ.kpi_connected": "Conectadas",
    "integ.kpi_configure": "Por configurar",
    "integ.search_placeholder": "Buscar integración por nombre, categoría o descripción…",
    "integ.cat_all": "Todas",
    "integ.cat_communication": "Comunicación",
    "integ.cat_automation": "Automatización",
    "integ.cat_crm": "CRM",
    "integ.cat_enrichment": "Prospección & Enriquecimiento",
    "integ.cat_marketing": "Marketing",
    "integ.cat_payments": "Pagos",
    "integ.cat_documents": "Documentos",
    "integ.cat_analytics": "Analytics",
    "integ.cat_ai": "IA",
    "integ.cat_count_apps": "apps",
    "integ.empty_filtered": "Ninguna integración coincide con los filtros actuales.",
    "integ.read_more": "Saber más",
    "integ.run": "Ejecutar",
    "integ.connect": "Conectar",
    "integ.update": "Actualizar",
    "cfg.title_connect": "Conectar {name}",
    "cfg.title_update": "Actualizar {name}",
    "cfg.already_connected": "Ya conectado",
    "cfg.current_key": "Clave actual",
    "cfg.where_to_get": "Obtén tus credenciales en",
    "cfg.field_api_key": "API key / token",
    "cfg.placeholder_keep": "Déjalo vacío para mantener la clave actual",
    "cfg.never_displayed": "Nunca mostramos tu clave nuevamente — solo la versión enmascarada.",
    "cfg.update": "Actualizar",
    "cfg.connect": "Conectar",
    "cfg.disconnect": "Desconectar",
    "cfg.disconnect_confirm": "¿Desconectar {name}? Necesitarás reconfigurar la API key para reconectar.",
    "cfg.disconnected": "{name} desconectado",
    "cfg.saved": "{name} conectado con éxito",
    "cfg.save_failed": "Error al guardar credenciales",
    "mkt.title": "App Marketplace",
    "mkt.subtitle": "Escalera curada de 3 niveles — Esenciales → Diferenciales → Avanzados",
    "mkt.error_title": "No se pudo cargar el marketplace",
    "mkt.eyebrow": "Escalera de integraciones en 3 niveles",
    "mkt.hero_title": "Tu stack de prospección a un clic de distancia.",
    "mkt.hero_body": "Mapeamos las 22 integraciones que convierten a AgenteLead Pro de MVP a competidor de Clay/Apollo. Elige tu nivel, haz clic en Instalar y te guiamos por las credenciales en segundos.",
    "mkt.kpi_total": "Total de apps",
    "mkt.kpi_connected": "Conectados",
    "mkt.kpi_to_configure": "A configurar",
    "mkt.search_placeholder": "Buscar en todas las apps del marketplace…",
    "mkt.tier_all": "Todos los niveles",
    "mkt.tier_essentials_short": "Esenciales",
    "mkt.tier_differentials_short": "Diferenciales",
    "mkt.tier_advanced_short": "Avanzados",
    "mkt.tier_connected": "conectados",
    "mkt.tier_pending": "pendientes",
    "mkt.empty_filtered": "Ninguna app coincide con los filtros actuales.",
    "mkt.install": "Instalar",
    "mkt.installed": "Instalado",
    "mkt.coming_soon": "Próximamente",
    "mkt.status_coming_soon": "Próximamente",
    "tour.skip": "Saltar tour",
    "tour.next": "Siguiente",
    "tour.back": "Volver",
    "tour.done": "Entendido",
    "tour.restart": "Reabrir tour",
    "tour.step_label": "Paso {current} de {total}",
    "tour.s1.title": "Bienvenido a AgenteLead Pro",
    "tour.s1.body": "Un recorrido de 60 segundos mostrando cómo encontrar leads B2B locales, calificarlos con IA y ejecutar abordaje multicanal, todo dentro de una sola app.",
    "tour.s1.b1": "Búsqueda en Google Maps sin copiar-pegar ni extensión externa",
    "tour.s1.b2": "Score, auditoría y correo personalizado por GPT en cada lead",
    "tour.s1.b3": "Pipeline visual con WhatsApp, seguimiento e historial en el CRM Kanban",
    "tour.s2.title": "1. Prospección por nicho + ciudad",
    "tour.s2.body": "Abre Prospección, elige el nicho (Roofing, HVAC, Plumbing…) y la ciudad. La plataforma consulta Google Maps en vivo y trae cada negocio ya con score, badge, teléfono, sitio web y dirección.",
    "tour.s2.b1": "Bulk Search en varias ciudades a la vez",
    "tour.s2.b2": "Auto-guardar de leads CALIENTE directo en tu CRM",
    "tour.s2.b3": "Deduplicación automática — el mismo negocio nunca aparece dos veces",
    "tour.s2.cta": "Abrir Prospección",
    "tour.s3.title": "2. Puntaje y Auditoría con IA",
    "tour.s3.body": "Cada lead recibe un Puntaje Digital (cuanto MENOR, más CALIENTE, mayor oportunidad de venta). Haz clic en \"Run Audit\" y el GPT genera un análisis del sitio web en 6 secciones. En \"Send Email\", la IA escribe un outreach personalizado citando calificación, reseñas y detalles del sitio web.",
    "tour.s3.b1": "CALIENTE 0-33 · TEMPLADO 34-66 · FRÍO 67-100",
    "tour.s3.b2": "Auditoría GPT cubre Web, SEO Local, Social, Reseñas, Oportunidades y Pitch",
    "tour.s3.b3": "AI Lookalike: convierte un cliente Ganado en 5 otros parecidos a él",
    "tour.s4.title": "3. Pipeline en el CRM Kanban",
    "tour.s4.body": "Leads guardados van al Kanban. Arrastra entre Nuevo → Contactado → Calificado → Propuesta → Ganado/Perdido. Haz clic en la tarjeta para abrir el panel lateral con historial, notas y próximo seguimiento.",
    "tour.s4.b1": "Acciones rápidas: WhatsApp · Llamar · Correo — un clic",
    "tour.s4.b2": "Alerta visual en tarjetas detenidas por más de 7 días en la misma columna",
    "tour.s4.b3": "Búsqueda por nombre, filtro por temperatura o nicho en la parte superior del tablero",
    "tour.s4.cta": "Abrir CRM Kanban",
    "tour.s5.title": "Listo para volar 🚀",
    "tour.s5.body": "Sigue tu embudo, conversión y ROI en tiempo real en el Dashboard de la Agencia. Puedes reabrir este tour en cualquier momento desde el botón en la barra lateral.",
    "tour.s5.b1": "Embudo de Conversión de Leads con KPIs clicables",
    "tour.s5.b2": "Webhooks se activan en cada evento clave (guardar, cambio de estado, auditoría, WhatsApp)",
    "tour.s5.b3": "Log de Actividades con drill-down en un clic",
    "tour.s5.cta": "Ir al Dashboard",
    "camp.greeting": "Hola, Reach Soul!",
    "camp.trial_left": "Quedan 14 días de tu prueba Premium",
    "camp.view_plans": "Ver planes",
    "camp.nav_title": "Campañas",
    "camp.nav_subtitle": "Email marketing para los leads de tu CRM",
    "camp.cta_primary": "Empezar gratis",
    "camp.cta_pricing": "Ver precios",
    "camp.cta_hint": "Gratis durante la prueba",
    "camp.hero_eyebrow": "Email marketing",
    "camp.hero_title": "Envia campañas de email que generan clics",
    "camp.hero_body": "Marketing y ventas en el mismo lugar. Crea correos bonitos, automatiza el mensaje correcto en el momento adecuado y convierte respuestas en pipeline, sin salir de tu CRM.",
    "camp.hero_button_label": "Abrir auditoría",
    "camp.b1_title": "Crea correos impecables",
    "camp.b1_body": "Elige entre plantillas profesionales y personalizables y monta campañas con tu marca en minutos con un editor de arrastrar y soltar.",
    "camp.b2_title": "Nutrír tus contactos",
    "camp.b2_body": "Dispara automatizaciones para que el mensaje correcto llegue en el momento justo — basado en el puntaje del lead, cambio de estado o señales del sitio.",
    "camp.b3_title": "Aumenta el rendimiento",
    "camp.b3_body": "Ve aperturas, clics y conversiones en tiempo real y compara campañas lado a lado en informes listos.",
    "camp.video_label": "Demo en vivo",
    "camp.video_demo": "En producción, el video demo se abriría aquí.",
    "camp.reasons_title": "Más razones para usar Campañas",
    "camp.reasons_subtitle": "Todo el trabajo pesado dentro de AgenteLead Pro.",
    "camp.r1": "Sin importar/exportar contactos — tu CRM es la fuente de la verdad.",
    "camp.r2": "Plantillas modernas y editor de arrastrar y soltar — sin necesidad de HTML.",
    "camp.r3": "El compromiso vuelve automáticamente al equipo de ventas — todos ven quién está caliente.",
    "camp.r4": "Comienza a comprometer leads en pocos pasos — sin asistente de configuración.",
    "camp.list_title": "Tus campañas",
    "camp.list_subtitle": "Borradores y envíos programados",
    "camp.count_label": "campañas",
    "camp.empty": "Aún ninguna campaña — el primer borrador está a un clic.",
    "camp.draft_name": "Campaña sin título · {date}",
    "camp.draft_subject": "Un mensaje rápido de AgenteLead Pro",
    "camp.draft_created": "Borrador creado: {name}",
    "camp.draft_failed": "Error al crear borrador",
    "camp.col_subject": "Asunto",
    "camp.col_recipients": "destinatarios",
    "camp.action_edit": "Editar",
    "camp.action_assign": "Asignar leads",
    "camp.edit_hint": "Abre el editor para refinar — próximamente",
    "camp.final_title": "¿Listo para convertir leads en clics?",
    "camp.final_body": "Crea un borrador ahora y nosotros ya lo llenamos con tus mejores leads CALIENTE.",
    "ins.greeting": "¡Hola, Reach Soul!",
    "ins.trial_left": "Quedan 14 días de tu prueba Premium",
    "ins.view_plans": "Ver planes",
    "ins.title": "Insights",
    "ins.search_placeholder": "Buscar dashboards, metas, informes…",
    "ins.notifications": "Notificaciones",
    "ins.avatar_tooltip": "Accede a configuraciones y herramientas — todas las opciones de tu cuenta están en el menú del avatar.",
    "ins.section_dashboards": "Dashboards",
    "ins.section_goals": "Metas",
    "ins.section_reports": "Informes",
    "ins.my_dashboards": "Mis dashboards",
    "ins.my_goals": "Mis metas",
    "ins.my_reports": "Mis informes",
    "ins.no_dashboards": "Aún no hay dashboards",
    "ins.no_goals": "Aún no hay metas",
    "ins.no_reports": "Aún no hay informes",
    "ins.eyebrow": "Analytics en tiempo real",
    "ins.hero_title": "Identifica oportunidades de crecimiento. Actúa.",
    "ins.hero_body": "Configura tu dashboard personalizable. Sigue los datos de AgenteLead relacionados con tus actividades de ventas. Toma decisiones informadas en el momento adecuado.",
    "ins.cta_create": "Crear dashboard",
    "ins.cta_ai": "Generar informe (IA)",
    "ins.cta_video": "Ver video (0:35)",
    "ins.video_demo": "En producción, el video demo se abriría aquí.",
    "ins.generating_ai": "Generación de informe por IA en cola — te avisaremos cuando esté listo.",
    "ins.chart_sectors": "Leads por nicho",
    "ins.chart_temperature": "Mezcla por temperatura",
    "ins.chart_actions": "Actividad por acción",
    "ins.chart_realtime": "en vivo",
    "ins.kpi_saved": "Leads guardados",
    "ins.kpi_saved_drill": "Abrir Kanban",
    "ins.kpi_avg_score": "Puntaje medio",
    "ins.kpi_avg_drill": "Ver leads puntuados",
    "ins.kpi_quente": "CALIENTE",
    "ins.kpi_quente_drill": "Ver solo leads CALIENTE",
    "ins.kpi_activity": "Eventos de actividad",
    "ins.kpi_activity_drill": "Abrir registro de actividad",
    "ins.last_updated": "Actualizado",
    "ins.refresh_now": "Actualizar ahora",
    "ins.refreshed": "Insights actualizados",
    "ins.extra_title": "Vistas estratégicas",
    "ins.extra_subtitle": "Últimos 30 días · auto-refresh",
    "ins.funnel_title": "Embudo del pipeline de ventas",
    "ins.source_title": "Leads por origen",
    "ins.gauge_no_goal_title": "Seguimiento de objetivo",
    "ins.gauge_of_target": "del objetivo {target}",
    "ins.gauge_metric": "Métrica",
    "ins.gauge_no_goal": "Crea un objetivo para ver el progreso aquí.",
    "ins.timeline_title": "Leads vs actividad (30d)",
    "ins.timeline_badge": "tendencia",
    "ins.timeline_leads": "Leads capturados",
    "ins.timeline_activity": "Eventos de actividad",
    "ins.efficiency_title": "Eficiencia por acción",
    "ins.efficiency_events": "Eventos",
    "ins.efficiency_qualified": "Movidos a QUALIFIED+",
    "ins.efficiency_legend": "Más barra verde = acciones que más mueven el indicador de conversión.",
    "ins.heatmap_title": "Mapa de calor Sector × Temperatura",
    "ins.heatmap_empty": "Aún sin datos de sector — guarda algunos leads para poblar.",
    "ins.heatmap_legend": "Célula más oscura = bucket más denso. Identifica sectores calientes en segundos.",
    "ins.report_generated": "Informe de IA generado",
    "ins.report_failed": "Error al generar informe de IA",
    "ins.report_deleted": "Informe eliminado",
    "ins.cta_goal": "Nuevo objetivo",
    "ins.dash_modal_title": "Crear dashboard",
    "ins.dash_field_name": "Nombre",
    "ins.dash_field_desc": "Descripción",
    "ins.dash_placeholder_name": "ej.: Florida — Pipeline de Roofing",
    "ins.dash_placeholder_desc": "Opcional. ¿Qué sigue este dashboard?",
    "ins.dash_save": "Crear",
    "ins.dash_name_required": "El nombre del dashboard es obligatorio",
    "ins.dash_created": "Dashboard '{name}' creado",
    "ins.dash_failed": "Operación fallida",
    "ins.dash_deleted": "Dashboard eliminado",
    "ins.dash_delete_confirm": "¿Eliminar el dashboard '{name}'?",
    "ins.goal_modal_title": "Crear objetivo",
    "ins.goal_field_name": "Nombre",
    "ins.goal_field_metric": "Métrica",
    "ins.goal_field_target": "Meta",
    "ins.goal_placeholder_name": "ej.: 200 leads guardados en abril",
    "ins.goal_save": "Crear",
    "ins.goal_name_required": "El nombre del objetivo es obligatorio",
    "ins.goal_created": "Objetivo '{name}' creado",
    "ins.goal_failed": "Error al crear objetivo",
    "ins.goal_m_saved": "Leads guardados",
    "ins.goal_m_quente": "Leads CALIENTE",
    "ins.goal_m_activity": "Eventos de actividad",
    "ins.goal_m_avg": "Puntuación media",
    "ins.ai_report_title": "Informe de IA de Insights",
    "ins.ai_wins": "Victorias",
    "ins.ai_risks": "Riesgos",
    "ins.ai_actions": "Próximas acciones",
    "common.cancel": "Cancelar",
    "fs.page_title_v2": "Settings · Data Sources",
    "fs.page_subtitle_v2": "Gestiona tus fuentes de datos · Elige un playbook · Ejecuta el Motor de Prospección",
    "fs.view_dashboard": "Ver en el Dashboard",
    "fs.cta_engine": "Ejecutar Motor de Prospección",
    "fs.error_title": "No se pudieron cargar las fuentes",
    "fs.curated_count": "fuentes curadas, actualizadas semanalmente",
    "fs.hero_eyebrow": "Gratis + Freemium",
    "fs.hero_title": "De \"quiero leads\" a \"tengo una lista organizada y lista para la acción\" — sin 5 herramientas pagas.",
    "fs.hero_body": "Curamos las mejores fuentes free / freemium de leads B2B, etiquetamos por dificultad, costo y tipo de dato, y conectamos cada una a nuestro Motor de Prospección. Elige una fuente o playbook abajo y nos encargamos de la deduplicación, puntuación y enrutamiento a tu CRM.",
    "fs.recommended_title": "Recomendado para ti",
    "fs.tag_recommended": "Selección top",
    "fs.search_placeholder": "Buscar por nombre, tipo o tipo de dato…",
    "fs.group_all": "Todas las categorías",
    "fs.group_directory": "Directorios públicos",
    "fs.group_email": "Email finders",
    "fs.group_scraper": "Scrapers / Extensiones",
    "fs.group_b2b": "Bases B2B",
    "fs.cost_any": "Cualquier costo",
    "fs.cost_free": "Gratis",
    "fs.cost_freemium": "Freemium",
    "fs.cost_credits": "Créditos",
    "fs.diff_any": "Cualquier dificultad",
    "fs.diff_beginner": "Principiante",
    "fs.diff_intermediate": "Intermedio",
    "fs.diff_advanced": "Avanzado",
    "fs.filter_clear": "Limpiar filtros",
    "fs.sources_count": "fuentes",
    "fs.empty_filtered": "Ninguna fuente corresponde a los filtros actuales.",
    "fs.card_credits": "Free tier",
    "fs.card_send_engine": "Enviar al Motor",
    "fs.tab_all": "Todas las fuentes",
    "fs.tab_general": "🏢 General Prospecting",
    "fs.tab_gov": "🏛️ Gov & Construcción",
    "fs.open_in_app": "Abrir en la app",
    "fs.credits_internal": "Usa Créditos AgenteLead (motor integrado)",
    "fs.credits_external": "Usa TUS créditos en la plataforma externa",
    "fs.card_open": "Abrir fuente",
    "fs.playbooks_title": "Playbooks de Prospección",
    "fs.playbooks_subtitle": "Flujos listos que eligen fuentes, parámetros y salidas para los objetivos más comunes.",
    "fs.pb1_title": "Encontrar B2B locales en mi ciudad",
    "fs.pb1_body": "Empresas de Roofing, HVAC, Construcción cerca de una ciudad — directo de Google Maps + BBB + Yellow Pages, deduplicadas y con puntuación.",
    "fs.pb2_title": "Validar correos de una lista antigua",
    "fs.pb2_body": "Pasa tu lista de contactos por Hunter / Prospeo / Snov para quedarte solo con correos verificados antes del envío.",
    "fs.pb3_title": "Encontrar decisores en construcción",
    "fs.pb3_body": "Usa Apollo + Lusha + BBB para llegar a los dueños, GMs y Directores de Marketing de constructoras.",
    "fs.pb4_title": "Lista bulk con alta evaluación",
    "fs.pb4_body": "Obtén empresas HVAC/Plumbing 4★+ con 50+ reviews — leads de alta credibilidad listos para cold outreach.",
    "fs.pb_recommended_sources": "Fuentes recomendadas",
    "fs.pb_run": "Ejecutar playbook",
    "fs.faq_title": "FAQ & soporte",
    "fs.faq1_q": "¿Necesito instalar algo para usar estas fuentes?",
    "fs.faq1_a": "No. La mayoría de las fuentes funcionan directamente dentro del Motor de Prospección. Algunos scrapers (Web Scraper, Octoparse) requieren extensión Chrome free — solo avisamos cuando sea relevante.",
    "fs.faq2_q": "¿El motor hace deduplicación entre fuentes?",
    "fs.faq2_a": "Sí. Deduplicamos por teléfono, dominio del sitio normalizado y place_id. Al guardar un lead que ya existe, incrementamos el contador dedup_hits en lugar de duplicar.",
    "fs.faq3_q": "¿Los leads van a mi CRM en el momento que ejecuto el motor?",
    "fs.faq3_a": "Solo si eliges 'Añadir al CRM' en el último paso del asistente. También se puede exportar CSV o popular una campaña sin guardar en el CRM.",
    "fs.faq4_q": "¿Cuál es la diferencia entre el Hub y la prospección directa?",
    "fs.faq4_a": "Prospeción directa (la barra de búsqueda) es rápida — una fuente a la vez. Hub + Motor son ideales cuando quieres combinar varias fuentes, seguir un playbook y enrutar la salida a un destino específico.",
    "fs.final_cta_title": "¿Listo para llenar tu pipeline?",
    "fs.final_cta_body": "Un asistente, cinco pasos, tu CRM poblado de leads calificados. Adiós malabarismo de hojas de cálculo.",
    "wiz.title": "Motor de Prospección",
    "wiz.next": "Siguiente",
    "wiz.back": "Volver",
    "wiz.finish": "Concluir",
    "wiz.step_label": "Paso {current} de {total}",
    "wiz.error_fetch": "Falla en la búsqueda. Intenta de nuevo.",
    "wiz.success_crm": "{count} leads guardados en tu CRM Kanban",
    "wiz.success_campaign": "Borrador de campaña creado con esos leads",
    "wiz.success_csv": "CSV con {count} leads descargado",
    "wiz.campaign_name": "Prospectos {type} · {loc}",
    "wiz.campaign_subject": "Un mensaje rápido para empresas de {type}",
    "wiz.s0_title": "¿Cuál es tu objetivo de prospección?",
    "wiz.s0_subtitle": "Elige un objetivo — preconfiguramos fuentes y parámetros para ti.",
    "wiz.s0_local_title": "Encontrar empresas B2B locales",
    "wiz.s0_local_body": "Roofing, HVAC, Plumbing etc. cerca de una ciudad",
    "wiz.s0_validate_title": "Validar correos electrónicos",
    "wiz.s0_validate_body": "Verificar una lista antes del outreach",
    "wiz.s0_decision_title": "Encontrar decisores",
    "wiz.s0_decision_body": "Propietarios, GMs, Directores de Marketing",
    "wiz.s0_bulk_title": "Lista bulk de alta evaluación",
    "wiz.s0_bulk_body": "Empresas top-rated con muchas reseñas",
    "wiz.s0_custom_title": "Personalizado",
    "wiz.s0_custom_body": "Montar desde cero",
    "wiz.s1_title": "Elige las fuentes recomendadas",
    "wiz.s1_subtitle": "Combina varias fuentes para más cobertura. Deduplicamos automáticamente.",
    "wiz.s1_selected": "seleccionadas",
    "wiz.s2_title": "Parámetros de búsqueda",
    "wiz.s2_subtitle": "Indica al motor qué tipo de negocio y dónde buscar.",
    "wiz.s2_business": "Tipo de negocio",
    "wiz.s2_business_placeholder": "ej.: Roofing, HVAC, Control de plagas",
    "wiz.s2_location": "Ubicación",
    "wiz.s2_radius": "Radio",
    "wiz.s2_score": "Filtro por temperatura",
    "wiz.s2_score_any": "Cualquier temperatura",
    "wiz.s2_score_quente_morno": "CALIENTE + TEMPLADO (≤66)",
    "wiz.s2_score_quente": "Solo CALIENTE (≤33)",
    "wiz.s3_title": "Revisar & ejecutar",
    "wiz.s3_subtitle": "Vamos a consultar Google Maps, deduplicar y puntuar cada lead.",
    "wiz.s3_run": "Ejecutar motor",
    "wiz.s3_running": "Buscando, deduplicando y calificando leads…",
    "wiz.s3_done": "{count} leads calificados listos",
    "wiz.s3_source": "Fuente",
    "wiz.s4_title": "Elegir salida",
    "wiz.s4_subtitle": "¿A dónde enviar los {count} leads?",
    "wiz.s4_crm_title": "Agregar al CRM Kanban",
    "wiz.s4_crm_body": "Cada lead va a la columna 'Nuevo' con puntuación y auditoría listas",
    "wiz.s4_campaign_title": "Rellenar campaña de correo electrónico",
    "wiz.s4_campaign_body": "Crea un borrador relleno con estos leads",
    "wiz.s4_csv_title": "Descargar CSV",
    "wiz.s4_csv_body": "Hoja de cálculo con nombre, teléfono, sitio web, puntuación, etc.",
    "prod.greeting": "Hola, Reach Soul!",
    "prod.trial_left": "Quedan 14 días de tu prueba Premium",
    "prod.view_plans": "Ver planes",
    "prod.title": "Productos",
    "prod.search_placeholder": "Buscar en AgenteLead",
    "prod.add_tooltip": "Añadir nuevo producto",
    "prod.add_product": "Añadir producto",
    "prod.ai_tooltip": "Acción rápida con IA — llena productos a partir de tus mejores deals",
    "prod.help": "Ayuda",
    "prod.notifications": "Notificaciones",
    "prod.nav_marketplace": "Marketplace",
    "prod.nav_automations": "Automatizaciones",
    "prod.nav_assignment": "Asignación automática",
    "prod.nav_sequences": "Secuencias",
    "prod.nav_documents": "Documentos",
    "prod.nav_import": "Importar datos",
    "prod.nav_export": "Exportar datos",
    "prod.nav_restore": "Restaurar datos",
    "prod.products_count": "productos",
    "prod.empty_title": "No se encontraron productos",
    "prod.empty_subtitle": "Intenta restablecer el filtro o ver todos los productos.",
    "prod.reset_filter": "Restablecer filtro",
    "prod.view_all": "Ver todos los productos",
    "prod.col_name": "Producto",
    "prod.col_owner": "Responsable",
    "prod.col_sku": "SKU",
    "prod.draft_name": "Nuevo producto · {date}",
    "prod.created": "Producto creado: {name}",
    "prod.create_failed": "Error al crear producto",

    // ── Centro de Tutoriales ("Aprende a usar") ────────────────────
    "tut.nav.title": "Aprende a usar",
    "tut.page.title": "Aprende a usar AgenteLead Pro",
    "tut.page.subtitle": "Tutoriales cortos para cada bloque de la app.",
    "tut.search.placeholder": "Buscar por herramienta o tarea…",
    "tut.filter.all": "Todos",
    "tut.filter.discovery": "Discovery",
    "tut.filter.outreach": "Outreach",
    "tut.filter.pipeline": "Pipeline",
    "tut.filter.analytics": "Analytics",
    "tut.filter.specialty": "Especializado",
    "tut.filter.onboarding": "Empieza aquí",
    "tut.status.not_started": "No iniciado",
    "tut.status.in_progress": "En curso",
    "tut.status.completed": "Completado",
    "tut.card.duration": "{sec}s",
    "tut.card.go": "Abrir herramienta",
    "tut.card.watch": "Ver tutorial",
    "tut.card.prereq": "Prerrequisitos",
    "tut.section.objective": "Objetivo",
    "tut.section.when": "Cuándo usar",
    "tut.section.prep": "Preparación",
    "tut.section.demo": "Demostración",
    "tut.section.result": "Resultado",
    "tut.section.next": "Próxima acción",
    "tut.section.steps": "Paso a paso",
    "tut.section.success": "Cómo saber que funcionó",
    "tut.section.errors": "Errores comunes",
    "tut.section.transcript": "Transcripción",
    "tut.mark.done": "Marcar como completado",
    "tut.mark.undo": "Deshacer completado",
    "tut.feedback.q": "¿Este tutorial te ayudó?",
    "tut.feedback.yes": "Sí",
    "tut.feedback.no": "No",
    "tut.feedback.thanks": "¡Gracias por tu feedback!",
    "tut.production.status": "Estado de producción",
    "tut.production.script_ready": "Guion listo — video pendiente",
    "tut.production.in_production": "Video en producción",
    "tut.production.review": "En revisión",
    "tut.production.published": "Publicado",
    "tut.player.pending": "Video pendiente. Sigue el paso a paso ilustrado mientras tanto.",
    "tut.help.button": "Cómo usar",
    "tut.help.tooltip": "Ver un tutorial corto sobre este bloque",
    "tut.help.float": "Ayuda",
    "tut.recommended": "Ruta recomendada",
    "tut.start.here": "Empieza aquí",
    "tut.updated": "Última revisión",
  },
};
